/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core"
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = {
	[K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
	[SubKey in K]?: Maybe<T[SubKey]>
}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
	[SubKey in K]: Maybe<T[SubKey]>
}
export type MakeEmpty<
	T extends { [key: string]: unknown },
	K extends keyof T,
> = { [_ in K]?: never }
export type Incremental<T> =
	| T
	| {
			[P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
	  }
export type Hour = number & { readonly __brand: unique symbol }
export type Minute = number & { readonly __brand: unique symbol }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
	ID: { input: string; output: string }
	String: { input: string; output: string }
	Boolean: { input: boolean; output: boolean }
	Int: { input: number; output: number }
	Float: { input: number; output: number }
	/** Date (isoformat) */
	Date: { input: string; output: string }
	/** Date with time (isoformat) */
	DateTime: { input: string; output: string }
	YearMonth: { input: string; output: string }
	join__FieldSet: { input: string; output: string }
	link__Import: { input: string; output: string }
}

/**
 * スクレイピング失敗店舗の Slack 通知を今すぐ投稿する。
 * 毎朝 7:00 の cron job (alert_salon_scraping_jobs_not_finished) が
 * #02_dev_salon_scraping_jobs_not_finished_notification に投稿しているものと同じ通知を、
 * 任意のタイミングで手動実行するための mutation。
 *
 * 通知内容・副作用は cron job と同一:
 * - 「API を叩いた日の 0:00 以降に salon_scraping_log がなく、ID/PASS エラーでもない」稼働中店舗
 *   (is_test_salon=false かつ skip_enqueueing_scraping=false) を失敗店舗として列挙する
 * - 前回通知 (midnight_scraping_not_finished_slack_message_logs の最新) と比較した増減を先頭に出す
 * - 投稿後、今回の失敗店舗 ID を midnight_scraping_not_finished_slack_message_logs に記録する
 *   (手動実行でも記録するため、次回の cron 通知はこの手動通知との増減を出す)
 *
 * - [error]
 *     - PERMISSION_DENIED: souhl_admin でないユーザーがアクセスした場合
 */
export type AlertSalonScrapingJobsNotFinishedInput = {
	/** true の場合、Slack 投稿と midnight_scraping_not_finished_slack_message_logs への記録を行わず、通知対象になる失敗店舗 ID だけを返す (投稿前の確認用)。false の場合は実際に投稿する。 */
	dryRun: Scalars["Boolean"]["input"]
}

/** alertSalonScrapingJobsNotFinished のレスポンス */
export type AlertSalonScrapingJobsNotFinishedResponse = {
	/** 通知対象 (スクレイピング失敗) になった店舗 ID (昇順)。dryRun=false なら Slack に投稿済み、dryRun=true なら投稿せずに算出した結果。失敗店舗がない場合は空配列 (dryRun=false のときは「なし」と投稿される)。 */
	salonIds: Array<Scalars["Int"]["output"]>
}

/**
 * 設備マッピング候補 (draft_data_source_equipment_mappings) を承認し、
 * data_source_equipment_mappings へ昇格させる。
 * スプレッドシートで「実行待ち」にした複数行をまとめて処理する運用のため draft ID を複数受け取り、
 * 1件ずつの結果を返す。1件がスキップされても他の draft の処理は続行する。
 * souhl_admin のみアクセス可能。
 * - [error]
 *     - PERMISSION_DENIED: souhl_admin でないユーザーがアクセスした場合
 *     - INVALID_ARGUMENT: draftIds が空、または重複した ID を含む場合
 */
export type ApproveDraftDataSourceEquipmentMappingsInput = {
	/** 承認する draft の ID 一覧 */
	draftIds: Array<Scalars["String"]["input"]>
}

export type ApproveDraftDataSourceEquipmentMappingsResponse = {
	/** リクエストした draft ID と同じ順序で返る */
	results: Array<DataSourceEquipmentMappingActionResult>
}

/**
 * スタッフマッピング候補 (draft_data_source_staff_mappings) を承認し、
 * data_source_staff_mappings へ昇格させる。
 * スプレッドシートで「実行待ち」にした複数行をまとめて処理する運用のため draft ID を複数受け取り、
 * 1件ずつの結果を返す。1件がスキップされても他の draft の処理は続行する。
 * souhl_admin のみアクセス可能。
 * - [error]
 *     - PERMISSION_DENIED: souhl_admin でないユーザーがアクセスした場合
 *     - INVALID_ARGUMENT: draftIds が空、または重複した ID を含む場合
 */
export type ApproveDraftDataSourceStaffMappingsInput = {
	/** 承認する draft の ID 一覧 */
	draftIds: Array<Scalars["String"]["input"]>
}

export type ApproveDraftDataSourceStaffMappingsResponse = {
	/** リクエストした draft ID と同じ順序で返る */
	results: Array<DataSourceStaffMappingActionResult>
}

export type ArchiveTaigaMilestoneInput = {
	id: Scalars["String"]["input"]
}

export type ArchiveTaigaMilestoneResponse = {
	milestone: TaigaMilestone
}

export type ArchiveTaigaNodeInput = {
	id: Scalars["String"]["input"]
}

export type ArchiveTaigaNodeResponse = {
	node: TaigaNode
}

export type ArchiveTaigaSheetInput = {
	id: Scalars["String"]["input"]
}

export type ArchiveTaigaSheetResponse = {
	sheet: TaigaSheet
}

/** 既存 Slack スレッドの紐づけ。thread_ts のみ保存し、Slack への投稿は行わない。 */
export type AttachTaigaSlackThreadInput = {
	/** Slack チャンネル ID */
	channelId: Scalars["String"]["input"]
	/** セッションに付与するメモ（省略可。空文字は null として保存） */
	memo?: InputMaybe<Scalars["String"]["input"]>
	/** 対象ノード ID（末端ノードのみ） */
	nodeId: Scalars["String"]["input"]
	/** 紐づける Slack スレッドの thread_ts */
	threadTs: Scalars["String"]["input"]
}

export type AttachTaigaSlackThreadResponse = {
	/** セッション情報が紐づけられた更新後のノード */
	node: TaigaNode
}

/** ドラフトメッセージの作成者種別 */
export type AuthorType =
	/** AI bot が自動作成したドラフト */
	| "AI_BOT"
	/** ユーザー（人間）が作成したドラフト */
	| "USER"

/**
 * bizdev module の souhl_admin サブグラフのヘルスチェック。
 * - [error]
 *     - PERMISSION_DENIED: souhl_admin でないユーザーがアクセスした場合
 */
export type BizdevHealthParam = {
	_dummy?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** bizdev module のヘルスチェックレスポンス */
export type BizdevHealthResponse = {
	/** サービスステータス（常に true） */
	ok: Scalars["Boolean"]["output"]
}

/**
 * 入金 settlement のステータスを一括更新する（souhl_admin のみ）。
 * pending -> invoice_in_progress、invoice_in_progress -> completed、invoice_in_progress -> carryover、invoice_in_progress -> pending の遷移に使用。
 * 対象 settlement を FOR UPDATE でロック。
 * - [error]
 *     - NOT_FOUND: settlementIds に存在しない ID が含まれる場合
 *     - BAD_REQUEST: ステータス遷移が不正な場合
 *     - BAD_REQUEST: isSettlementAmountKindPayout が false でない settlement が含まれる場合
 */
export type BulkUpdateInvoiceSettlementStatusesInput = {
	/** 更新対象の Settlement ID 一覧 */
	settlementIds: Array<Scalars["ID"]["input"]>
	/** 遷移先ステータス */
	targetStatus: SettlementStatus
}

/** bulkUpdateInvoiceSettlementStatuses のレスポンス */
export type BulkUpdateInvoiceSettlementStatusesResponse = {
	/** 更新された Settlement ID 一覧 */
	updatedSettlementIds: Array<Scalars["ID"]["output"]>
}

/**
 * 振込 settlement のステータスを一括更新する（souhl_admin のみ）。
 * pending -> payout_in_progress、payout_in_progress -> completed、payout_in_progress -> carryover、payout_in_progress -> pending の遷移に使用。
 * 対象 settlement を FOR UPDATE でロック。
 * - [error]
 *     - NOT_FOUND: settlementIds に存在しない ID が含まれる場合
 *     - BAD_REQUEST: ステータス遷移が不正な場合
 *     - BAD_REQUEST: isSettlementAmountKindPayout が true でない settlement が含まれる場合
 */
export type BulkUpdatePayoutSettlementStatusesInput = {
	/** 更新対象の Settlement ID 一覧 */
	settlementIds: Array<Scalars["ID"]["input"]>
	/** 遷移先ステータス */
	targetStatus: SettlementStatus
}

/** bulkUpdatePayoutSettlementStatuses のレスポンス */
export type BulkUpdatePayoutSettlementStatusesResponse = {
	/** 更新された Settlement ID 一覧 */
	updatedSettlementIds: Array<Scalars["ID"]["output"]>
}

/**
 * channelGroups + lineWorksGroups を一括登録する。未登録の lineGroupId は idp にも自動登録する。
 * 各 item に対して ChannelGroup + LineWorksGroup のペアを BulkUpsert する。
 * displayName は BulkUpsert で上書きされる（初回登録時のハードコード値を Chrome 拡張経由の値で更新する想定）。
 * registerTime は ChannelGroupService 内で clock.Now() により生成する。
 * - [error]
 *     - INTERNAL: idp BulkInsertLineGroups 呼び出しに失敗した場合（bizdev 側の upsert もスキップされる）
 */
export type BulkUpsertChannelGroupsAndLineWorksGroupsInput = {
	/** 一括登録する LINE グループ情報。lineGroupId が未登録の場合は idp にも登録する */
	items: Array<ChannelGroupLineWorksGroupInput>
}

/** bulkUpsertChannelGroupsAndLineWorksGroups のレスポンス */
export type BulkUpsertChannelGroupsAndLineWorksGroupsResponse = {
	/** upsert された件数 */
	upsertedCount: Scalars["Int"]["output"]
}

export type CancelPolicyTemplateType =
	| "MANUAL_ONLY"
	| "SK_CLINIC_ZERO_THREE_SEVEN"
	| "UENO_CLINIC"
	| "ZERO_FIVE"
	| "ZERO_ONE"
	| "ZERO_ONE_AND_SUBSCRIPTION_PAYMENT_FAILED"
	| "ZERO_THREE"
	| "ZERO_TWO"

/**
 * CancelType は、キャンセルのタイプを表す。
 *
 * <一般的なキャンセルタイプ>
 * - UNSPECIFIED: 不明
 * - NO_CONFIRMATION: 無断キャンセル
 * - PREVIOUS_DAY: 前日キャンセル
 * - ON_THE_DAY: 当日キャンセル
 * - MORE_THAN_TWO_DAYS_AGO: 2日以上前のキャンセル
 *     - 請求不可なキャンセルタイプ (is_claimable_cancel_type が False)
 *
 * - FROM_PREVIOUS_DAY_TO_TWO_DAYS_AGO: 前日から2日前のキャンセル
 * - MORE_THAN_THREE_DAYS_AGO: 3日以上前のキャンセル
 *     - 請求不可なキャンセルタイプ (is_claimable_cancel_type が False)
 *
 * - SUBSCRIPTION_PAYMENT_FAILED: サブスクリプション決済失敗
 *
 * <SKクリニック専用のキャンセルタイプ>
 * - SK_CLINIC_*: 各診療科・カウンセリング別のキャンセルタイプ
 */
export type CancelType =
	| "CLAIMING_CONVERSION_RECANCEL"
	| "FIVE_DAYS_AGO"
	| "FOUR_DAYS_AGO"
	| "FROM_PREVIOUS_DAY_TO_TWO_DAYS_AGO"
	| "MANUAL_INVOICE_PRICE_SETTING"
	| "MORE_THAN_FOUR_DAYS_AGO"
	| "MORE_THAN_SIX_DAYS_AGO"
	| "MORE_THAN_THREE_DAYS_AGO"
	| "MORE_THAN_TWO_DAYS_AGO"
	| "NO_CONFIRMATION"
	| "ON_THE_DAY"
	| "PREVIOUS_DAY"
	| "SK_CLINIC_COUNSELING_FROM_ON_THE_DAY_TO_SEVEN_DAYS_AGO"
	| "SK_CLINIC_COUNSELING_MORE_THAN_EIGHT_DAYS_AGO"
	| "SK_CLINIC_COUNSELING_UNSPECIFIED"
	| "SK_CLINIC_DENTAL_COUNSELING_FROM_ON_THE_DAY_TO_SEVEN_DAYS_AGO"
	| "SK_CLINIC_DENTAL_COUNSELING_MORE_THAN_EIGHT_DAYS_AGO"
	| "SK_CLINIC_DENTAL_COUNSELING_UNSPECIFIED"
	| "SK_CLINIC_DENTAL_FROM_FOUR_DAYS_AGO_TO_SEVEN_DAYS_AGO"
	| "SK_CLINIC_DENTAL_FROM_PREVIOUS_DAY_TO_THREE_DAYS_AGO"
	| "SK_CLINIC_DENTAL_MORE_THAN_EIGHT_DAYS_AGO"
	| "SK_CLINIC_DENTAL_ON_THE_DAY"
	| "SK_CLINIC_DENTAL_UNSPECIFIED"
	| "SK_CLINIC_DERMATOLOGY_COUNSELING_FROM_ON_THE_DAY_TO_SEVEN_DAYS_AGO"
	| "SK_CLINIC_DERMATOLOGY_COUNSELING_MORE_THAN_EIGHT_DAYS_AGO"
	| "SK_CLINIC_DERMATOLOGY_COUNSELING_UNSPECIFIED"
	| "SK_CLINIC_DERMATOLOGY_FROM_FOUR_DAYS_AGO_TO_SEVEN_DAYS_AGO"
	| "SK_CLINIC_DERMATOLOGY_FROM_PREVIOUS_DAY_TO_THREE_DAYS_AGO"
	| "SK_CLINIC_DERMATOLOGY_MORE_THAN_EIGHT_DAYS_AGO"
	| "SK_CLINIC_DERMATOLOGY_ON_THE_DAY"
	| "SK_CLINIC_DERMATOLOGY_UNSPECIFIED"
	| "SK_CLINIC_MANUAL_INVOICE_PRICE_SETTING"
	| "SK_CLINIC_SURGERY_COUNSELING_FROM_ON_THE_DAY_TO_SEVEN_DAYS_AGO"
	| "SK_CLINIC_SURGERY_COUNSELING_MORE_THAN_EIGHT_DAYS_AGO"
	| "SK_CLINIC_SURGERY_COUNSELING_UNSPECIFIED"
	| "SK_CLINIC_SURGERY_FROM_FOUR_DAYS_AGO_TO_SEVEN_DAYS_AGO"
	| "SK_CLINIC_SURGERY_FROM_PREVIOUS_DAY_TO_THREE_DAYS_AGO"
	| "SK_CLINIC_SURGERY_MORE_THAN_EIGHT_DAYS_AGO"
	| "SK_CLINIC_SURGERY_ON_THE_DAY"
	| "SK_CLINIC_SURGERY_UNSPECIFIED"
	| "SK_CLINIC_SURGICAL_FOLLOW_UP_FROM_ON_THE_DAY_TO_SEVEN_DAYS_AGO"
	| "SK_CLINIC_SURGICAL_FOLLOW_UP_MORE_THAN_EIGHT_DAYS_AGO"
	| "SK_CLINIC_SURGICAL_FOLLOW_UP_UNSPECIFIED"
	| "SK_CLINIC_UNKNOWN"
	| "SUBSCRIPTION_PAYMENT_FAILED"
	| "THREE_DAYS_AGO"
	| "TWO_DAYS_AGO"
	| "UENO_CLINIC_CONFIRMED_CANCEL_FAMILY_CONSULTATION"
	| "UENO_CLINIC_CONFIRMED_CANCEL_FEAR"
	| "UENO_CLINIC_CONFIRMED_CANCEL_PRICE"
	| "UENO_CLINIC_CONFIRMED_CANCEL_SCHEDULE"
	| "UENO_CLINIC_FAMILY_CONSULTATION"
	| "UENO_CLINIC_FEAR"
	| "UENO_CLINIC_OTHER"
	| "UENO_CLINIC_PRICE"
	| "UENO_CLINIC_SCHEDULE"
	| "UNSPECIFIED"

/** キャンセルタイプと表示用テキストの組み合わせ。 */
export type CancelTypeText = {
	/** キャンセルタイプ。 */
	cancelType: CancelType
	/** 表示用のテキスト。 */
	text: Scalars["String"]["output"]
}

/**
 * エラーが起きた際、ユーザー側で解決可能なエラーのときは
 * extensions.code でエラーコードを返し、message で human readable なエラーメッセージを返す。
 * その際、取り得るエラーコードがUserErrorCodeである。
 *
 * - フロントエンドにどんなエラーコード文字列が返りうるかを一覧で伝えるため、型定義をしているが、UserErrorCodeという型を返すAPI自体があるわけではない。
 */
export type CancyCompanyAdminSubgraphUserErrorCode =
	| "BAD_REQUEST"
	| "RESOURCE_EXHAUSTED"

export type CancyDataSummary = {
	thisMonth: CancyKpiPeriod
	total: CancyKpiPeriod
}

export type CancyKpiPeriod = {
	totalInvoiceAmount: Scalars["Int"]["output"]
	totalPaidPrice: Scalars["Int"]["output"]
	totalRereservationAmount: Scalars["Int"]["output"]
}

/** 一括登録する LINE グループの個別情報。 */
export type ChannelGroupLineWorksGroupInput = {
	/** LINE グループの表示名（Chrome 拡張経由で LINE Works API から取得した名前） */
	displayName: Scalars["String"]["input"]
	/** そのグループが DM（1:1 トーク）かどうか。判定できない場合は null（不明）。確定したもののみ true/false を送る。 */
	isDm?: InputMaybe<Scalars["Boolean"]["input"]>
	/** LINE グループの ID（idp line_groups.id に対応） */
	lineGroupId: Scalars["String"]["input"]
}

/** チャネルグループ（トークルーム）単位の申し送りメモ */
export type ChannelGroupMemo = {
	/** 作成者の slack_users.id */
	authorSlackUserId: Scalars["String"]["output"]
	/** 紐づくチャネルグループ ID（channel_groups.id） */
	channelGroupId: Scalars["String"]["output"]
	/** メモ ID (ULID) */
	id: Scalars["ID"]["output"]
	/** ピン留めフラグ（true = 一覧の最上部に固定・強調表示） */
	isPinned: Scalars["Boolean"]["output"]
	/** 登録時刻 (RFC3339) */
	registerTime: Scalars["DateTime"]["output"]
	/** メモ本文 */
	text: Scalars["String"]["output"]
}

/**
 * 指定 channelGroupId の active なメモ一覧を取得する（souhl_admin のみ）。
 * is_pinned DESC → register_time DESC でソートして返す。
 * - [error]
 *     - PERMISSION_DENIED: souhl_admin でないユーザーがアクセスした場合
 */
export type ChannelGroupMemosParam = {
	/** 対象のチャネルグループ ID（channel_groups.id） */
	channelGroupId: Scalars["String"]["input"]
}

/** channelGroupMemos Query のレスポンス */
export type ChannelGroupMemosResponse = {
	/** メモ一覧（is_pinned DESC → register_time DESC） */
	memos: Array<ChannelGroupMemo>
}

/**
 * cancel_id ごとの請求 reminder (claiming_cancel_fee_reminders) の現在状態。
 * 架電バッチが発信直前に「支払い済み・中止済みでないか」を確認する用途。
 * status が scheduled 以外、または next_scheduled_time が当日 (JST) でない /
 * 既に過ぎている場合、その cancel_id への sendClaimingCancelFeeReminderSoon は
 * INTERNAL で失敗する。
 */
export type ClaimingCancelFeeReminderStatus = {
	/** 請求 reminder の cancel_id */
	cancelId: Scalars["String"]["output"]
	/** 次回送付予定時刻 (JST) */
	nextScheduledTime: Scalars["DateTime"]["output"]
	/** reminder の status (scheduled / completed / paid / aborted 等) */
	status: Scalars["String"]["output"]
}

/**
 * タスクの「要アクション」状態を手動で解除する（souhl_admin のみ）。
 * active な task_reminder の last_outgoing_message_create_time を現在時刻にセットし、
 * NeedsAction() が false を返すようにする。
 * COMPLETED 状態のタスクに対して呼び出すと FAILED_PRECONDITION エラーを返す。
 * 催促スケジュールが存在しない場合や、既に要アクションでない場合は何もせず成功を返す。
 * - [error]
 *     - UNAUTHORIZED: ServiceToken の検証に失敗する場合
 *     - PERMISSION_DENIED: ServiceToken が SouhlAdmin 権限を持たない場合
 *     - NOT_FOUND: taskId のタスクが存在しない場合
 *     - FAILED_PRECONDITION: taskId のタスクが既に COMPLETED の場合
 */
export type ClearTaskNeedsActionInput = {
	/** 更新対象のタスク ID */
	taskId: Scalars["ID"]["input"]
}

/** clearTaskNeedsAction のレスポンス */
export type ClearTaskNeedsActionResponse = {
	/** 成功した場合は true */
	ok: Scalars["Boolean"]["output"]
}

/**
 * Close known issues (set status to closed).
 * - [error]
 *     - UNAUTHORIZED: ServiceToken validation failed
 *     - PERMISSION_DENIED: ServiceToken does not have SouhlAdmin permission
 *     - NOT_FOUND: KnownIssue with specified id does not exist
 */
export type CloseKnownIssuesInput = {
	ids: Array<Scalars["String"]["input"]>
}

export type CloseKnownIssuesResponse = {
	ids: Array<Scalars["String"]["output"]>
}

/**
 * CloudBeautyStoreInput は Cloud Beauty 店舗の情報を表します。
 * database_id と store_id の組み合わせで一意に店舗が定まります。
 */
export type CloudBeautyStoreInput = {
	databaseId: Scalars["String"]["input"]
	storeId: Scalars["String"]["input"]
}

/**
 * `companies` は、全ての会社一覧を、作成日の降順で取得します。
 * - [error]
 *     - 401: caller が SOUHL admin ではない場合
 */
export type CompaniesResponse = {
	companies: Array<Company>
}

export type Company = {
	/**
	 * バッチジョブ（recalculate_company_cancy_summaries、1 日 3 回実行）で事前集計された cancy KPI を返す。
	 * カウンタテーブルに該当 company のデータがない場合は、今月・累計とも全フィールド 0 を返す。
	 */
	cancyDataSummary: CancyDataSummary
	contract: Array<Contract>
	/** 会社全体で ON になっているフラグ ID 一覧 */
	enabledFeatureFlagIds: Array<Scalars["String"]["output"]>
	/**
	 * company に紐づくアクティブな HubSpot 取引一覧（is_active = 1 のマッピングのみ）。
	 * FE の現在の紐付け状態表示用。
	 * レコードは UpdateCompanyHubspotContractIDs mutation で作成・更新される。
	 * 実装は data loader パターンを使用し、companies クエリでの N+1 を防止する。
	 */
	hubspotContracts: Array<HubspotContract>
	id: Scalars["String"]["output"]
	/** 会社に紐づく LINE グループ一覧 */
	lineGroups: Array<LineGroup>
	name: Scalars["String"]["output"]
	/** 会社に紐づく salon 一覧 (data loader 経由) */
	salons: Array<Salon>
}

export type CompanyBySalonIdParam = {
	salon_id: Scalars["Int"]["input"]
}

export type CompanyBySalonIdResponse = {
	company: Company
}

/**
 * 手数料率変更履歴（company_commission_rate_change_histories テーブル）。
 * 手数料率の更新時に自動記録される。
 */
export type CompanyCommissionRateChangeHistory = {
	/** 変更後のキャンセル料回収手数料率（税抜 %） */
	cancelFeeCommissionRate: Scalars["Int"]["output"]
	/** 変更日時 */
	createTime: Scalars["DateTime"]["output"]
	/** 変更後の既存客の再予約手数料率（税抜 %） */
	existingCustomerRereservationCommissionRate: Scalars["Int"]["output"]
	/** 履歴 ID（ULID） */
	id: Scalars["String"]["output"]
	/** 変更後の新規客の再予約手数料率（税抜 %） */
	newCustomerRereservationCommissionRate: Scalars["Int"]["output"]
}

/**
 * 会社手数料率（company_commission_rates テーブル）。
 * 会社ごとにキャンセル料回収手数料率と再予約手数料率を保持する。
 * 手数料率は税抜の整数 % で管理する。
 */
export type CompanyCommissionRates = {
	/** キャンセル料回収手数料率（税抜 %、0〜100） */
	cancelFeeCommissionRate: Scalars["Int"]["output"]
	/** IDP companies.id */
	companyId: Scalars["String"]["output"]
	/** 既存客の再予約手数料率（税抜 %、0〜100） */
	existingCustomerRereservationCommissionRate: Scalars["Int"]["output"]
	/** 新規客の再予約手数料率（税抜 %、0〜100） */
	newCustomerRereservationCommissionRate: Scalars["Int"]["output"]
}

/** 会社の Feature Flag 設定 */
export type CompanyFeatureFlag = {
	/** 有効な店舗 ID 一覧 */
	enabledSalonIds: Array<Scalars["Int"]["output"]>
	/** フラグ定義 */
	featureFlag: FeatureFlag
	/** 会社全体で有効か（false なら enabledSalonIds で個別店舗設定） */
	isCompanyWideEnabled: Scalars["Boolean"]["output"]
}

/**
 * 会社の Feature Flag 設定一覧を取得します。
 * 全ての FeatureFlag について、会社での有効状態を返却します。
 * 返却順は FeatureFlag enum の定義順です。
 * - [error]
 *     - UNAUTHORIZED: ServiceToken の検証に失敗する場合
 *     - PERMISSION_DENIED: ServiceToken が SouhlAdmin 権限を持たない場合
 */
export type CompanyFeatureFlagsParam = {
	companyId: Scalars["String"]["input"]
}

export type CompanyFeatureFlagsResponse = {
	companyFeatureFlags: Array<CompanyFeatureFlag>
}

/**
 * `company` は、指定された会社情報を取得します。
 * - [error]
 *     - 401: caller が SOUHL admin ではない場合
 */
export type CompanyParam = {
	id: Scalars["String"]["input"]
}

export type CompanyResponse = {
	company: Company
}

export type CompanySmsSendingRuleAutoClaimBase =
	| "CANCEL_DATE"
	| "RESERVATION_RECEIPTED_DATE"

/**
 * ある会社が持つSMS送信ルールV2
 * - cancel_type の組が、cancel_policy_template_type にあったものでないといけない.
 */
export type CompanySmsSendingRuleV2 = {
	/** どのようにキャンセルタイプを分けるかの種別 */
	cancelPolicyTemplateType: CancelPolicyTemplateType
	/** キャンセル種別ごとの設定 */
	cancelTypeSettings: Array<CompanySmsSendingRuleV2CancelTypeSetting>
	companyId: Scalars["String"]["output"]
	id: Scalars["String"]["output"]
	name: Scalars["String"]["output"]
	/**
	 * 現在選択可能な請求転換種別一覧
	 * FIXME: 一回 rule 取得しないと これがとれないのは微妙なので、 company クエリとかに移したい
	 */
	selectableClaimingConversionPolicyNames: Array<Scalars["String"]["output"]>
	/**
	 * 現在選択可能な再予約案内種別一覧 (setting の送付種別・来店回数区間 unit の送付種別で共通)
	 * FIXME: 一回 rule 取得しないと これがとれないのは微妙なので、 company クエリとかに移したい
	 */
	selectableEncouragingRereservationPolicyNames: Array<
		Scalars["String"]["output"]
	>
	/** ルールのサマリー文章 */
	summaryText: Scalars["String"]["output"]
}

/**
 * キャンセル種別ごとの設定
 * - 来店回数が十分に大きいときにも請求や再予約を行う場合, min_visit_count_for_xxx = 20 を指定する.
 *     - 20 が入力されたときには, backend では nil として扱う
 *     - nil は nil と等しく無限大に大きい整数として来店回数の処理を行う
 * - [validation]
 *     - cancel_type の組が、CancelPolicyTemplateType が設定可能な cancel_type の組と同じである必要がある
 *     - min_visit_count_for_claiming_conversion <= min_visit_count_for_manually_claiming_cancel_fee <= max_visit_count_for_encourageing_rereservation <= max_visit_count_for_nothing
 *     を満たす必要がある。
 *     - 現在は同じキャンセルタイプで請求と再予約案内送付を行うことができないため次の条件を全て満たす必要がある.
 *         - 再予約を使用する(min_visit_count_for_encouraging_rereservation != min_visit_count_for_nothing) ならば 請求は使用しない(min_visit_count_for_encouraging_rereservation = 0)
 *         - 請求を使用する(min_visit_count_for_encouraging_rereservation > 0 ) ならば 再予約は使用しない(min_visit_count_for_encouraging_rereservation = min_visit_count_for_nothing)
 */
export type CompanySmsSendingRuleV2CancelTypeSetting = {
	/**
	 * 0円以外の予約のキャンセル料金の金額。
	 * - 多くて `cancel_fee_percent_for_non_zero_yen_reservation` のどちらかが設定されている。
	 *     - `cancel_type` が請求可能なキャンセルタイプの場合は、どちらか一個だけ設定されている
	 *     - どちらも設定されていない場合は,請求機能を使用しない場合である (`min_visit_count_for_encouraging_rereservation` = 0)
	 * - 0 以下であることはない
	 */
	cancelFeeAmountForNonZeroYenReservation: Maybe<Scalars["Int"]["output"]>
	/**
	 * 0円の予約のキャンセル料金の金額
	 * - 請求機能を使用しない場合は 0 を指定する
	 * - 負の数であることはない
	 */
	cancelFeeAmountForZeroYenReservation: Scalars["Int"]["output"]
	/**
	 * 0円以外の予約のキャンセル料金は何%か。
	 * - 多くて `cancel_fee_amount_for_non_zero_yen_reservation` のどちらかが設定されている。
	 *     - `cancel_type` が請求可能なキャンセルタイプの場合は、どちらか一個だけ設定されている
	 *     - どちらも設定されていない場合は,請求機能を使用しない場合である (`min_visit_count_for_encouraging_rereservation` = 0)
	 * - 0 以下であることはない
	 */
	cancelFeePercentForNonZeroYenReservation: Maybe<Scalars["Int"]["output"]>
	cancelType: CancelType
	/**
	 * 請求転換種別
	 * - min_visit_count_for_claiming_conversion = min_visit_count_for_manually_claiming_cancel_fee のときは null それ以外の場合は必須
	 * - selectable_claiming_conversion_policy_names で返される値でないといけない
	 */
	claimingConversionPolicyName: Maybe<Scalars["String"]["output"]>
	companySmsSendingRuleV2Id: Scalars["String"]["output"]
	/**
	 * 再予約案内種別
	 * - min_visit_count_for_encouraging_rereservation = min_visit_count_for_nothing のときは null それ以外の場合は必須
	 * - selectable_encouraging_rereservation_policy_names で返される値でないといけない
	 */
	encouragingRereservationPolicyName: Maybe<Scalars["String"]["output"]>
	/**
	 * 再予約案内の来店回数区間ごとの送付種別設定 (min_visit_count 昇順)
	 * - 0 件の場合は従来通り encouraging_rereservation_policy_name を参照する
	 */
	encouragingRereservationUnits: Array<CompanySmsSendingRuleV2EncouragingRereservationUnit>
	/** company_sms_sending_rule_v2_id * cancel_type で一意に決まる */
	id: Scalars["String"]["output"]
	/**
	 * 請求可能なキャンセルタイプかどうか
	 * - False の場合 min_visit_count_for_encourage_rereservation = 0 である必要がある.
	 */
	isClaimableCancelType: Scalars["Boolean"]["output"]
	/**
	 * 手動請求の来店回数区間ごとの転換設定 (min_visit_count 昇順)
	 * - 0 件の場合は転換しない普通の手動請求
	 */
	manuallyClaimingUnits: Array<CompanySmsSendingRuleV2ManuallyClaimingUnit>
	/**
	 * 請求転換を行う顧客の最小来店回数
	 * - 自動請求を行わない場合は 0 を指定する
	 * - 0 以上 20 以下でないといけない
	 */
	minVisitCountForClaimingConversion: Scalars["Int"]["output"]
	/**
	 * 再予約案内送付を行う顧客の最小来店回数
	 * - 手動請求を行わない場合は min_visit_count_for_manually_claiming_cancel_fee と同じ値を指定する
	 * - min_visit_count_for_manually_claiming_cancel_fee 未満であることはない
	 * - 0 以上 20 以下でないといけない
	 */
	minVisitCountForEncouragingRereservation: Scalars["Int"]["output"]
	/**
	 * 手動請求を行う顧客の最小来店回数
	 * - 請求転換を行わない場合は min_visit_count_for_claiming_conversion と同じ値を指定する
	 * - min_visit_count_for_claiming_conversion 未満であることはない
	 * - 0 以上 20 以下でないといけない
	 */
	minVisitCountForManuallyClaimingCancelFee: Scalars["Int"]["output"]
	/**
	 * アクションを行わない顧客の最小来店回数
	 * - 再予約案内送付を行わない場合は min_visit_count_for_encouraging_rereservation と同じ値を指定する
	 * - min_visit_count_for_encouraging_rereservation 未満であることはない
	 * - 0 以上 20 以下でないといけない
	 */
	minVisitCountForNothing: Scalars["Int"]["output"]
}

/**
 * 再予約案内の来店回数区間ごとの送付種別設定
 * - 区間は [min_visit_count, 次の unit の min_visit_count - 1]。最後の unit は min_visit_count_for_nothing - 1 まで (min_visit_count_for_nothing が null (=20) の場合は上限なし)
 * - unit が 0 件の setting は従来通り encouraging_rereservation_policy_name を参照する (フォールバック)
 */
export type CompanySmsSendingRuleV2EncouragingRereservationUnit = {
	/**
	 * この区間の再予約案内種別
	 * - selectable_encouraging_rereservation_policy_names で返される値でないといけない
	 */
	encouragingRereservationPolicyName: Scalars["String"]["output"]
	/**
	 * 区間開始の来店回数 (この来店回数以上)
	 * - 先頭 unit は min_visit_count_for_encouraging_rereservation と一致する
	 */
	minVisitCount: Scalars["Int"]["output"]
}

/**
 * 手動請求の来店回数区間ごとの転換設定
 * - 区間は [min_visit_count, 次の unit の min_visit_count - 1]。最後の unit は min_visit_count_for_encouraging_rereservation - 1 まで (min_visit_count_for_encouraging_rereservation が null (=20) の場合は上限なし)
 * - unit が 0 件の setting / manually_claiming_unit_kind が null の unit は、転換しない普通の手動請求
 */
export type CompanySmsSendingRuleV2ManuallyClaimingUnit = {
	/**
	 * キャンセル日から何日後に転換するか
	 * - manually_claiming_unit_kind と常に同時に null / 非 null でないといけない
	 * - ENCOURAGE_CONVERSION では 5 / 7 / 14 / 21 のいずれか
	 */
	conversionDays: Maybe<Scalars["Int"]["output"]>
	/**
	 * この区間の転換先
	 * - null は転換しない普通の手動請求
	 */
	manuallyClaimingUnitKind: Maybe<ManuallyClaimingUnitKind>
	/**
	 * 区間開始の来店回数 (この来店回数以上)
	 * - 先頭 unit は min_visit_count_for_manually_claiming_cancel_fee と一致する
	 */
	minVisitCount: Scalars["Int"]["output"]
}

/**
 * companySmmSendingRulesV2 query は、caller が現在ログインしている店舗 (Rh-Salon-Id header で指定した店舗) が
 * 所属している Company の SMS 送信ルール一覧を作成時間の降順で返す。
 * - cancelTypeSettings の field は CancelType の enum の順で返される
 * - [error]
 *     - PERMISSION_DENIED: caller が会社の会社 admin ではない場合.
 */
export type CompanySmsSendingRulesV2Response = {
	rules: Array<CompanySmsSendingRuleV2>
	/**
	 * 会社単位の店舗送付用テキスト (コピペ用)。
	 * ルールごとに「適用店舗の displayName (1 行 1 店舗、salon id 昇順) → そのルールの rules[].summaryText と同じ文章」を並べ、
	 * ルール間は空行 2 つで区切る (summaryText 内のキャンセル種別ブロックは空行 1 つ区切り)。
	 * ルールの並びは適用店舗数の多い順 (同数ならルール名の昇順)。rules の並び (更新日時の降順) とは異なる。
	 * 店舗が紐づいていないルールは含めない。店舗が紐づくルールが 1 つも無い場合は空文字。
	 * このフィールドを要求したときだけ店舗の取得が走る (rules だけを要求する場合に追加コストはない)。
	 */
	summaryText: Scalars["String"]["output"]
}

/** セッション完了設定。isDone を true にしてセッションの作業完了を示す。 */
export type CompleteTaigaSessionInput = {
	/** 対象ノード ID */
	nodeId: Scalars["String"]["input"]
}

export type CompleteTaigaSessionResponse = {
	node: TaigaNode
}

export type CompleteTaigaSlackMentionInput = {
	/** true なら同一スレッドの embed session も完了にし :done: を投稿する（全完了）。false なら mention のみ完了する。 */
	completeEmbeddedSession: Scalars["Boolean"]["input"]
	/** 対象メンション ID */
	id: Scalars["String"]["input"]
}

export type CompleteTaigaSlackMentionResponse = {
	mention: TaigaSlackMention
}

/**
 * タスクを完了にする（souhl_admin のみ）。
 * tasks.status を COMPLETED に、completed_time を現在時刻にセットする。
 * 現行の催促スケジュール（active）があれば ended に変更する。
 * - [error]
 *     - UNAUTHORIZED: ServiceToken の検証に失敗する場合
 *     - PERMISSION_DENIED: ServiceToken が SouhlAdmin 権限を持たない場合
 *     - NOT_FOUND: taskId のタスクが存在しない場合
 *     - FAILED_PRECONDITION: taskId のタスクが既に COMPLETED の場合
 */
export type CompleteTaskInput = {
	/** 完了のきっかけとなった LINE Works メッセージ ID（null = 手動完了でメッセージ指定なし）。task_complete_line_works_message_ids テーブルに記録される。channel_messages がまだ存在しないケースがあるため channel_message_id ではなく line_works_message_id を使用。 */
	lineWorksMessageId?: InputMaybe<Scalars["String"]["input"]>
	/** 完了対象のタスク ID */
	taskId: Scalars["ID"]["input"]
}

/** completeTask のレスポンス */
export type CompleteTaskResponse = {
	/** 成功した場合は true */
	ok: Scalars["Boolean"]["output"]
}

/**
 * 指定 lineGroupId の完了タスク一覧を取得する。
 * 右ペインの「完了タスク」折りたたみセクションを展開した際に lazy load する。
 * register_time DESC でソート。
 * - [error]
 *     - PERMISSION_DENIED: souhl_admin でないユーザーがアクセスした場合
 */
export type CompletedTasksParam = {
	/** 対象の LINE グループ ID（line_works_groups.line_group_id） */
	lineGroupId: Scalars["String"]["input"]
}

/** completedTasks Query のレスポンス */
export type CompletedTasksResponse = {
	/** 完了タスク一覧 */
	tasks: Array<Task>
}

/**
 * Cancy リソース設定用の入力
 * サロンの基本情報、スクレイピング設定、再予約促進設定などを含む
 */
export type ConfigureCancySalonInput = {
	/** キャンセルポリシーテンプレートタイプ */
	cancelPolicyTemplateType: Scalars["String"]["input"]
	/** 会社 ID */
	companyId: Scalars["String"]["input"]
	/** クーポンマスター設定 */
	couponMasterInput?: InputMaybe<CouponMasterInput>
	/** テストサロンかどうか */
	isTestSalon: Scalars["Boolean"]["input"]
	/** Kanzashi スクレイピング設定 */
	kanzashiScrapingSettingInput?: InputMaybe<KanzashiScrapingSettingInput>
	/** キャンセルを非表示にする最小来店回数 */
	minVisitCountsToHideCancel?: InputMaybe<Scalars["Int"]["input"]>
	/** Moto モード（E2E テスト用 Cognito モック） */
	motoMode: Scalars["Boolean"]["input"]
	/** 請求しないキャンセラー名（部分一致）のリスト */
	partialMatchNoClaimCancelerNames: Array<Scalars["String"]["input"]>
	/** サロン住所 */
	salonAddress: Scalars["String"]["input"]
	/** サロン表示名 */
	salonDisplayName: Scalars["String"]["input"]
	/** サロン ID */
	salonId: Scalars["Int"]["input"]
	/** サロン名 */
	salonName: Scalars["String"]["input"]
	/** 再予約促進設定 */
	salonRereservationSettingInput: SalonRereservationSettingInput
}

export type ConfigureCancySalonResponse = {
	/** 設定が完了したサロン ID */
	salonId: Scalars["Int"]["output"]
	/** 設定が成功したかどうか */
	success: Scalars["Boolean"]["output"]
}

export type Contract = {
	id: Scalars["String"]["output"]
	name: Scalars["String"]["output"]
}

/** クーポンマスター設定 */
export type CouponMasterInput = {
	/** 割引額（円） */
	discountAmount?: InputMaybe<Scalars["Int"]["input"]>
	/** 割引率（%） */
	discountPercent?: InputMaybe<Scalars["Int"]["input"]>
	/** 有効期限（日数） */
	expireDurationDay: Scalars["Int"]["input"]
	/** デフォルトクーポンとして設定するかどうか */
	isDefaultCoupon: Scalars["Boolean"]["input"]
	/** 最小利用金額（円） */
	minAmount: Scalars["Int"]["input"]
}

/**
 * チャネルグループのメモを新規作成する（souhl_admin のみ）。
 * 作成者は ServiceToken の souhlUserID から自動解決する（slack_users.souhl_user_id で引く）。
 * - [error]
 *     - NOT_FOUND: 指定 channelGroupId に対応する channel_groups レコードが存在しない場合
 *     - NOT_FOUND: ServiceToken の souhlUserID に対応する slack_users レコードが存在しない場合
 *     - INVALID_ARGUMENT: text が空文字の場合
 */
export type CreateChannelGroupMemoInput = {
	/** メモを作成する対象のチャネルグループ ID（channel_groups.id） */
	channelGroupId: Scalars["String"]["input"]
	/** ピン留めフラグ */
	isPinned: Scalars["Boolean"]["input"]
	/** メモ本文 */
	text: Scalars["String"]["input"]
}

/** createChannelGroupMemo のレスポンス */
export type CreateChannelGroupMemoResponse = {
	/** 作成されたメモ */
	memo: ChannelGroupMemo
}

/**
 * `createCompany` は、会社を作成します。
 * contractIds が渡された場合は、HubSpot から取引情報を取得して Contract の作成と company_id_and_contract_id_mapping の作成を行います。
 * - すで DB にある contract の id が渡された場合には company_id_and_contract_id_mapping の作成のみを行います。
 * - [error]
 *     - 401: caller が SOUHL admin ではない場合
 *     - NOT_FOUND: HubSpot にも DB にも存在しない contract の ID が contractIds に含まれる場合
 */
export type CreateCompanyInput = {
	/** HubSpot の 取引 ID */
	contractIds?: InputMaybe<Array<Scalars["String"]["input"]>>
	name: Scalars["String"]["input"]
}

export type CreateCompanyResponse = {
	company: Company
}

/**
 * `createCompanySalonMapping` は、会社とサロンの紐付けを作成します。
 * - [error]
 *     - BAD_REQUEST: 指定された店舗がすでに会社の紐付けがされている場合
 *     - 401: caller が SOUHL admin ではない場合
 */
export type CreateCompanySalonMappingInput = {
	companyId: Scalars["String"]["input"]
	salonIds: Array<Scalars["Int"]["input"]>
}

export type CreateCompanySalonMappingResponse = {
	company: Company
}

export type CreateCompanySmsSendingRuleV2CancelTypeSettingInput = {
	/** 詳細は CompanySmsSendingRuleV2CancelTypeSetting.cancel_fee_amount_for_non_zero_yen_reservation を参照 */
	cancelFeeAmountForNonZeroYenReservation?: InputMaybe<Scalars["Int"]["input"]>
	/** 詳細は CompanySmsSendingRuleV2CancelTypeSetting.cancel_fee_amount_for_zero_yen_reservation を参照 */
	cancelFeeAmountForZeroYenReservation: Scalars["Int"]["input"]
	/** 詳細は CompanySmsSendingRuleV2CancelTypeSetting.cancel_fee_percent_for_non_zero_yen_reservation を参照 */
	cancelFeePercentForNonZeroYenReservation?: InputMaybe<Scalars["Int"]["input"]>
	cancelType: CancelType
	/** 詳細は CompanySmsSendingRuleV2CancelTypeSetting.claiming_conversion_policy_name を参照 */
	claimingConversionPolicyName?: InputMaybe<Scalars["String"]["input"]>
	/** 詳細は CompanySmsSendingRuleV2CancelTypeSetting.encouraging_rereservation_policy_name を参照 */
	encouragingRereservationPolicyName?: InputMaybe<Scalars["String"]["input"]>
	/**
	 * 再予約案内の来店回数区間ごとの送付種別設定
	 * - 省略時 (null) / 空リストは unit なし (従来通り encouraging_rereservation_policy_name を参照する)
	 */
	encouragingRereservationUnits?: InputMaybe<
		Array<EncouragingRereservationUnitInput>
	>
	/**
	 * 手動請求の来店回数区間ごとの転換設定
	 * - 省略時 (null) / 空リストは unit なし (転換しない普通の手動請求)
	 */
	manuallyClaimingUnits?: InputMaybe<Array<ManuallyClaimingUnitInput>>
	/** 詳細は CompanySmsSendingRuleV2CancelTypeSetting.min_visit_count_for_claiming_conversion を参照 */
	minVisitCountForClaimingConversion: Scalars["Int"]["input"]
	/** 詳細は CompanySmsSendingRuleV2CancelTypeSetting.min_visit_count_for_encouraging_rereservation を参照 */
	minVisitCountForEncouragingRereservation: Scalars["Int"]["input"]
	/** 詳細は CompanySmsSendingRuleV2CancelTypeSetting.min_visit_count_for_manually_claiming_cancel_fee を参照 */
	minVisitCountForManuallyClaimingCancelFee: Scalars["Int"]["input"]
	/** 詳細は CompanySmsSendingRuleV2CancelTypeSetting.min_visit_count_for_nothing を参照 */
	minVisitCountForNothing: Scalars["Int"]["input"]
}

/**
 * createCompanySmsSendingRuleV2 mutation は、ログインしている店舗 (Rh-Salon-Id header で指定した店舗) が所属している Company の
 * SMS 送信ルールを作成します。
 *
 * - [validation]
 *     - CompanySmsSendingRuleV2 と CompanySmsSendingRuleV2CancelTypeSetting の各フィールドが満たすべき条件を満たしている必要がある
 * - [error] (extension の masseges にエラーメッセージ list を返します)
 *     - PERMISSION_DENIED: caller が会社の会社 admin ではない場合.
 *     - BAD_REQUEST: validation error の場合
 */
export type CreateCompanySmsSendingRuleV2Input = {
	cancelPolicyTemplateType: CancelPolicyTemplateType
	cancelTypeSettingInputs: Array<CreateCompanySmsSendingRuleV2CancelTypeSettingInput>
	companyId: Scalars["String"]["input"]
	name: Scalars["String"]["input"]
}

export type CreateCompanySmsSendingRuleV2Response = {
	rule: CompanySmsSendingRuleV2
}

/**
 * スタッフマッピング（data_source_staff_mappings）を1件登録する。
 * id は salon_id・fromDataSource・fromDataSourceStaffId から決定的に生成されるため、
 * 同じ from 側のマッピングが既に存在する場合は何も登録せず created=false を返す（冪等）。
 * 登録前に既存マッピングを FOR UPDATE で確認するため、同一行を複数回叩いても二重登録は発生しない。
 * souhl_admin のみアクセス可能。
 * - [error]
 *     - PERMISSION_DENIED: souhl_admin でないユーザーがアクセスした場合
 *     - INVALID_ARGUMENT: 入力値が不正な場合（salonId <= 0、空文字など）
 */
export type CreateDataSourceStaffMappingInput = {
	/** マッピング元の媒体 */
	fromDataSource: DataSource
	/** マッピング元の媒体スタッフ ID */
	fromDataSourceStaffId: Scalars["String"]["input"]
	/** 対象の salon ID */
	salonId: Scalars["Int"]["input"]
	/** マッピング先の媒体 */
	toDataSource: DataSource
	/** マッピング先の媒体スタッフ ID */
	toDataSourceStaffId: Scalars["String"]["input"]
}

export type CreateDataSourceStaffMappingResponse = {
	/** 新規登録された場合は true。同じマッピングが既に存在し何も登録しなかった場合は false */
	created: Scalars["Boolean"]["output"]
}

/** CreateDefaultCompanySmsSendingRuleV2 Mutation は会社のデフォルトルールを作成します */
export type CreateDefaultCompanySmsSendingRuleV2Input = {
	/** default_rule を作成する会社の id */
	companyId: Scalars["String"]["input"]
	/** default_rule を作成する会社の名前 */
	companyName: Scalars["String"]["input"]
}

export type CreateDefaultCompanySmsSendingRuleVResponse = {
	/** default_rule を作成した会社の id */
	companyId: Scalars["String"]["output"]
}

/**
 * ドラフトメッセージを新規作成する（souhl_admin のみ）。
 * ユーザーが手動で作成する通常ドラフト、またはレビュー結果メッセージを作成する。
 * 作成者は ServiceToken の souhlUserID から自動解決する（slack_users.souhl_user_id で引く）。
 * - revieweeDraftMessageId を指定しない場合: 通常ドラフトを新規作成する。
 * - revieweeDraftMessageId を指定した場合: レビュー結果メッセージを新規作成する。
 *   reviewee は **deactivate されず active のまま残り**、レビュー結果が並列の
 *   active 行として追加される（元と reviewer 版を UI 上で比較できる）。
 * - [error]
 *     - NOT_FOUND: 指定 taskId に対応する tasks レコードが存在しない場合
 *     - NOT_FOUND: ServiceToken の souhlUserID に対応する slack_users レコードが存在しない場合
 *     - NOT_FOUND: 指定 revieweeDraftMessageId に対応する active な draft_messages レコードが存在しない場合
 *     - INVALID_ARGUMENT: revieweeDraftMessageId が指定した draft_messages の task_id と taskId が一致しない場合
 */
export type CreateDraftMessageInput = {
	/** レビュー元ドラフトの ID（null = 通常ドラフト作成。指定 = レビュー結果メッセージ作成） */
	revieweeDraftMessageId?: InputMaybe<Scalars["String"]["input"]>
	/** ドラフトを作成する対象タスクの ID */
	taskId: Scalars["String"]["input"]
	/** メッセージ本文 */
	text: Scalars["String"]["input"]
}

/** createDraftMessage のレスポンス */
export type CreateDraftMessageResponse = {
	/** 作成されたドラフトメッセージ */
	draftMessage: DraftMessage
}

/**
 * Create a known issue.
 * - [error]
 *     - UNAUTHORIZED: ServiceToken validation failed
 *     - PERMISSION_DENIED: ServiceToken does not have SouhlAdmin permission
 *     - BAD_REQUEST: Required field is invalid, or mentionTargetIds contains invalid ID
 */
export type CreateKnownIssueInput = {
	/** Days after last activity to auto-resolve (default: 7 = 1 week) */
	autoResolveDaysAfterLastActivity: Scalars["Int"]["input"]
	/** Cooldown hours between notifications. Null means no cooldown. */
	cooldownHoursToNotify?: InputMaybe<Scalars["Int"]["input"]>
	description: Scalars["String"]["input"]
	issueType: IssueType
	logKeyword: Scalars["String"]["input"]
	logKind?: InputMaybe<Scalars["String"]["input"]>
	logLevel: LogLevel
	logMatchMethod: LogMatchMethod
	logModuleName: Scalars["String"]["input"]
	/** Salon IDs to match (OR condition). Pass empty array [] if not filtering by salon. */
	logSalonIds: Array<Scalars["Int"]["input"]>
	/** Slack mention target IDs (e.g. ["U12345678", "U87654321"]) */
	mentionTargetIds: Array<Scalars["String"]["input"]>
	shouldSendIosCriticalNotification: Scalars["Boolean"]["input"]
	/** @deprecated 期限機能は廃止済み。指定しても無視される */
	shouldSkipThresholdCountCheckAfter?: InputMaybe<Scalars["DateTime"]["input"]>
	slackChannelNameToNotify: Scalars["String"]["input"]
	/** Number of log matches in last 24h to trigger notification (>= 1) */
	thresholdCountToNotify: Scalars["Int"]["input"]
}

export type CreateKnownIssueResponse = {
	knownIssue: KnownIssue
}

/**
 * KPI キャンセル CSV スプレッドシートを更新する。
 * 以下の 3 シートを最新の DB データで洗い替えする:
 *
 * - 【更新】RAW
 * - 【更新】請求済み：3ヶ月（ファーストインボイスが直近3ヶ月）
 * - 【更新】回収済RAW
 *
 * - [error]
 *     - PERMISSION_DENIED: souhl_admin でないユーザーがアクセスした場合
 */
export type CreateKpiCancelCsvInput = {
	Dummy?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** KPI キャンセル CSV スプレッドシート更新結果 */
export type CreateKpiCancelCsvResponse = {
	/** 更新に成功したかどうか */
	success: Scalars["Boolean"]["output"]
}

/**
 * `createSalon` は指定された salon_id で Salon を作成します。
 * 指定した company_id に紐付けて作成します。
 * CloudBeautyStoreInput を指定した場合、pos_store_id も指定されます。
 * - [error]
 *     - UNAUTHORIZED: ServiceToken の検証に失敗する場合
 *     - PERMISSION_DENIED: ServiceToken が SouhlAdmin 権限を持たない場合
 *     - ALREADY_EXISTS: 指定された salon_id の Salon が既に存在する場合
 *     - NOT_FOUND: 指定された company_id の Company が存在しない場合
 */
export type CreateSalonInput = {
	address: Scalars["String"]["input"]
	cloudBeautyStore?: InputMaybe<CloudBeautyStoreInput>
	companyId: Scalars["String"]["input"]
	displayName: Scalars["String"]["input"]
	name: Scalars["String"]["input"]
	salonId: Scalars["Int"]["input"]
}

export type CreateSalonResponse = {
	salon: Salon
}

/**
 * createSettlement は指定した accountingGroupID と yearMonth に対して settlement を作成する（souhl_admin のみ）。
 * 既に同一 accountingGroupID + yearMonth の settlement が存在する場合はスキップし created=false を返す。
 * - [error]
 *     - FORBIDDEN: souhl_admin でないユーザーがアクセスした場合
 *     - NOT_FOUND: accountingGroupID が存在しない場合
 */
export type CreateSettlementInput = {
	/** 対象 accounting group ID */
	accountingGroupId: Scalars["String"]["input"]
	/** 対象年月（YYYY-MM 形式） */
	yearMonth: Scalars["YearMonth"]["input"]
}

/** createSettlement のレスポンス */
export type CreateSettlementResponse = {
	/** settlement が新規作成されたかどうか（既に存在する場合は false） */
	created: Scalars["Boolean"]["output"]
}

/**
 * Slack ユーザー / Subteam を新規作成する（souhl_admin のみ）。
 * - memberType が SLACK_USER の場合、souhlUserID は必須。
 * - memberType が SLACK_SUBTEAM の場合、souhlUserID / lineWorksUserID は指定不可（INVALID_ARGUMENT）。
 * - [error]
 *     - ALREADY_EXISTS: 同じ id の slack_user が既に存在する場合
 *     - NOT_FOUND: lineWorksUserID が指定されているが channel_users に存在しない場合
 *     - NOT_FOUND: souhlUserID が指定されているが idp に該当ユーザーが存在しない場合
 *     - INVALID_ARGUMENT: memberType が SLACK_USER の場合に souhlUserID が未指定または空の場合
 *     - INVALID_ARGUMENT: memberType が SLACK_SUBTEAM の場合に souhlUserID または lineWorksUserID が指定されている場合
 */
export type CreateSlackUserInput = {
	/** 表示名 */
	displayName: Scalars["String"]["input"]
	/** Slack User ID or Subteam ID */
	id: Scalars["String"]["input"]
	/** channel_users.id（LINE Works ユーザーとの紐づけ。省略可。SLACK_SUBTEAM の場合は指定不可） */
	lineWorksUserID?: InputMaybe<Scalars["String"]["input"]>
	/** メンバー種別 */
	memberType: SlackUserMemberType
	/** Cognito User Sub（SLACK_USER の場合は必須。SLACK_SUBTEAM の場合は指定不可） */
	souhlUserID?: InputMaybe<Scalars["String"]["input"]>
}

/** createSlackUser のレスポンス */
export type CreateSlackUserResponse = {
	/** 作成された Slack ユーザー */
	slackUser: SlackUser
}

export type CreateTaigaMilestoneInput = {
	name: Scalars["String"]["input"]
	sheetId: Scalars["String"]["input"]
}

export type CreateTaigaMilestoneResponse = {
	milestone: TaigaMilestone
}

export type CreateTaigaNodeInput = {
	milestoneId: Scalars["String"]["input"]
	/** null = マイルストーン直下にルートノードとして作成 */
	parentNodeId?: InputMaybe<Scalars["String"]["input"]>
	/** セッション作成モーダルで入力された prompt。先頭100文字が node 名として保存される */
	prompt: Scalars["String"]["input"]
}

export type CreateTaigaNodeResponse = {
	/** 作成されたノード */
	node: TaigaNode
}

export type CreateTaigaNodeUnderSlackMentionInput = {
	/** セッション作成モーダルで入力された prompt。先頭100文字が root node 名として保存される */
	prompt: Scalars["String"]["input"]
	/** 対象 Slack mention の ID (`{channelId}_{messageTs}` 形式) */
	slackMentionId: Scalars["String"]["input"]
}

export type CreateTaigaNodeUnderSlackMentionResponse = {
	/** 作成された root node */
	node: TaigaNode
}

/** AI セッション作成。Slack チャンネルにスレッドを作成し、ノードに紐づける。 */
export type CreateTaigaSessionInput = {
	/** セッションに付与するメモ（省略可。空文字は null として保存） */
	memo?: InputMaybe<Scalars["String"]["input"]>
	/** 対象ノード ID（末端ノードのみ） */
	nodeId: Scalars["String"]["input"]
	/** AI に送信する初回プロンプト */
	prompt: Scalars["String"]["input"]
	/** Slack mention user ID の上書き（省略時は TAIGA_SLACK_MENTION_USER_ID を使用） */
	slackMentionUserId?: InputMaybe<Scalars["String"]["input"]>
}

export type CreateTaigaSessionResponse = {
	/** セッション情報が紐づけられた更新後のノード */
	node: TaigaNode
}

export type CreateTaigaSheetInput = {
	name: Scalars["String"]["input"]
}

export type CreateTaigaSheetResponse = {
	sheet: TaigaSheet
}

export type CreateTaigaSlackMentionInput = {
	/** true なら maki 宛メンションも付けて投稿する（デフォルト ON 想定。embed session 起動用）。 */
	mentionMaki: Scalars["Boolean"]["input"]
	/** 初期 priority（0 以上） */
	priority: Scalars["Int"]["input"]
	/** Slack に投稿する本文 */
	text: Scalars["String"]["input"]
}

export type CreateTaigaSlackMentionResponse = {
	mention: TaigaSlackMention
}

/**
 * タスクを手動作成する（souhl_admin のみ）。
 * channelGroupId / taskKindId を必須とし、その他のフィールドは任意。
 * taskReminder が指定された場合はその intervals で催促スケジュールを作成する。
 * intervals が空配列の場合は催促スケジュールを作成しない。
 * - [error]
 *     - UNAUTHORIZED: ServiceToken の検証に失敗する場合
 *     - PERMISSION_DENIED: ServiceToken が SouhlAdmin 権限を持たない場合
 *     - NOT_FOUND: channelGroupId / taskKindId / firstAssigneeSlackUserId / modifiedAssigneeSlackUserId / triggerChannelMessageId / tagIds の FK 先が存在しない場合
 *     - INVALID_ARGUMENT: taskReminder.intervals が 5 個超、または 0 以下の値を含む場合
 */
export type CreateTaskInput = {
	/** チャネルグループ ID（FK → channel_groups.id） */
	channelGroupId: Scalars["ID"]["input"]
	/** 最初の担当者の Slack User ID（FK → slack_users.id。null = 未指定） */
	firstAssigneeSlackUserId?: InputMaybe<Scalars["String"]["input"]>
	/** メモ（null = メモなし） */
	memo?: InputMaybe<Scalars["String"]["input"]>
	/** 引き継ぎ後の担当者の Slack User ID（FK → slack_users.id。null = 未指定） */
	modifiedAssigneeSlackUserId?: InputMaybe<Scalars["String"]["input"]>
	/** Slack スレッド（null = スレッドなし） */
	slackThreads?: InputMaybe<SlackThreadsInput>
	/** タグ ID 配列（空配列 = タグなし） */
	tagIds: Array<Scalars["ID"]["input"]>
	/** タスク種別 ID（FK → task_kinds.id） */
	taskKindId: Scalars["ID"]["input"]
	/** 催促スケジュール（必須。催促なしにしたい場合は intervals: [] を渡す） */
	taskReminder: TaskReminderInput
	/** タスク開始のきっかけとなった channel_messages.id（null = きっかけメッセージなし） */
	triggerChannelMessageId?: InputMaybe<Scalars["String"]["input"]>
}

/** タスク種別を新規作成する */
export type CreateTaskKindInput = {
	/** 表示色（RGB） */
	color: RgbInput
	/** デフォルトの催促間隔（時間単位の配列、最大 5 個。空配列 = 催促なし） */
	defaultReminderIntervalDays: Array<Scalars["Int"]["input"]>
	/** 表示名（ユニーク） */
	name: Scalars["String"]["input"]
}

/** createTaskKind のレスポンス */
export type CreateTaskKindResponse = {
	/** 作成されたタスク種別 */
	taskKind: TaskKind
}

/** createTask のレスポンス */
export type CreateTaskResponse = {
	/** 成功した場合は true */
	ok: Scalars["Boolean"]["output"]
}

/** タスクタグを新規作成する */
export type CreateTaskTagInput = {
	/** 表示色（RGB） */
	color: RgbInput
	/** タグ名（ユニーク） */
	name: Scalars["String"]["input"]
}

/** createTaskTag のレスポンス */
export type CreateTaskTagResponse = {
	/** 作成されたタスクタグ */
	taskTag: TaskTag
}

/**
 * DataSource は個々のスクレイピング対象媒体を表す enum。
 * DataSourcePolicy（複数媒体の組み合わせ）とは異なり、単一の媒体を指す。
 */
export type DataSource =
	| "BEAUTY_MERIT"
	| "CLOUD_BEAUTY"
	| "EXCEED_SYSTEM"
	| "KANZASHI"
	| "MINIMO"
	| "POSTAS"
	| "RAKUTEN"
	| "RESERVIA"
	| "SALONBOARD"
	| "SALON_CONNECT"
	| "SALORIZA"

/**
 * 対象会社に紐づく salon の DataSourceConnectionStatus が1つ以上存在する DataSource の一覧を、DataSource enum の定義順で返す。
 * DataSourceConnectionStatus が1つも存在しない DataSource は除外される。
 * souhl_admin のみアクセス可能。
 * - [error]
 *     - PERMISSION_DENIED: souhl_admin でないユーザーがアクセスした場合
 */
export type DataSourceColumnsParam = {
	/** 対象会社の ID（IDP companies.id） */
	companyId: Scalars["String"]["input"]
}

/** dataSourceColumns のレスポンス */
export type DataSourceColumnsResponse = {
	/** 表示すべき媒体カラム一覧。DataSource enum の定義順で返却する */
	dataSourceColumns: Array<DataSourceWithText>
}

/** DataSourceConnectionStatus は、salon の特定媒体に対する連携状況を表す。 */
export type DataSourceConnectionStatus = {
	/** 媒体種別 */
	dataSource: DataSource
	/** 最後につながったときの媒体側の店舗名。ipass エラー中も残る（一度もつながったことがない店舗などは null）。ipass エラーかどうかは hasIdPassError で判定する */
	dataSourceStoreName: Maybe<Scalars["String"]["output"]>
	/**
	 * ipass エラーかどうか。定期スクレイピングで ID/PASS エラーになると true になり、
	 * スクレイピングの成功や認証情報の更新でつながると false に戻る。
	 * true のとき、loginId は null になる。dataSourceStoreName・storeId は前回つながったときの値が残る
	 */
	hasIdPassError: Scalars["Boolean"]["output"]
	/** スクレイピング設定のログインID（媒体によっては null） */
	loginId: Maybe<Scalars["String"]["output"]>
	/** 最後に接続を確認した媒体の店舗ID。ipass エラー中も残る（媒体・接続前の店舗によっては null） */
	storeId: Maybe<Scalars["String"]["output"]>
}

/** 設備マッピング (data_source_equipment_mappings) 1件に対する承認結果 */
export type DataSourceEquipmentMappingActionResult = {
	/** 対象の draft ID (= 承認後の本テーブルの ID) */
	mappingId: Scalars["String"]["output"]
	/** スキップした理由。昇格された (または to 側まで同一で既に昇格済みだった) 場合は null */
	skipReason: Maybe<DataSourceEquipmentMappingSkipReason>
}

/**
 * DataSourceEquipmentMappingActionResult.skipReason の理由コード。
 * - NOT_FOUND: 指定した draft ID が draft_data_source_equipment_mappings に存在しない
 * - ALREADY_MAPPED: 同じ from 側のマッピングが、異なる to 側で本テーブルに既に存在する
 */
export type DataSourceEquipmentMappingSkipReason =
	| "ALREADY_MAPPED"
	| "NOT_FOUND"

/**
 * verifyDataSourceLoginCredentials / updateDataSourceLoginCredentials の共通入力。
 * 指定 salon・媒体の新しい認証情報（loginId/password）を表す。
 *
 * 各 mutation の挙動:
 * - verifyDataSourceLoginCredentials（保存しない）: 新認証情報で媒体へログインし店舗名・店舗ID を取得して返す。
 *   オペレーターが「正しい店舗に繋がるか」を保存前に画面で確認するために使う。
 *   非対応媒体（CLOUD_BEAUTY）は INVALID_ARGUMENT。
 * - updateDataSourceLoginCredentials（保存）: login_id(DB) + password(Parameter Store) を更新する。
 *   更新順序は Parameter Store(password) を TX 外で先に更新 → DB(login_id) を TX 内で更新（既存 UpsertSalons パターン準拠）。
 *   検証なし媒体（POSTAS）は検証スキップで更新。非対応媒体（CLOUD_BEAUTY）は INVALID_ARGUMENT。
 *   副作用: 検証あり媒体の成功時、data_source_connection_status を更新する。
 *
 * souhl_admin のみアクセス可能。機密検証のため mutation として公開し no-cache で呼ぶ（兄弟 getDataSourceLoginPassword と同方針）。
 * パスワード値はレスポンス・ログに平文出力しない（監査ログには操作者・対象 salon/媒体のみ記録）。
 *
 * - [error]
 *     - PERMISSION_DENIED: souhl_admin でないユーザー（update は Parameter Store 書き込み権限不足も含む）の場合
 *     - NOT_FOUND: 指定 salon_id の当該媒体 scraping_setting が存在しない場合
 *     - INVALID_ARGUMENT: data_source が対象外、または loginId/password が空の場合
 *       （verify は POSTAS も対象外。update は POSTAS は許可、EXCEED_SYSTEM/CLOUD_BEAUTY のみ対象外）
 *     - FAILED_PRECONDITION: ログイン検証に失敗した場合（ipassエラー＝認証失敗、またはタイムアウト/媒体側障害等の一時障害。update では更新は行われない）
 */
export type DataSourceLoginCredentialsInput = {
	/** 対象媒体 */
	dataSource: DataSource
	/** 新しいログインID（update では DB の {media}_scraping_setting.login_id を更新） */
	loginId: Scalars["String"]["input"]
	/** 新しいログインパスワード（update では AWS Parameter Store を更新）。レスポンス・ログには出力しない */
	password: Scalars["String"]["input"]
	/** 対象の salon ID */
	salonId: Scalars["Int"]["input"]
}

/** DataSourcePolicy は salon の媒体設定ポリシーを表す enum。 */
export type DataSourcePolicy =
	| "BEAUTY_MERIT"
	| "CLOUD_BEAUTY"
	| "EXCEED_AND_SALONBOARD"
	| "EXCEED_ONLY"
	| "KANZASHI"
	| "OTHER"
	| "POSTAS"
	| "RESERVIA_AND_SALONBOARD"
	| "RESERVIA_AND_SALONBOARD_AND_MINIMO"
	| "RESERVIA_AND_SALONBOARD_AND_MINIMO_AND_RAKUTEN"
	| "RESERVIA_AND_SALONBOARD_AND_RAKUTEN"
	| "SALONBOARD"
	| "SALONBOARD_AND_MINIMO"
	| "SALONBOARD_AND_MINIMO_AND_RAKUTEN"
	| "SALONBOARD_AND_RAKUTEN"
	| "SALON_ANSWER"
	| "SALON_CONNECT"
	| "SALORIZA_AND_SALONBOARD"
	| "SALORIZA_AND_SALONBOARD_AND_MINIMO"
	| "SALORIZA_AND_SALONBOARD_AND_MINIMO_AND_RAKUTEN"
	| "SALORIZA_AND_SALONBOARD_AND_RAKUTEN"
	/** 上野クリニック専用: スプレッドシート手入力ベース（自動スクレイピング対象外・再予約なし） */
	| "UENO_CLINIC_SPREAD_SHEET"

/**
 * DataSourcePolicy の全選択肢（enum 値 + 日本語表示名）を返す。
 * deprecated なポリシーは除外される。DataSourcePolicy enum の定義順で返却する。
 * souhl_admin のみアクセス可能。
 * - [error]
 *     - PERMISSION_DENIED: souhl_admin でないユーザーがアクセスした場合
 */
export type DataSourcePolicyOptionsParam = {
	_dummy?: InputMaybe<Scalars["Boolean"]["input"]>
}

/**
 * DataSourcePolicy の選択肢（enum 値 + 日本語表示名）。
 * フロントエンドのドロップダウン表示に使用する。
 */
export type DataSourcePolicyWithText = {
	/** 日本語表示名 */
	label: Scalars["String"]["output"]
	/** DataSourcePolicy enum 値 */
	value: DataSourcePolicy
}

/** スタッフマッピング (data_source_staff_mappings) 1件に対する承認結果 */
export type DataSourceStaffMappingActionResult = {
	/** 対象の draft ID (= 承認後の本テーブルの ID) */
	mappingId: Scalars["String"]["output"]
	/** スキップした理由。昇格された (または to 側まで同一で既に昇格済みだった) 場合は null */
	skipReason: Maybe<DataSourceStaffMappingSkipReason>
}

/**
 * DataSourceStaffMappingActionResult.skipReason の理由コード。
 * - NOT_FOUND: 指定した draft ID が draft_data_source_staff_mappings に存在しない
 * - ALREADY_MAPPED: 同じ from 側のマッピングが、異なる to 側で本テーブルに既に存在する
 */
export type DataSourceStaffMappingSkipReason = "ALREADY_MAPPED" | "NOT_FOUND"

/**
 * DataSourceWithText は DataSource enum 値と日本語表示名のペア。
 * ダッシュボードのテーブルヘッダに使用する。
 */
export type DataSourceWithText = {
	/** DataSource enum 値 */
	dataSource: DataSource
	/** 日本語表示名（例: 'サロンボード', 'サロリザ'） */
	label: Scalars["String"]["output"]
}

/**
 * active な channel_group_memos を非アクティブ (is_active = false) にする（論理削除）。
 * - [error]
 *     - NOT_FOUND: 指定 memoId に対応する active な channel_group_memos レコードが存在しない場合
 */
export type DeactivateChannelGroupMemoInput = {
	/** 非アクティブにするメモ ID */
	memoId: Scalars["String"]["input"]
}

/** deactivateChannelGroupMemo のレスポンス */
export type DeactivateChannelGroupMemoResponse = {
	/** 非アクティブにしたメモの ID */
	memoId: Scalars["String"]["output"]
}

/**
 * active な draft_messages を非アクティブ (is_active = false) にする。
 * - [error]
 *     - NOT_FOUND: 指定 draftMessageId に対応する active な draft_messages レコードが存在しない場合
 */
export type DeactivateDraftMessageInput = {
	/** 非アクティブにするドラフトメッセージ ID */
	draftMessageId: Scalars["String"]["input"]
}

/** deactivateDraftMessage のレスポンス */
export type DeactivateDraftMessageResponse = {
	/** 非アクティブにしたドラフトメッセージの ID */
	draftMessageId: Scalars["String"]["output"]
}

/** タスク種別を soft delete する */
export type DeleteTaskKindInput = {
	/** 削除対象のタスク種別 ID */
	id: Scalars["String"]["input"]
}

/** deleteTaskKind のレスポンス */
export type DeleteTaskKindResponse = {
	/** 削除されたタスク種別の ID */
	deletedTaskKindId: Scalars["String"]["output"]
}

/** タスクタグを soft delete する */
export type DeleteTaskTagInput = {
	/** 削除対象のタスクタグ ID */
	id: Scalars["String"]["input"]
}

/** deleteTaskTag のレスポンス */
export type DeleteTaskTagResponse = {
	/** 削除されたタスクタグの ID */
	deletedTaskTagId: Scalars["String"]["output"]
}

/**
 * ドラフトメッセージ。タスクに紐づくメッセージの下書き。
 * 本文 (text) は DynamoDB に格納されており、GraphQL レスポンスに含めて返す。
 * revieweeDraftMessageId が設定されている場合、このレコードはレビュー結果メッセージを表す
 * （reviewee 側ドラフトはそのまま active で残り、レビュー結果が並列に active として追加される）。
 */
export type DraftMessage = {
	/** 作成者の Slack ユーザー ID（null = AI bot） */
	authorSlackUserId: Maybe<Scalars["String"]["output"]>
	/** 作成者種別 */
	authorType: AuthorType
	/** ドラフトメッセージ ID（ULID。DynamoDB の PK と一致） */
	id: Scalars["ID"]["output"]
	/** 現行ドラフトかどうか（true = 現行、false = 廃版） */
	isActive: Scalars["Boolean"]["output"]
	/**
	 * 直前ドラフトの ID（null = 直前なしの新規ドラフト）。
	 * updateDraftMessage で本文を書き換えるたびに新しい active 行が作られ、その
	 * original_draft_message_id に直前の active 行の id が保存される。AI / USER /
	 * reviewer 出力 (revieweeDraftMessageId IS NOT NULL) のどれが元でも同様に
	 * 系譜 (chain) を伸ばすため、辿ることで履歴を遡れる。
	 */
	originalDraftMessageId: Maybe<Scalars["String"]["output"]>
	/** 業務的な登録日時 */
	registerTime: Scalars["DateTime"]["output"]
	/**
	 * draft 単位のレビュー状態（computed field, reviewee 側 = レビューされる元 draft の状態）。
	 * - OUTGOING_MESSAGE_SENT_AFTER_REVIEWED: self.is_outgoing_message_sent_after_reviewed = true (レビュー局面終了)
	 * - REVIEWED: self.id を reviewee_draft_message_id に持つ active draft (= レビュー結果メッセージ) が存在
	 * - PENDING_REVIEW: reviewer_slack_user_id IS NOT NULL かつ上記に該当しない
	 * - NONE: それ以外 (reviewer 未アサイン 等)
	 * 右ペイン (SouhlTaskPanel) のドラフトカードヘッダーに「レビュー待ち / レビュー済み」 バッジを出す用。
	 */
	reviewStatus: ReviewStatus
	/** レビュー元ドラフトの ID（null = 通常ドラフト。設定されている場合はレビュー結果メッセージ。reviewee は deactivate されず active のまま残る） */
	revieweeDraftMessageId: Maybe<Scalars["String"]["output"]>
	/**
	 * レビュワー（computed field, reviewerSlackUserId から SlackUser を引いて返す）。
	 * reviewerSlackUserId が null、 または該当 SlackUser が存在しない場合は null。
	 * draft 単位の「現在のレビュワー」を表現するフィールド。
	 */
	reviewer: Maybe<SlackUser>
	/** レビュワーの Slack ユーザー ID（null = 未アサイン） */
	reviewerSlackUserId: Maybe<Scalars["String"]["output"]>
	/** 紐づくタスクの ID */
	taskId: Scalars["String"]["output"]
	/**
	 * メッセージ本文（DynamoDB から取得）。
	 * **注意: 取得が重い（DynamoDB BatchGetItem が走る）ため、不要な場合は selection に含めないこと。**
	 * draft 単位の表示やレビュー UI で text 自体が必要な場面でのみ要求する。
	 * selection に含めなければ DataLoader 自体が呼ばれないので、 DynamoDB 通信は発生しない。
	 */
	text: Scalars["String"]["output"]
}

export type EncouragingRereservationUnitInput = {
	/** 詳細は CompanySmsSendingRuleV2EncouragingRereservationUnit.encouraging_rereservation_policy_name を参照 */
	encouragingRereservationPolicyName: Scalars["String"]["input"]
	/** 詳細は CompanySmsSendingRuleV2EncouragingRereservationUnit.min_visit_count を参照 */
	minVisitCount: Scalars["Int"]["input"]
}

/**
 * daytime_scraping.force_rescraping_target_salon_ids にハードコードされた対象店舗を、
 * midnight scraping と同様に scraping の ECS long job で enqueue する。
 *
 * midnight scraping と違い、当日 salon_scraping_log があってもスキップせず
 * 強制的に再スクレイピングする。対象店舗・enqueue 間隔はこの mutation の引数ではなく、
 * コード上の force_rescraping_target_salon_ids / force_rescraping_interval_sec を
 * 直接編集して指定する。
 *
 * - [error]
 *     - PERMISSION_DENIED: souhl_admin でないユーザーがアクセスした場合
 */
export type EnqueueLongScrapingJobsInput = {
	/** スケジュール開始時刻。null の場合は現在時刻から即時に enqueue を開始する。指定した場合はその時刻を基準にスケジュールする (Asia/Tokyo として解釈)。 */
	scheduledStartTime?: InputMaybe<Scalars["DateTime"]["input"]>
}

/** enqueueLongScrapingJobs のレスポンス */
export type EnqueueLongScrapingJobsResponse = {
	/** スクレイピング job を enqueue した対象サロンの ID リスト。 */
	salonIds: Array<Scalars["Int"]["output"]>
}

/**
 * settlement_id リスト → 対象 settlement の会計メール送信タスクを非同期登録する（souhl_admin のみ）。
 * 各 settlement に対し:
 *   1. settlement の status が invoice_in_progress または payout_in_progress であることを検証（1件でも違反があれば BAD_REQUEST）
 *   2. asynchronous_tasks を作成（各 settlement ごとに UUID を発行し idempotency_key として使用）
 *   3. SendAccountingEmailTopic{settlement_id, idempotency_key} 経由で Job が非同期実行される
 * ※ settlement の status 変更は行わない
 * ※ settlement_accounting_email_logs は使用しない（テーブル追加なし）
 * ※ settlementIds が空の場合はエラーにせず、空の enqueuedSettlementIds を返す
 * ※ idempotency_key は settlement_id とは独立した UUID のため、同一 settlement に対する再送が可能
 * ※ Job 側で settlement の is_net_amount_kind_payout を判定し、invoice 型 / payout 型で異なるテンプレート・添付を使用
 * - [error]
 *     - FORBIDDEN: souhl_admin でないユーザーがアクセスした場合
 *     - NOT_FOUND: settlementIds に存在しない settlement が含まれる場合
 *     - BAD_REQUEST: 対象 settlement に invoice_in_progress / payout_in_progress でないものが含まれる場合
 */
export type EnqueueSendAccountingEmailsBySettlementIDsInput = {
	/** 対象 settlement ID リスト */
	settlementIds: Array<Scalars["String"]["input"]>
}

/** enqueueSendAccountingEmailsBySettlementIDs のレスポンス */
export type EnqueueSendAccountingEmailsBySettlementIDsResponse = {
	/** メール送信タスクが登録された Settlement ID 一覧 */
	enqueuedSettlementIds: Array<Scalars["String"]["output"]>
}

/**
 * 指定したcancel_id一覧について、既存のGIFT incentive(RereservationIncentiveType.GIFT)が
 * 付与されていることを確認したうえで、クーポンURLを1件割り当て、
 * メール送信用の非同期タスクを発行する。
 * 対象確認・URL確保はこのmutation内で同期的に完結する。実際のメール送信は非同期に行われる。
 *
 * cancelIds が空配列の場合はエラーにせず、空の結果を返す。
 * cancelIds の中に GIFT incentive が付与されていない cancel_id が1件でも含まれる場合は、
 * 「対象外が混ざっていること自体がリクエストの誤り」とみなし、BAD_REQUESTで処理全体を
 * 中断する(該当cancel_idだけスキップして続行、という扱いはしない)。
 * 既に割当・送信済み(enqueue済み)のcancel_idは、エラーにせず黙ってスキップする
 * (同じ入力で再実行しても安全にするため)。
 * - [error]
 *     - BAD_REQUEST: cancelIds の中にGIFT incentiveが付与されていないcancel_idが含まれる場合
 *     - RESOURCE_EXHAUSTED: 該当する(publisher, price)の未割当URL在庫が足りない場合
 *       (処理全体を中断する。publisher は reminder から決まるため、cancelIds に複数の
 *        発行元が混ざると片方の在庫切れで全体が止まる。registerGiftUrls で不足分を
 *        登録してから同じ cancelIds で再実行する)
 */
export type EnqueueSendingGiftEmailsInput = {
	/** 対象キャンセルID一覧（GIFT incentive条件を満たすものであること） */
	cancelIds: Array<Scalars["String"]["input"]>
}

/** 一括enqueueの結果 */
export type EnqueueSendingGiftEmailsResponse = {
	/** 実際にenqueueされたcancel_id一覧（既にenqueue済みのものはスキップされ、ここには含まれない） */
	cancelIds: Array<Scalars["String"]["output"]>
}

/**
 * LINE Works メッセージ同期をオンデマンドでトリガーする。
 * Chrome 拡張がメッセージ送信を検知した際に呼び出し、publish worker 経由で
 * BizdevJobService.SyncLineWorksMessages を非同期実行する。
 * - [error]
 *     - PERMISSION_DENIED: souhl_admin でないユーザーがアクセスした場合
 */
export type EnqueueSyncLineWorksMessagesParam = {
	_dummy?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** enqueueSyncLineWorksMessages のレスポンス */
export type EnqueueSyncLineWorksMessagesResponse = {
	/** 成功した場合は true */
	ok: Scalars["Boolean"]["output"]
}

/** 外部サービスへのリンク生成に使う base URL 集 */
export type ExternalLinkBaseUrls = {
	/** HubSpot 取引ページの base URL（末尾に {deal_id}/ を連結する） */
	hubspotDeal: Scalars["String"]["output"]
	/** souhl_admin 会社詳細ページの base URL（末尾に {company_id} を連結する） */
	souhlAdminCompany: Scalars["String"]["output"]
	/** store_management ページの base URL（?salon_id={id} で店舗指定） */
	storeManagement: Scalars["String"]["output"]
}

/** Feature Flag の定義 */
export type FeatureFlag = {
	/** フラグの説明 */
	comment: Scalars["String"]["output"]
	/** フラグ ID (XXX_YYY 形式) */
	id: Scalars["String"]["output"]
	/** フラグ名 */
	name: Scalars["String"]["output"]
}

export type FeatureFlagToggleInput = {
	/** 有効にする店舗 ID 一覧（isCompanyWideEnabled が false の場合のみ使用、true の場合は無視） */
	enabledSalonIds?: InputMaybe<Array<Scalars["Int"]["input"]>>
	/** フラグ ID */
	featureFlagId: Scalars["String"]["input"]
	/** 会社全体で有効にするか（true: 会社全体ON, false: 個別店舗設定） */
	isCompanyWideEnabled: Scalars["Boolean"]["input"]
}

/**
 * 全 Feature Flag の定義一覧を取得します。
 * - [error]
 *     - UNAUTHORIZED: ServiceToken の検証に失敗する場合
 *     - PERMISSION_DENIED: ServiceToken が SouhlAdmin 権限を持たない場合
 */
export type FeatureFlagsParam = {
	_dummy?: InputMaybe<Scalars["Boolean"]["input"]>
}

export type FeatureFlagsResponse = {
	/** 全フラグ定義一覧（enum 定義順） */
	featureFlags: Array<FeatureFlag>
}

/**
 * セッションのフォーク。フォーク先ノード（省略時は元ノードと同じ階層の兄弟ノード、
 * slackMentionId 指定時はその mention の root node）を作り、
 * 「/fork <元スレッド URL>」の Slack 新規投稿で作ったスレッドをセッションとして紐づける。
 */
export type ForkTaigaSessionInput = {
	/** フォーク元セッションを持つノード ID */
	nodeId: Scalars["String"]["input"]
	/**
	 * フォーク先ノードを root node として置く Slack mention ID（embed session の Fork 用）。
	 * 省略時は元ノードと同じ階層に兄弟ノードとして作成する。
	 */
	slackMentionId?: InputMaybe<Scalars["String"]["input"]>
	/** Slack mention user ID の上書き（省略時は TAIGA_SLACK_MENTION_USER_ID を使用） */
	slackMentionUserId?: InputMaybe<Scalars["String"]["input"]>
}

export type ForkTaigaSessionResponse = {
	/** 作成されたフォーク先ノード（fork セッション紐づけ済み） */
	node: TaigaNode
}

/**
 * `generateFinLoginUrl` は company_id または line_group_id のどちらか一方を受け取り、Fin ログイン URL を生成します。
 * トークン（ULID）を生成して DB に保存し、Fin ログイン URL を返します。
 * Intercom Identity Verification 用の user_hash（HMAC-SHA256）はトークン検証時に都度算出します。
 * - [error]
 *     - UNAUTHORIZED: ServiceToken の検証に失敗する場合
 *     - PERMISSION_DENIED: ServiceToken が SouhlAdmin 権限を持たない場合
 *     - BAD_REQUEST: companyId と lineGroupId の指定がどちらもない、または両方ある場合
 *     - NOT_FOUND: 指定された company_id の Company が存在しない場合
 *     - NOT_FOUND: 指定された line_group_id の LineGroup が存在しない場合
 */
export type GenerateFinLoginUrlInput = {
	companyId?: InputMaybe<Scalars["String"]["input"]>
	lineGroupId?: InputMaybe<Scalars["String"]["input"]>
}

export type GenerateFinLoginUrlResponse = {
	/**
	 * ISO 8601 形式の有効期限。
	 * ※ 現在 Fin ログイン URL の expire 機能は実質無効化されており、サーバ側の `IsExpired()` は
	 * 常に false を返すため、ここで返す時刻を過ぎても URL は引き続き利用可能です。
	 * フィールドはスキーマ互換性維持のため残しています。
	 */
	expireTime: Scalars["DateTime"]["output"]
	url: Scalars["String"]["output"]
}

/** 会社の手数料率変更履歴を取得する（新しい順）。 */
export type GetCompanyCommissionRateChangeHistoriesParam = {
	/** IDP companies.id */
	companyId: Scalars["String"]["input"]
}

/** getCompanyCommissionRateChangeHistories のレスポンス */
export type GetCompanyCommissionRateChangeHistoriesResponse = {
	histories: Array<CompanyCommissionRateChangeHistory>
}

/**
 * 会社の手数料率を取得する。
 * レコードが存在しない場合はデフォルト値（回収手数料率: 30%、再予約手数料率: 25%）を返す。
 */
export type GetCompanyCommissionRatesParam = {
	/** IDP companies.id */
	companyId: Scalars["String"]["input"]
}

/** getCompanyCommissionRates のレスポンス */
export type GetCompanyCommissionRatesResponse = {
	companyCommissionRates: CompanyCommissionRates
}

/**
 * 指定された salon_id と data_source のログインパスワードを Parameter Store から取得する。
 * 機密取得のため mutation として公開し、フロントエンドでは no-cache で呼び出す。
 * souhl_admin のみアクセス可能。
 * - [error]
 *     - PERMISSION_DENIED: souhl_admin でないユーザー、または Parameter Store 権限不足の場合
 *     - NOT_FOUND: パスワードが Parameter Store に存在しない場合
 */
export type GetDataSourceLoginPasswordInput = {
	/** 対象媒体 */
	dataSource: DataSource
	/** 対象の salon ID */
	salonId: Scalars["Int"]["input"]
}

export type GetDataSourceLoginPasswordResponse = {
	/** 媒体ログインパスワード。画面表示せず clipboard コピーにのみ使用する */
	password: Scalars["String"]["output"]
}

/**
 * `salonUsers` は指定された店舗に所属するユーザー一覧を取得します
 * - [error]
 *     - UNAUTHORIZED: ServiceToken の検証に失敗する場合
 *     - PERMISSION_DENIED: ServiceToken が SouhlAdmin 権限を持たない場合
 *     - NOT_FOUND: 指定された salon_id の Salon が存在しない場合
 */
export type GetSalonUsersParam = {
	salonId: Scalars["Int"]["input"]
}

export type GetSalonUsersResponse = {
	users: Array<User>
}

/** ギフトの発行元 */
export type GiftPublisher = "ANYREACH" | "GIFTEE"

/** 登録するギフトクーポンURL1件分 */
export type GiftUrlInput = {
	/** ポイント交換期限（この日付までは交換可能。過去日は登録できない） */
	expireDate: Scalars["Date"]["input"]
	/** 発行元で発行したギフト受け取りURL（https:// で始まること） */
	giftUrl: Scalars["String"]["input"]
	/** このURLの発行元 */
	publisher: GiftPublisher
}

/**
 * embed session の引き継ぎ。
 * threadTs / channelId は引き継ぎ元 embed session の識別子で、FE は Slack URL を
 * extractSlackInfo でパースして渡す（attachTaigaSlackThread と同じ parse logic）。
 */
export type HandOverTaigaEmbedSessionInput = {
	/** 引き継ぎ元 embed session の Slack channel ID */
	channelId: Scalars["String"]["input"]
	/** 引き継ぎ先 Slack mention ID（この mention の root node として embed session を移動する） */
	slackMentionId: Scalars["String"]["input"]
	/** 引き継ぎ元 embed session の Slack thread_ts */
	threadTs: Scalars["String"]["input"]
}

export type HandOverTaigaEmbedSessionResponse = {
	/** 引き継ぎ先の配下へ移動した、session 付きノード */
	node: TaigaNode
}

/**
 * 指定された req_id を Redis に TTL 付きで保存し、UnknownIssueLogs の表示から除外する。
 * - TTL は 48 時間（表示期間と同じ）
 * - 同じ req_id を複数回 hide しても問題なし（TTL が更新される）
 * - [error]
 *     - UNAUTHORIZED: ServiceToken validation failed
 *     - PERMISSION_DENIED: ServiceToken does not have SouhlAdmin permission
 */
export type HideUnknownIssueLogsInput = {
	/** 非表示にする req_id のリスト */
	reqIds: Array<Scalars["String"]["input"]>
}

export type HideUnknownIssueLogsResponse = {
	/** 非表示に設定された件数 */
	hiddenCount: Scalars["Int"]["output"]
}

/**
 * HubSpot から同期された取引情報。
 * UpsertHubSpotContracts Job で 5 分ごとに hubspot_contracts テーブルに同期される。
 * dealstage は HubSpot の内部 ID（例: "contractsent"）。ラベル解決は将来対応。
 */
export type HubspotContract = {
	/** 取引ステージ内部 ID（HubSpot dealstage プロパティ。null の場合あり） */
	dealstage: Maybe<Scalars["String"]["output"]>
	/** HubSpot Deal ID */
	id: Scalars["String"]["output"]
	/** メイン担当者（HubSpot main_salon_manager プロパティ。null の場合あり） */
	mainAssignee: Maybe<Scalars["String"]["output"]>
	/** 取引名（HubSpot dealname プロパティ） */
	name: Scalars["String"]["output"]
	/** 登録日時 */
	registerTime: Scalars["DateTime"]["output"]
}

export type IssueType = "BIZ_TASK" | "DEV_TASK" | "PROGRAMMING_ISSUE"

/** Kanzashi スクレイピング設定 */
export type KanzashiScrapingSettingInput = {
	/** 美容室かどうか */
	isHairSalon: Scalars["Boolean"]["input"]
	/** Kanzashi グループアカウントかどうか */
	isKanzashiGroupAccount: Scalars["Boolean"]["input"]
	/** Kanzashi ログイン ID */
	kanzashiId: Scalars["String"]["input"]
	/** Kanzashi パスワード */
	kanzashiPassword: Scalars["String"]["input"]
	/** Kanzashi サロン ID */
	kanzashiSalonId: Scalars["Int"]["input"]
}

export type KnownIssue = {
	/** Days after last activity (max of latestAlertedTime, issueModifiedTime) to auto-resolve (default: 7 = 1 week) */
	autoResolveDaysAfterLastActivity: Scalars["Int"]["output"]
	/** Cooldown hours between notifications. Null means no cooldown (always notify when threshold is met). */
	cooldownHoursToNotify: Maybe<Scalars["Int"]["output"]>
	description: Scalars["String"]["output"]
	id: Scalars["String"]["output"]
	issueModifiedTime: Scalars["DateTime"]["output"]
	issueType: IssueType
	latestAlertedTime: Maybe<Scalars["DateTime"]["output"]>
	logKeyword: Scalars["String"]["output"]
	logKind: Maybe<Scalars["String"]["output"]>
	logLevel: LogLevel
	logMatchMethod: LogMatchMethod
	logModuleName: Scalars["String"]["output"]
	/** Salon IDs to match (OR condition) */
	logSalonIds: Array<Scalars["Int"]["output"]>
	mentionTargets: Array<KnownIssueMentionTarget>
	/** OpenSearch query URL */
	opensearchQueryUrl: Scalars["String"]["output"]
	registerTime: Scalars["DateTime"]["output"]
	shouldSendIosCriticalNotification: Scalars["Boolean"]["output"]
	/** @deprecated 期限機能は廃止済み。アラート判定では使用されない */
	shouldSkipThresholdCountCheckAfter: Scalars["DateTime"]["output"]
	slackChannelNameToNotify: Scalars["String"]["output"]
	status: KnownIssueStatus
	thresholdCountToNotify: Scalars["Int"]["output"]
}

export type KnownIssueDaySummariesEntry = {
	daySummaries: Array<KnownIssueDaySummary>
	knownIssueId: Scalars["String"]["output"]
	/** Count of matched logs in the last 24 hours */
	last24HoursMatchCount: Scalars["Int"]["output"]
}

/**
 * Get day summaries for specified known issues.
 * - [error]
 *     - UNAUTHORIZED: ServiceToken validation failed
 *     - PERMISSION_DENIED: ServiceToken does not have SouhlAdmin permission
 */
export type KnownIssueDaySummariesResponse = {
	summaries: Array<KnownIssueDaySummariesEntry>
}

export type KnownIssueDaySummary = {
	date: Scalars["Date"]["output"]
	/** Count of matched logs */
	matchLogCount: Scalars["Int"]["output"]
	/** Sample message (max 100 chars, if matched logs exist) */
	sampleMessage: Maybe<Scalars["String"]["output"]>
	/** Sample req_id (if matched logs exist) */
	sampleReqId: Maybe<Scalars["String"]["output"]>
}

/**
 * Get day summary for a single known issue (for detail page).
 * - [error]
 *     - UNAUTHORIZED: ServiceToken validation failed
 *     - PERMISSION_DENIED: ServiceToken does not have SouhlAdmin permission
 *     - NOT_FOUND: KnownIssue with specified id does not exist
 */
export type KnownIssueDaySummaryResponse = {
	daySummaries: Array<KnownIssueDaySummary>
	/** Count of matched logs in the last 24 hours */
	last24HoursMatchCount: Scalars["Int"]["output"]
}

export type KnownIssueMentionTarget = {
	name: Scalars["String"]["output"]
	slackMentionTargetId: Scalars["String"]["output"]
}

/**
 * Get a single known issue by ID.
 * - [error]
 *     - UNAUTHORIZED: ServiceToken validation failed
 *     - PERMISSION_DENIED: ServiceToken does not have SouhlAdmin permission
 *     - NOT_FOUND: KnownIssue with specified id does not exist
 */
export type KnownIssueResponse = {
	knownIssue: KnownIssue
}

export type KnownIssueStatus =
	| "AUTOMATICALLY_RESOLVED"
	| "CLOSED"
	| "MANUALLY_RESOLVED"
	| "OPEN"

/**
 * Get known issues list with optional filters.
 * Returns all issues if no filter specified, sorted by register_time desc.
 * - [error]
 *     - UNAUTHORIZED: ServiceToken validation failed
 *     - PERMISSION_DENIED: ServiceToken does not have SouhlAdmin permission
 */
export type KnownIssuesParam = {
	issueType?: InputMaybe<IssueType>
	logKind?: InputMaybe<Scalars["String"]["input"]>
	logLevel?: InputMaybe<LogLevel>
	logModuleName?: InputMaybe<Scalars["String"]["input"]>
	logSalonId?: InputMaybe<Scalars["Int"]["input"]>
	status?: InputMaybe<KnownIssueStatus>
}

export type KnownIssuesResponse = {
	knownIssues: Array<KnownIssue>
}

/**
 * LINE グループ。Federation entity として定義。
 * idp は id のみ返す。name は bizdev subgraph が resolve する。
 */
export type LineGroup = {
	id: Scalars["String"]["output"]
	/**
	 * LINE グループの表示名。bizdev channel_groups.display_name から取得する。
	 * lineGroupID → line_works_groups → channel_groups の 2 段ルックアップ（JOIN は使わずアプリ層で結合）。
	 * マッピングが見つからない場合は空文字を返す（graceful degradation）。
	 */
	name: Scalars["String"]["output"]
}

/**
 * LINE Works グループの詳細情報。
 * channel_groups + line_works_groups の 1:1 結合ビュー。
 */
export type LineWorksGroup = {
	/** channel_groups.id */
	channelGroupId: Scalars["String"]["output"]
	/** LINE グループに紐づく会社一覧（IDP federation entity 参照） */
	companies: Array<Company>
	/** 表示名（channel_groups.display_name） */
	displayName: Scalars["String"]["output"]
	/** そのグループが DM（1:1 トーク）かどうか。判定できない場合は null（不明）。 */
	isDm: Maybe<Scalars["Boolean"]["output"]>
	/** LINE グループ ID（line_works_groups.line_group_id） */
	lineGroupId: Scalars["String"]["output"]
	/** 未完了タスク一覧（status != 'completed'） */
	tasks: Array<Task>
}

/**
 * LINE Works グループを line_works_groups.line_group_id 指定で取得する。
 * FE の左ペイン（トークルーム一覧）/ 中央ペイン（詳細）両方に対応。
 * 単一取得が必要な場合は ids: [single_line_group_id] で呼ぶ。
 * - [error]
 *     - PERMISSION_DENIED: souhl_admin でないユーザーがアクセスした場合
 */
export type LineWorksGroupsParam = {
	/** 取得対象の line_works_groups.line_group_id の配列（必須。空配列 = 空結果） */
	ids: Array<Scalars["String"]["input"]>
}

/** lineWorksGroups Query のレスポンス */
export type LineWorksGroupsResponse = {
	/** 外部リンクの base URL 集（FE でリンク生成に使う） */
	externalLinkBaseUrls: ExternalLinkBaseUrls
	/** 取得した LINE Works グループ一覧 */
	lineWorksGroups: Array<LineWorksGroup>
}

/** lineWorksGroupsSyncTime Query のレスポンス */
export type LineWorksGroupsSyncTimeResponse = {
	/** タスクまたは下書きの最終更新時刻 (RFC3339)。データ未存在時は null */
	lastSyncedTime: Maybe<Scalars["DateTime"]["output"]>
}

/**
 * LINE Works メッセージと bizdev channel_messages の対応情報。
 * 中央ペインの右クリックメニューで line message id から channel_messages.id を解決するために使う。
 */
export type LineWorksMessage = {
	/** channel_messages.id */
	channelMessageId: Scalars["String"]["output"]
	/** LINE Works メッセージ ID（互換フィールド。lineWorksMessageId と同値） */
	lineMessageId: Maybe<Scalars["String"]["output"]>
	/** line_works_messages.line_works_message_id */
	lineWorksMessageId: Maybe<Scalars["String"]["output"]>
	/** line_works_messages.line_message_create_time */
	messageCreateTime: Scalars["DateTime"]["output"]
	/** メッセージ本文を ID 生成に使う prefix 量 (messageIDTextPrefixMaxRunes = 200 runes) で trim したもの。右クリックメニューで line message id → channel_message_id を解決する突き合わせ用。 */
	trimmedText: Scalars["String"]["output"]
}

/** lineWorksMessages Query の引数。 line_group_id 単発指定で直近 100 件取得。 */
export type LineWorksMessagesParam = {
	/** 取得対象の line_works_groups.line_group_id */
	lineGroupId: Scalars["String"]["input"]
}

/** lineWorksMessages Query のレスポンス */
export type LineWorksMessagesResponse = {
	/** 取得した LINE Works メッセージ一覧 (line_message_create_time ASC) */
	lineWorksMessages: Array<LineWorksMessage>
}

export type LogLevel = "CRITICAL" | "ERROR" | "WARNING"

export type LogMatchMethod = "PARTIAL" | "REGEX"

export type ManuallyClaimingUnitInput = {
	/** 詳細は CompanySmsSendingRuleV2ManuallyClaimingUnit.conversion_days を参照 */
	conversionDays?: InputMaybe<Scalars["Int"]["input"]>
	/** 詳細は CompanySmsSendingRuleV2ManuallyClaimingUnit.manually_claiming_unit_kind を参照 */
	manuallyClaimingUnitKind?: InputMaybe<ManuallyClaimingUnitKind>
	/** 詳細は CompanySmsSendingRuleV2ManuallyClaimingUnit.min_visit_count を参照 */
	minVisitCount: Scalars["Int"]["input"]
}

/**
 * 手動請求の来店回数区間を「何に転換するか」
 * - ENCOURAGE_CONVERSION: 再予約転換 (転換日数以内に再予約されなければ再予約案内へ転換する)
 * - 転換しない普通の手動請求は manually_claiming_unit_kind を null にする
 */
export type ManuallyClaimingUnitKind = "ENCOURAGE_CONVERSION"

/**
 * 過去スクレイピング (analysis_cancels) のキャンセルを再予約・来店確認し、
 * 未再予約・未来店で送付可否ゲートを通過したものだけを本番 rh_cancels に登録して
 * 再予約案内 reminder を付与する。
 * 再予約済み・来店済み・送付対象外のキャンセルは rh_cancels に登録しない
 * (送付に使われないキャンセルで店舗 UI のキャンセル一覧や集計を汚さないため)。
 *
 * 対象は指定 salon の analysis_cancels のうち、来店予定日が次の期間 (両端を含む) のもの。
 * 期間は自動で決まるため指定不要:
 * - 上限: sending_start_time の前日と昨日の早い方 (通常スクレイピングが扱う直近キャンセル
 *   = 請求対象になりうるものを取り込まないため)
 * - 下限: 本日 - 再予約案内の最大送付日数 (現状 29 日)。これより古い来店日は
 *   「来店日 + 送付日数」を過ぎていて reminder を作れないため読まない
 * 来店済み・再予約済みの除外と送付対象外の除外は下記の判定で行う。
 *
 * 処理内容:
 * 1. 前提チェック: salon が rh_salons に存在 / キャンセルポリシーテンプレートが取り込みに対応
 *    (非請求バケットを持つ zero_one 系・zero_two・zero_three・zero_five) /
 *    salon_rereservation_settings が存在し sending_start_time 設定済み /
 *    DB feature flag is_encouraging_rereservation が有効 / salon に company が紐づいている /
 *    上記の期間が空でない / 期間内の analysis_cancels が 1 件以上。いずれか未達なら BAD_REQUEST
 * 2. 対象 analysis_cancels のうち未登録分を Cancel に変換する。
 *    登録するのは 4. で reminder を作成したものだけ
 *    (message_kind=encourage_rereservation / payment_status=NOT_SUBJECT /
 *    is_imported_from_analysis=true で自動請求・手動請求のどちらの経路にも乗らない。
 *    請求スケジュール・rereservations・salon_scraping_log は作らない)。
 *    氏名が空・enum 不正などで変換できない行はスキップして skippedInvalidCount に数える。
 *    cancel_type 不明 (UNSPECIFIED) の行を取り込めるのは salonboard の「無断」と
 *    「お客様キャンセルで受付日時 (キャンセル受付日時) がある行」のみ。
 *    お客様キャンセルは受付日時から実際の cancel_type / date_cancel を計算する
 *    (reminder を付けるか = 登録するかは rule_v2 の cancel_type 別送付設定が判定する)。
 *    それ以外の cancel_type を計算できない行 (受付日時なし・サロンキャンセル・自動キャンセル・
 *    他媒体の UNSPECIFIED 等) はスキップして skippedInvalidCount に数える
 * 3. 再予約・来店確認: analysis_reservations (キャンセル済み予約は除外) と本番予約を
 *    顧客突合し、一致 (来店済み or 未来予約あり) した cancel は reminder 対象外
 *    (rh_cancels にも登録しない)
 * 4. reminder 付与: 未再予約・未来店の cancel に対し、通常フローと同じ送付可否ゲート
 *    (電話番号あり / 抑制電話番号に非該当 / 送付対象の cancel_type / 来店回数上限 /
 *    同一電話番号は最新キャンセル 1 件のみ 等。送付開始日ウィンドウのみバイパス) を
 *    通過したものに reminder を作成し、その cancel だけを rh_cancels に一括登録する。
 *    送信開始日時は「来店日 + policy の送付日数」の 19 時。来店日 + 送付日数を既に過ぎている
 *    cancel は送付対象外 (reminder を作らず、登録もしない)
 * 5. dryRun=true の場合は書き込みを一切行わず件数のみ返す
 *
 * 送付開始日ウィンドウのバイパスは cancel 側の is_imported_from_analysis を見て行うため、
 * SMS 送信直前の再判定 (should_update_as_aborted_by_rereservation_setting_change) でも
 * 同じ結果になる (作成できたのに送信直前で abort される、という不整合が起きない)。
 *
 * 冪等性: rh_cancels.id (UNIQUE) + FOR UPDATE 事前取得により再実行・通常スクレイピング済み分は
 * 登録スキップされる。登録しなかった cancel (再予約済み・送付対象外) は再実行のたびに
 * 改めて判定される。
 * - [error]
 *     - PERMISSION_DENIED: souhl_admin でないユーザーがアクセスした場合
 *     - BAD_REQUEST: salon が存在しない / キャンセルポリシーテンプレートが取り込み非対応 /
 *       salon_rereservation_settings が存在しない / sending_start_time が未設定 /
 *       feature flag is_encouraging_rereservation が無効 / salon に company が紐づいていない /
 *       取り込める期間が空 (sending_start_time が古い) /
 *       期間内の analysis_cancels が 0 件 (過去スクレイピング未実施) の場合
 */
export type ManuallyImportAllAnalysisCancelsInput = {
	/** true なら書き込みを行わず件数のみ返す (実行前プレビュー用)。既定 true で誤実行を防ぐ */
	dryRun?: Scalars["Boolean"]["input"]
	/** 対象サロンの ID (rh_salons.salon_id) */
	salonId: Scalars["Int"]["input"]
}

/** 過去スクレイピングキャンセル一括登録の実行結果 (dryRun 時は書き込んだと仮定した場合の件数) */
export type ManuallyImportAllAnalysisCancelsResponse = {
	/** dryRun で実行したかどうか */
	dryRun: Scalars["Boolean"]["output"]
	/** rh_cancels に新規登録した件数 (= reminder を作成した cancel の件数) */
	registeredCount: Scalars["Int"]["output"]
	/** encourage_rereservation_reminders を作成した件数 */
	reminderCreatedCount: Scalars["Int"]["output"]
	/** 未登録の候補のうち再予約済み・来店済みと判定した件数 (reminder 対象外・rh_cancels にも登録しない) */
	rereservedOrVisitedCount: Scalars["Int"]["output"]
	/** 既に rh_cancels に存在し登録をスキップした件数 */
	skippedAlreadyRegisteredCount: Scalars["Int"]["output"]
	/** 送付可否ゲートで reminder 対象外になった件数 (電話番号なし・抑制電話番号・対象外 cancel_type・来店回数超過・同一電話番号の重複・送付日数超過 等)。rh_cancels にも登録しない */
	skippedIneligibleCount: Scalars["Int"]["output"]
	/** analysis_cancels の値が不正で Cancel に変換できずスキップした件数 (対象の reserve_id はログに出力する) */
	skippedInvalidCount: Scalars["Int"]["output"]
	/** 対象 salon の analysis_cancels のうち来店予定日が対象期間内の件数 (変換できなかった件数も含む) */
	targetCount: Scalars["Int"]["output"]
}

/**
 * タスクを手動で NEEDS_REPLY に戻す（souhl_admin のみ）。
 * COMPLETED 状態のタスクに対して呼び出すと FAILED_PRECONDITION エラーを返す。
 * - [error]
 *     - UNAUTHORIZED: ServiceToken の検証に失敗する場合
 *     - PERMISSION_DENIED: ServiceToken が SouhlAdmin 権限を持たない場合
 *     - NOT_FOUND: taskId のタスクが存在しない場合
 *     - FAILED_PRECONDITION: taskId のタスクが既に COMPLETED の場合
 */
export type MarkTaskNeedsReplyInput = {
	/** 更新対象のタスク ID */
	taskId: Scalars["ID"]["input"]
}

/** markTaskNeedsReply のレスポンス */
export type MarkTaskNeedsReplyResponse = {
	/** 成功した場合は true */
	ok: Scalars["Boolean"]["output"]
}

/**
 * タスクを手動で WAITING_REPLY にする（souhl_admin のみ）。
 * COMPLETED 状態のタスクに対して呼び出すと FAILED_PRECONDITION エラーを返す。
 * - [error]
 *     - UNAUTHORIZED: ServiceToken の検証に失敗する場合
 *     - PERMISSION_DENIED: ServiceToken が SouhlAdmin 権限を持たない場合
 *     - NOT_FOUND: taskId のタスクが存在しない場合
 *     - FAILED_PRECONDITION: taskId のタスクが既に COMPLETED の場合
 */
export type MarkTaskWaitingReplyInput = {
	/** 更新対象のタスク ID */
	taskId: Scalars["ID"]["input"]
}

/** markTaskWaitingReply のレスポンス */
export type MarkTaskWaitingReplyResponse = {
	/** 成功した場合は true */
	ok: Scalars["Boolean"]["output"]
}

/** ノードを別の親に移動する。 */
export type MoveTaigaNodeInput = {
	/** この ID のノードの後ろに挿入（null = 先頭に配置） */
	afterNodeId?: InputMaybe<Scalars["String"]["input"]>
	/** 移動対象ノード ID */
	nodeId: Scalars["String"]["input"]
	/** 移動先マイルストーン ID */
	targetMilestoneId: Scalars["String"]["input"]
	/** 移動先の親ノード ID（null = マイルストーン直下のルートノードへ） */
	targetParentNodeId?: InputMaybe<Scalars["String"]["input"]>
}

export type MoveTaigaNodeResponse = {
	/** 移動されたノード（更新後） */
	node: TaigaNode
}

/** souhl admin 権限でない場合は 403 を返す */
export type Mutation = {
	alertSalonScrapingJobsNotFinished: AlertSalonScrapingJobsNotFinishedResponse
	approveDraftDataSourceEquipmentMappings: ApproveDraftDataSourceEquipmentMappingsResponse
	approveDraftDataSourceStaffMappings: ApproveDraftDataSourceStaffMappingsResponse
	/**
	 * マイルストーンをアーカイブする。
	 * アーカイブされたマイルストーンは taigaSheet のレスポンスに含まれなくなる。
	 * 配下のノード・セッションは削除されず保持される。
	 * - [error]
	 *     - UNAUTHORIZED: ServiceToken validation failed
	 *     - PERMISSION_DENIED: ServiceToken does not have SouhlAdmin permission
	 *     - NOT_FOUND: Milestone with specified id does not exist
	 *     - BAD_REQUEST: 既にアーカイブ済み
	 *     - BAD_REQUEST: Adhoc マイルストーンはアーカイブできません
	 */
	archiveTaigaMilestone: ArchiveTaigaMilestoneResponse
	/**
	 * ノードをアーカイブする（実質削除。復元不可）。
	 * 子ノードがある場合は子もすべて再帰的にアーカイブされる。
	 * アーカイブされたノードは taigaSheet のレスポンスに含まれなくなる。
	 * - [error]
	 *     - UNAUTHORIZED: ServiceToken validation failed
	 *     - PERMISSION_DENIED: ServiceToken does not have SouhlAdmin permission
	 *     - NOT_FOUND: Node with specified id does not exist
	 *     - BAD_REQUEST: 既にアーカイブ済み
	 */
	archiveTaigaNode: ArchiveTaigaNodeResponse
	/**
	 * シートをアーカイブする。
	 * アーカイブされたシートは taigaSheets の includeArchived=false（デフォルト）で非表示になる。
	 * 配下のマイルストーン・ノード・セッションは削除されず保持される。
	 * - [error]
	 *     - UNAUTHORIZED: ServiceToken validation failed
	 *     - PERMISSION_DENIED: ServiceToken does not have SouhlAdmin permission
	 *     - NOT_FOUND: Sheet with specified id does not exist
	 *     - BAD_REQUEST: 既にアーカイブ済み
	 *     - BAD_REQUEST: デフォルトシートはアーカイブできません
	 */
	archiveTaigaSheet: ArchiveTaigaSheetResponse
	/**
	 * 既存の Slack スレッドを末端ノードに紐づける。
	 * Slack への投稿は行わず、指定された thread_ts をセッションに保存するのみ。
	 * - AI Session は子ノードを持たない末端ノードにのみ作成可能
	 * - [error]
	 *     - UNAUTHORIZED: ServiceToken validation failed
	 *     - PERMISSION_DENIED: ServiceToken does not have SouhlAdmin permission
	 *     - NOT_FOUND: Node with specified nodeId does not exist
	 *     - BAD_REQUEST: 子ノードを持つノード、既にセッションが存在する
	 */
	attachTaigaSlackThread: AttachTaigaSlackThreadResponse
	bulkUpdateInvoiceSettlementStatuses: BulkUpdateInvoiceSettlementStatusesResponse
	bulkUpdatePayoutSettlementStatuses: BulkUpdatePayoutSettlementStatusesResponse
	bulkUpsertChannelGroupsAndLineWorksGroups: BulkUpsertChannelGroupsAndLineWorksGroupsResponse
	clearTaskNeedsAction: ClearTaskNeedsActionResponse
	closeKnownIssues: CloseKnownIssuesResponse
	/**
	 * セッション完了を設定する。
	 * isDone を true にすると、そのノードの作業が完了したことを示す。
	 * - [error]
	 *     - UNAUTHORIZED: ServiceToken validation failed
	 *     - PERMISSION_DENIED: ServiceToken does not have SouhlAdmin permission
	 *     - NOT_FOUND: 指定された node に session が存在しない
	 */
	completeTaigaSession: CompleteTaigaSessionResponse
	/**
	 * Slack メンションを完了にする。
	 * 1. Slack reactions.add で :done: reaction を対象メッセージに付与
	 * 2. DB の is_done を true、update_time を now に更新
	 * Slack 側のリアクション付与に失敗した場合はエラーを返し DB 更新も行わない。
	 * - [error]
	 *     - UNAUTHORIZED: ServiceToken validation failed
	 *     - PERMISSION_DENIED: ServiceToken does not have SouhlAdmin permission
	 *     - PERMISSION_DENIED: 自分以外の user_id を持つメンションを操作した
	 *     - NOT_FOUND: 指定 id のメンションが存在しない
	 *     - INTERNAL: Slack reactions.add 失敗（rate limit / network / token expired 等）
	 */
	completeTaigaSlackMention: CompleteTaigaSlackMentionResponse
	completeTask: CompleteTaskResponse
	configureCancySalon: ConfigureCancySalonResponse
	createChannelGroupMemo: CreateChannelGroupMemoResponse
	createCompany: CreateCompanyResponse
	createCompanySalonMapping: CreateCompanySalonMappingResponse
	createCompanySmsSendingRuleV2: CreateCompanySmsSendingRuleV2Response
	createDataSourceStaffMapping: CreateDataSourceStaffMappingResponse
	createDefaultCompanySmsSendingRuleV2: CreateDefaultCompanySmsSendingRuleVResponse
	createDraftMessage: CreateDraftMessageResponse
	createKnownIssue: CreateKnownIssueResponse
	createKpiCancelCsv: CreateKpiCancelCsvResponse
	createSalon: CreateSalonResponse
	createSettlement: CreateSettlementResponse
	createSlackUser: CreateSlackUserResponse
	/**
	 * マイルストーンを作成する。
	 * 作成時の priority は、シート内の既存マイルストーンの最大 priority + 1 が自動付与される
	 * （= 一番下に追加される）。
	 * - [error]
	 *     - UNAUTHORIZED: ServiceToken validation failed
	 *     - PERMISSION_DENIED: ServiceToken does not have SouhlAdmin permission
	 *     - NOT_FOUND: Sheet with specified sheetId does not exist
	 */
	createTaigaMilestone: CreateTaigaMilestoneResponse
	/**
	 * ノードを作成する。
	 * - parentNodeId が null の場合、マイルストーン直下のルートノードとして作成
	 * - parentNodeId が指定された場合、そのノードの子として作成
	 * - 親ノードにセッションが紐づいている場合はエラー（セッション済みノードに子を追加できない）
	 * - 同一親内での order は末尾に配置される
	 * - parallelPriority は同一親内の active（is_done=false）なノードの max + 1 が自動付与される（done ノードは除外）
	 * - [error]
	 *     - UNAUTHORIZED: ServiceToken validation failed
	 *     - PERMISSION_DENIED: ServiceToken does not have SouhlAdmin permission
	 *     - NOT_FOUND: Milestone or parent node does not exist
	 *     - BAD_REQUEST: セッション済みノードに子を追加しようとした
	 */
	createTaigaNode: CreateTaigaNodeResponse
	/**
	 * Slack mention を origin とするツリーの root node を作成する。
	 * - milestone_id=NULL / parent_node_id=NULL の root node を作成し、taiga_slack_mention_root_nodes に
	 *   (node_id, slackMentionId) で登録する (同一トランザクション)。
	 * - order / parallel_priority は同一 slack_mention に属する root node 群をスコープに採番する。
	 * - 同一 Slack mention に複数 root node をぶら下げてよい (order は末尾)。
	 * - [error]
	 *     - UNAUTHORIZED: ServiceToken validation failed
	 *     - PERMISSION_DENIED: ServiceToken does not have SouhlAdmin permission
	 *     - PERMISSION_DENIED: 呼び出しユーザー != 対象 Slack mention の user_id
	 *     - NOT_FOUND: 指定 slackMentionId の Slack mention が存在しない
	 */
	createTaigaNodeUnderSlackMention: CreateTaigaNodeUnderSlackMentionResponse
	/**
	 * 末端ノードに AI セッションを作成する。
	 * 1. 指定の Slack チャンネルにメッセージを送信し、スレッドを作成
	 * 2. 作成されたスレッドの thread_ts をセッションに紐づける
	 * 3. 初期ステータスを IDLE に設定
	 * プロンプトは最初の1回のみ。以降のやり取りは Slack スレッド上で行う。
	 * - AI Session は子ノードを持たない末端ノードにのみ作成可能
	 * - [error]
	 *     - UNAUTHORIZED: ServiceToken validation failed
	 *     - PERMISSION_DENIED: ServiceToken does not have SouhlAdmin permission
	 *     - NOT_FOUND: Node with specified nodeId does not exist
	 *     - BAD_REQUEST: 子ノードを持つノード、既にセッションが存在する
	 */
	createTaigaSession: CreateTaigaSessionResponse
	/**
	 * 新しいシートを作成する。
	 * - [error]
	 *     - UNAUTHORIZED: ServiceToken validation failed
	 *     - PERMISSION_DENIED: ServiceToken does not have SouhlAdmin permission
	 */
	createTaigaSheet: CreateTaigaSheetResponse
	/**
	 * Slack メンションを手動で作成する。
	 * 認証ユーザーの slack user id を逆引きし、default チャンネルに自分宛メンション付きメッセージを投稿。
	 * 投稿結果から SlackMention レコードを作成して返す。
	 * - [error]
	 *     - UNAUTHORIZED: ServiceToken validation failed
	 *     - PERMISSION_DENIED: ServiceToken does not have SouhlAdmin permission
	 *     - BAD_REQUEST: text が空
	 *     - BAD_REQUEST: priority が 0 未満
	 *     - BAD_REQUEST: マッピング未登録ユーザー（slack user id が逆引きできない）
	 *     - INTERNAL: Slack chat.postMessage 失敗
	 */
	createTaigaSlackMention: CreateTaigaSlackMentionResponse
	createTask: CreateTaskResponse
	createTaskKind: CreateTaskKindResponse
	createTaskTag: CreateTaskTagResponse
	deactivateChannelGroupMemo: DeactivateChannelGroupMemoResponse
	deactivateDraftMessage: DeactivateDraftMessageResponse
	deleteTaskKind: DeleteTaskKindResponse
	deleteTaskTag: DeleteTaskTagResponse
	enqueueLongScrapingJobs: EnqueueLongScrapingJobsResponse
	enqueueSendAccountingEmailsBySettlementIDs: EnqueueSendAccountingEmailsBySettlementIDsResponse
	enqueueSendingGiftEmails: EnqueueSendingGiftEmailsResponse
	enqueueSyncLineWorksMessages: EnqueueSyncLineWorksMessagesResponse
	/**
	 * セッションを持つノードをフォークする。
	 * 1. フォーク先ノードを作成する（名前: "{元ノード名} (fork)"）
	 *    - slackMentionId 指定時（embed session の Fork）: その mention の root node として末尾に追加
	 *      （embed session の node は orphan / adhoc milestone 配下にあり得るため、元ノードの階層ではなく
	 *      mention 直下の nodes に置く）
	 *    - slackMentionId 省略時: 元ノードと同じ階層に兄弟ノードとして作成
	 *      - 元ノードが Slack mention の root node の場合は、同じ mention の root node として末尾に追加
	 *      - それ以外は同じ parent_node_id / milestone_id の兄弟として末尾に追加
	 * 2. 元セッションと同じ Slack チャンネルに「/fork <元スレッド URL>」メッセージを新規投稿し、
	 *    フォーク用スレッドを作成する（cc-server が /fork を検知し、元セッションの worktree・
	 *    会話履歴を引き継いだ新セッションを立ち上げる）
	 * 3. 新スレッドの thread_ts をセッションとしてフォーク先ノードに紐づける
	 * - [error]
	 *     - UNAUTHORIZED: ServiceToken validation failed
	 *     - PERMISSION_DENIED: ServiceToken does not have SouhlAdmin permission
	 *     - PERMISSION_DENIED: 他ユーザーの Slack mention ツリー配下のノード
	 *     - PERMISSION_DENIED: slackMentionId の mention が他ユーザーのもの
	 *     - NOT_FOUND: Node with specified nodeId does not exist
	 *     - NOT_FOUND: slackMentionId の mention が存在しない
	 *     - BAD_REQUEST: セッションが存在しないノード、orphan ノード（どの階層にも属さないノード。slackMentionId 省略時のみ）
	 */
	forkTaigaSession: ForkTaigaSessionResponse
	generateFinLoginUrl: GenerateFinLoginUrlResponse
	getDataSourceLoginPassword: GetDataSourceLoginPasswordResponse
	/**
	 * embed session を別の Slack mention に引き継ぐ。
	 * Slack URL から解決した (channel_id, thread_ts) に対応する embed session を持つノードを、
	 * slackMentionId の mention の root node として移動する（session・サブツリーごと引き継ぐ）。
	 * あわせて引き継ぎ元スレッドにある呼び出しユーザーの Slack mention を
	 * 「完了（embed session の node は完了させない）」にする。
	 * FE は MentionNodeTree の「+ node を追加」の隣の「embed 引き継ぎ」ボタンから発行する。
	 * - root node 化: 引き継ぎ元ノードの parent_node_id / milestone_id を NULL にし、
	 *   taiga_slack_mention_root_nodes に (node_id, slackMentionId) を登録する（既存マッピングは付け替え）。
	 * - mention の完了は completeTaigaSlackMention の completeEmbeddedSession=false 相当
	 *   （元 mention のみ done。引き継いだ node は移動して活かすため完了させない）。
	 * - mention の完了は best-effort（Slack reaction 失敗時もノード移動は確定し成功扱いとする）。
	 * - [error]
	 *     - UNAUTHORIZED: ServiceToken validation failed
	 *     - PERMISSION_DENIED: ServiceToken does not have SouhlAdmin permission
	 *     - PERMISSION_DENIED: 引き継ぎ先 mention が他ユーザーのもの
	 *     - NOT_FOUND: (channelId, threadTs) に対応する embed session が存在しない
	 *     - NOT_FOUND: slackMentionId の mention が存在しない
	 */
	handOverTaigaEmbedSession: HandOverTaigaEmbedSessionResponse
	hideUnknownIssueLogs: HideUnknownIssueLogsResponse
	manuallyImportAllAnalysisCancels: ManuallyImportAllAnalysisCancelsResponse
	markTaskNeedsReply: MarkTaskNeedsReplyResponse
	markTaskWaitingReply: MarkTaskWaitingReplyResponse
	/**
	 * ノードを別の親（または別マイルストーン）に移動する。
	 * - 移動先の親にセッションが紐づいている場合はエラー
	 * - 自分自身の子孫への移動は不可（循環参照防止）
	 * - 子ノードの milestoneId も再帰的に更新される
	 * - afterNodeId で挿入位置を指定（null = 先頭）
	 * - [error]
	 *     - UNAUTHORIZED: ServiceToken validation failed
	 *     - PERMISSION_DENIED: ServiceToken does not have SouhlAdmin permission
	 *     - NOT_FOUND: Node or target parent/milestone does not exist
	 *     - BAD_REQUEST: 循環参照、セッション済みノードへの移動
	 */
	moveTaigaNode: MoveTaigaNodeResponse
	postSlackThreadMessage: PostSlackThreadMessageResponse
	/**
	 * 指定ノード配下の全ノードの parallelPriority を一括で +1 する（= 優先度を下げる）。
	 * - 対象: 指定ノード自身 + 配下の全子孫ノード（parallelPriority が設定されているもの）
	 * - [error]
	 *     - UNAUTHORIZED: ServiceToken validation failed
	 *     - PERMISSION_DENIED: ServiceToken does not have SouhlAdmin permission
	 *     - NOT_FOUND: Node with specified id does not exist
	 */
	priorityDownTaigaNode: PriorityDownTaigaNodeResponse
	/**
	 * Slack メンションの優先度を下げる。
	 * priority を 1 増やす。
	 * - [error]
	 *     - UNAUTHORIZED: ServiceToken validation failed
	 *     - PERMISSION_DENIED: ServiceToken does not have SouhlAdmin permission
	 *     - PERMISSION_DENIED: 自分以外の user_id を持つメンションを操作した
	 *     - NOT_FOUND: 指定 id のメンションが存在しない
	 */
	priorityDownTaigaSlackMention: PriorityDownTaigaSlackMentionResponse
	/**
	 * 指定ノード配下の全ノードの parallelPriority を一括で -1 する（= 優先度を上げる）。
	 * - 対象: 指定ノード自身 + 配下の全子孫ノード（parallelPriority が設定されているもの）
	 * - parallelPriority の最小値は 0（0 未満にはならない）
	 * - [error]
	 *     - UNAUTHORIZED: ServiceToken validation failed
	 *     - PERMISSION_DENIED: ServiceToken does not have SouhlAdmin permission
	 *     - NOT_FOUND: Node with specified id does not exist
	 *     - BAD_REQUEST: 既に最小値 (0) のため上げられない
	 */
	priorityUpTaigaNode: PriorityUpTaigaNodeResponse
	/**
	 * Slack メンションの優先度を上げる。
	 * priority を 1 減らす。既に 0 の場合は 0 のまま。
	 * - [error]
	 *     - UNAUTHORIZED: ServiceToken validation failed
	 *     - PERMISSION_DENIED: ServiceToken does not have SouhlAdmin permission
	 *     - PERMISSION_DENIED: 自分以外の user_id を持つメンションを操作した
	 *     - NOT_FOUND: 指定 id のメンションが存在しない
	 */
	priorityUpTaigaSlackMention: PriorityUpTaigaSlackMentionResponse
	registerGiftUrls: RegisterGiftUrlsResponse
	/**
	 * Slack メンションを作り直す（= Slack 投稿の作成日をリフレッシュする）。
	 * 元メンションと同じ内容を channelId（未指定なら default チャンネル）に投稿し直して新しいメンションを作り、
	 * 元メンション配下の node ツリーを新しいメンションへ付け替えたうえで、元メンションを完了にする。
	 * 処理順は (1) 新メンション作成 → (2) node 付け替え → (3) 元メンション完了。
	 * - 新メンションの本文は元メンションの comment（空なら text）。maki 宛メンションは付けない。
	 * - 付け替え対象は「元メンションの root node 群」と「元メンションのスレッドにある embed session の node」。
	 *   embed session が無い場合は root node のみ付け替える（エラーにしない）。
	 * - 元メンションの完了は completeTaigaSlackMention の completeEmbeddedSession=false 相当
	 *   （引き継いだ node は移動して活かすため完了させない）。
	 * - [error]
	 *     - UNAUTHORIZED: ServiceToken validation failed
	 *     - PERMISSION_DENIED: ServiceToken does not have SouhlAdmin permission
	 *     - PERMISSION_DENIED: 対象メンションが他ユーザーのもの
	 *     - BAD_REQUEST: 対象メンションが完了済み
	 *     - BAD_REQUEST: daysFromToday が 0 未満 / 365 超
	 *     - BAD_REQUEST: priority が 0 未満
	 *     - NOT_FOUND: 対象メンションが存在しない
	 *     - INTERNAL: Slack chat.postMessage 失敗
	 */
	renewTaigaSlackMention: RenewTaigaSlackMentionResponse
	reopenKnownIssues: ReopenKnownIssuesResponse
	/**
	 * マイルストーンの並び順を変更する。
	 * ドラッグ&ドロップで並び替えた結果の ID 配列を受け取り、
	 * priority を 1, 2, 3... と振り直す（上にあるほど高優先）。
	 * - milestoneIds にはシート内の全マイルストーン ID を含める必要がある
	 * - [error]
	 *     - UNAUTHORIZED: ServiceToken validation failed
	 *     - PERMISSION_DENIED: ServiceToken does not have SouhlAdmin permission
	 *     - BAD_REQUEST: milestoneIds が不完全（シート内の全マイルストーン ID と一致しない）
	 */
	reorderTaigaMilestones: ReorderTaigaMilestonesResponse
	/**
	 * 同一親内でノードの並び順を変更する。
	 * ドラッグ&ドロップで並び替えた結果の ID 配列を受け取り、order を振り直す。
	 * - nodeIds には同一親配下の全ノード ID を含める必要がある
	 * - [error]
	 *     - UNAUTHORIZED: ServiceToken validation failed
	 *     - PERMISSION_DENIED: ServiceToken does not have SouhlAdmin permission
	 *     - BAD_REQUEST: nodeIds が不完全、または異なる親のノードが混在
	 */
	reorderTaigaNodes: ReorderTaigaNodesResponse
	requestTaskReview: RequestTaskReviewResponse
	resolveKnownIssues: ResolveKnownIssuesResponse
	sendClaimingCancelFeeReminderSoon: SendClaimingCancelFeeReminderSoonResponse
	/**
	 * Slack メンションの要アクション期限を設定する。
	 * due_date を「今日 + daysFromToday 日後」に更新する。
	 * daysFromToday は 0（= 今日）以上 365 以下。
	 * - [error]
	 *     - UNAUTHORIZED: ServiceToken validation failed
	 *     - PERMISSION_DENIED: ServiceToken does not have SouhlAdmin permission
	 *     - PERMISSION_DENIED: 自分以外の user_id を持つメンションを操作した
	 *     - NOT_FOUND: 指定 id のメンションが存在しない
	 *     - BAD_REQUEST: daysFromToday が 0 未満または 365 超
	 */
	setTaigaSlackMentionDueDate: SetTaigaSlackMentionDueDateResponse
	/**
	 * マイルストーン内の全ノードを parallel_priority 昇順にソートする。
	 * 各階層（ルートノード、各親ノードの子ノード）の兄弟グループがそれぞれ独立してソートされる。
	 * parallel_priority が未設定のノードは末尾に配置される。
	 * 1トランザクションで全ノードの order を一括更新する（FOR UPDATE でロック取得）。
	 * アーカイブ済みノードはソート対象外。
	 * - [error]
	 *     - UNAUTHORIZED: ServiceToken validation failed
	 *     - PERMISSION_DENIED: ServiceToken does not have SouhlAdmin permission
	 *     - NOT_FOUND: Milestone with specified milestoneId does not exist
	 */
	sortTaigaMilestoneNodes: SortTaigaMilestoneNodesResponse
	/**
	 * 認証ユーザーの Slack メンションを同期実行する (FE の「今すぐ更新」ボタン用)。
	 * hourly job と同じ処理を呼び出すため Slack API を叩く同期処理。
	 * - SlackUserToTaigaUserID にマッピングが無い認証ユーザーは upsertedCount=0 を返して何もしない
	 * - [error]
	 *     - UNAUTHORIZED: ServiceToken validation failed
	 *     - PERMISSION_DENIED: ServiceToken does not have SouhlAdmin permission
	 *     - INTERNAL: Slack search.messages / users.info / DB 書き込み失敗
	 */
	syncTaigaSlackMentions: SyncTaigaSlackMentionsResponse
	toggleFeatureFlags: ToggleFeatureFlagsResponse
	/**
	 * Slack mention の node ツリー全体の開閉状態をトグルする。
	 * is_child_nodes_collapsed を反転 (true ↔ false) する。
	 * FE は MentionRow の「▸ N nodes」アコーディオン開閉時にこの mutation を発行する。
	 * - [error]
	 *     - UNAUTHORIZED: ServiceToken validation failed
	 *     - PERMISSION_DENIED: ServiceToken does not have SouhlAdmin permission
	 *     - PERMISSION_DENIED: 呼び出しユーザー != 対象 Slack mention の user_id
	 *     - NOT_FOUND: 指定 id のメンションが存在しない
	 */
	toggleTaigaSlackMentionChildNodesCollapsed: ToggleTaigaSlackMentionChildNodesCollapsedResponse
	/**
	 * アーカイブされたマイルストーンを復元する。
	 * - [error]
	 *     - UNAUTHORIZED: ServiceToken validation failed
	 *     - PERMISSION_DENIED: ServiceToken does not have SouhlAdmin permission
	 *     - NOT_FOUND: Milestone with specified id does not exist
	 *     - BAD_REQUEST: アーカイブされていない
	 */
	unarchiveTaigaMilestone: UnarchiveTaigaMilestoneResponse
	/**
	 * アーカイブされたシートを復元する。
	 * - [error]
	 *     - UNAUTHORIZED: ServiceToken validation failed
	 *     - PERMISSION_DENIED: ServiceToken does not have SouhlAdmin permission
	 *     - NOT_FOUND: Sheet with specified id does not exist
	 *     - BAD_REQUEST: アーカイブされていない
	 */
	unarchiveTaigaSheet: UnarchiveTaigaSheetResponse
	uncompleteTask: UncompleteTaskResponse
	updateChannelGroupMemo: UpdateChannelGroupMemoResponse
	updateCompany: UpdateCompanyResponse
	updateCompanyCommissionRates: UpdateCompanyCommissionRatesResponse
	updateCompanyHubspotContractIDs: UpdateCompanyHubspotContractIDsResponse
	updateCompanySmsSendingRuleV2: UpdateCompanySmsSendingRuleV2Response
	updateDataSourceLoginCredentials: UpdateDataSourceLoginCredentialsResponse
	updateDataSourceLoginCredentialsForSameStoreId: UpdateDataSourceLoginCredentialsForSameStoreIdResponse
	updateDraftMessage: UpdateDraftMessageResponse
	updateKnownIssue: UpdateKnownIssueResponse
	updateLineGroupAndCompanyMappings: UpdateLineGroupAndCompanyMappingsResponse
	updateSalonAndCompanySmsSendingRuleMappings: UpdateSalonAndCompanySmsSendingRuleMappingsResponse
	updateSalonDataSourcePolicyMemo: UpdateSalonDataSourcePolicyMemoResponse
	updateSalonGoalDataSourcePolicies: UpdateSalonGoalDataSourcePoliciesResponse
	updateSalonSmsSendingStartSettings: UpdateSalonSmsSendingStartSettingsResponse
	updateSalonUsageStartDate: UpdateSalonUsageStartDateResponse
	updateSlackUser: UpdateSlackUserResponse
	/**
	 * マイルストーンの名前・折りたたみ状態を更新する。
	 * 変更しないフィールドは現在の値をそのまま渡す。
	 * - [error]
	 *     - UNAUTHORIZED: ServiceToken validation failed
	 *     - PERMISSION_DENIED: ServiceToken does not have SouhlAdmin permission
	 *     - NOT_FOUND: Milestone with specified id does not exist
	 */
	updateTaigaMilestone: UpdateTaigaMilestoneResponse
	/**
	 * ノードの名前を更新する。
	 * 変更しない場合は現在の値をそのまま渡す。
	 * - [error]
	 *     - UNAUTHORIZED: ServiceToken validation failed
	 *     - PERMISSION_DENIED: ServiceToken does not have SouhlAdmin permission
	 *     - NOT_FOUND: Node with specified id does not exist
	 */
	updateTaigaNode: UpdateTaigaNodeResponse
	/**
	 * セッションのメモを更新する。
	 * memo が null または空文字の場合はメモをクリア（NULL に更新）する。
	 * memo は 2000 文字以内であること。
	 * - [error]
	 *     - UNAUTHORIZED: ServiceToken validation failed
	 *     - PERMISSION_DENIED: ServiceToken does not have SouhlAdmin permission
	 *     - NOT_FOUND: 指定された node に session が存在しない
	 *     - BAD_REQUEST: memo が 2000 文字を超過
	 */
	updateTaigaSessionMemo: UpdateTaigaSessionMemoResponse
	/**
	 * セッションのステータスをユーザー操作で更新する。
	 * 主に PENDING 状態への変更に使用する。
	 * - [error]
	 *     - UNAUTHORIZED: ServiceToken validation failed
	 *     - PERMISSION_DENIED: ServiceToken does not have SouhlAdmin permission
	 *     - NOT_FOUND: 指定された node に session が存在しない
	 */
	updateTaigaSessionStatus: UpdateTaigaSessionStatusResponse
	/**
	 * シート名を更新する。
	 * - [error]
	 *     - UNAUTHORIZED: ServiceToken validation failed
	 *     - PERMISSION_DENIED: ServiceToken does not have SouhlAdmin permission
	 *     - NOT_FOUND: Sheet with specified id does not exist
	 */
	updateTaigaSheet: UpdateTaigaSheetResponse
	/**
	 * Slack メンションのコメントを更新する。
	 * trimSpace して保存する。空文字はそのまま空文字として保存される（text へのリセットは行わない）。
	 * - [error]
	 *     - UNAUTHORIZED: ServiceToken validation failed
	 *     - PERMISSION_DENIED: ServiceToken does not have SouhlAdmin permission
	 *     - PERMISSION_DENIED: 自分以外の user_id を持つメンションを操作した
	 *     - NOT_FOUND: 指定 id のメンションが存在しない
	 */
	updateTaigaSlackMentionComment: UpdateTaigaSlackMentionCommentResponse
	updateTask: UpdateTaskResponse
	updateTaskKind: UpdateTaskKindResponse
	updateTaskTag: UpdateTaskTagResponse
	updateUenoClinicInputSheet: UpdateUenoClinicInputSheetResponse
	uploadSlackThreadFile: UploadSlackThreadFileResponse
	upsertSalonUsers: UpsertSalonUsersResponse
	verifyDataSourceLoginCredentials: VerifyDataSourceLoginCredentialsResponse
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationAlertSalonScrapingJobsNotFinishedArgs = {
	input: AlertSalonScrapingJobsNotFinishedInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationApproveDraftDataSourceEquipmentMappingsArgs = {
	input: ApproveDraftDataSourceEquipmentMappingsInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationApproveDraftDataSourceStaffMappingsArgs = {
	input: ApproveDraftDataSourceStaffMappingsInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationArchiveTaigaMilestoneArgs = {
	input: ArchiveTaigaMilestoneInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationArchiveTaigaNodeArgs = {
	input: ArchiveTaigaNodeInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationArchiveTaigaSheetArgs = {
	input: ArchiveTaigaSheetInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationAttachTaigaSlackThreadArgs = {
	input: AttachTaigaSlackThreadInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationBulkUpdateInvoiceSettlementStatusesArgs = {
	input: BulkUpdateInvoiceSettlementStatusesInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationBulkUpdatePayoutSettlementStatusesArgs = {
	input: BulkUpdatePayoutSettlementStatusesInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationBulkUpsertChannelGroupsAndLineWorksGroupsArgs = {
	input: BulkUpsertChannelGroupsAndLineWorksGroupsInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationClearTaskNeedsActionArgs = {
	input: ClearTaskNeedsActionInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationCloseKnownIssuesArgs = {
	input: CloseKnownIssuesInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationCompleteTaigaSessionArgs = {
	input: CompleteTaigaSessionInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationCompleteTaigaSlackMentionArgs = {
	input: CompleteTaigaSlackMentionInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationCompleteTaskArgs = {
	input: CompleteTaskInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationConfigureCancySalonArgs = {
	input: ConfigureCancySalonInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationCreateChannelGroupMemoArgs = {
	input: CreateChannelGroupMemoInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationCreateCompanyArgs = {
	input: CreateCompanyInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationCreateCompanySalonMappingArgs = {
	input: CreateCompanySalonMappingInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationCreateCompanySmsSendingRuleV2Args = {
	input: CreateCompanySmsSendingRuleV2Input
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationCreateDataSourceStaffMappingArgs = {
	input: CreateDataSourceStaffMappingInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationCreateDefaultCompanySmsSendingRuleV2Args = {
	input: CreateDefaultCompanySmsSendingRuleV2Input
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationCreateDraftMessageArgs = {
	input: CreateDraftMessageInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationCreateKnownIssueArgs = {
	input: CreateKnownIssueInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationCreateKpiCancelCsvArgs = {
	input: CreateKpiCancelCsvInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationCreateSalonArgs = {
	input: CreateSalonInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationCreateSettlementArgs = {
	input: CreateSettlementInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationCreateSlackUserArgs = {
	input: CreateSlackUserInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationCreateTaigaMilestoneArgs = {
	input: CreateTaigaMilestoneInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationCreateTaigaNodeArgs = {
	input: CreateTaigaNodeInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationCreateTaigaNodeUnderSlackMentionArgs = {
	input: CreateTaigaNodeUnderSlackMentionInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationCreateTaigaSessionArgs = {
	input: CreateTaigaSessionInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationCreateTaigaSheetArgs = {
	input: CreateTaigaSheetInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationCreateTaigaSlackMentionArgs = {
	input: CreateTaigaSlackMentionInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationCreateTaskArgs = {
	input: CreateTaskInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationCreateTaskKindArgs = {
	input: CreateTaskKindInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationCreateTaskTagArgs = {
	input: CreateTaskTagInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationDeactivateChannelGroupMemoArgs = {
	input: DeactivateChannelGroupMemoInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationDeactivateDraftMessageArgs = {
	input: DeactivateDraftMessageInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationDeleteTaskKindArgs = {
	input: DeleteTaskKindInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationDeleteTaskTagArgs = {
	input: DeleteTaskTagInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationEnqueueLongScrapingJobsArgs = {
	input: EnqueueLongScrapingJobsInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationEnqueueSendAccountingEmailsBySettlementIDsArgs = {
	input: EnqueueSendAccountingEmailsBySettlementIDsInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationEnqueueSendingGiftEmailsArgs = {
	input: EnqueueSendingGiftEmailsInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationEnqueueSyncLineWorksMessagesArgs = {
	param: EnqueueSyncLineWorksMessagesParam
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationForkTaigaSessionArgs = {
	input: ForkTaigaSessionInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationGenerateFinLoginUrlArgs = {
	input: GenerateFinLoginUrlInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationGetDataSourceLoginPasswordArgs = {
	input: GetDataSourceLoginPasswordInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationHandOverTaigaEmbedSessionArgs = {
	input: HandOverTaigaEmbedSessionInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationHideUnknownIssueLogsArgs = {
	input: HideUnknownIssueLogsInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationManuallyImportAllAnalysisCancelsArgs = {
	input: ManuallyImportAllAnalysisCancelsInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationMarkTaskNeedsReplyArgs = {
	input: MarkTaskNeedsReplyInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationMarkTaskWaitingReplyArgs = {
	input: MarkTaskWaitingReplyInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationMoveTaigaNodeArgs = {
	input: MoveTaigaNodeInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationPostSlackThreadMessageArgs = {
	input: PostSlackThreadMessageInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationPriorityDownTaigaNodeArgs = {
	input: PriorityDownTaigaNodeInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationPriorityDownTaigaSlackMentionArgs = {
	input: PriorityDownTaigaSlackMentionInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationPriorityUpTaigaNodeArgs = {
	input: PriorityUpTaigaNodeInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationPriorityUpTaigaSlackMentionArgs = {
	input: PriorityUpTaigaSlackMentionInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationRegisterGiftUrlsArgs = {
	input: RegisterGiftUrlsInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationRenewTaigaSlackMentionArgs = {
	input: RenewTaigaSlackMentionInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationReopenKnownIssuesArgs = {
	input: ReopenKnownIssuesInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationReorderTaigaMilestonesArgs = {
	input: ReorderTaigaMilestonesInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationReorderTaigaNodesArgs = {
	input: ReorderTaigaNodesInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationRequestTaskReviewArgs = {
	input: RequestTaskReviewInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationResolveKnownIssuesArgs = {
	input: ResolveKnownIssuesInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationSendClaimingCancelFeeReminderSoonArgs = {
	input: SendClaimingCancelFeeReminderSoonInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationSetTaigaSlackMentionDueDateArgs = {
	input: SetTaigaSlackMentionDueDateInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationSortTaigaMilestoneNodesArgs = {
	input: SortTaigaMilestoneNodesInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationSyncTaigaSlackMentionsArgs = {
	input: SyncTaigaSlackMentionsInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationToggleFeatureFlagsArgs = {
	input: ToggleFeatureFlagsInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationToggleTaigaSlackMentionChildNodesCollapsedArgs = {
	input: ToggleTaigaSlackMentionChildNodesCollapsedInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationUnarchiveTaigaMilestoneArgs = {
	input: UnarchiveTaigaMilestoneInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationUnarchiveTaigaSheetArgs = {
	input: UnarchiveTaigaSheetInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationUncompleteTaskArgs = {
	input: UncompleteTaskInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationUpdateChannelGroupMemoArgs = {
	input: UpdateChannelGroupMemoInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationUpdateCompanyArgs = {
	input: UpdateCompanyInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationUpdateCompanyCommissionRatesArgs = {
	input: UpdateCompanyCommissionRatesInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationUpdateCompanyHubspotContractIDsArgs = {
	input: UpdateCompanyHubspotContractIDsInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationUpdateCompanySmsSendingRuleV2Args = {
	input: UpdateCompanySmsSendingRuleV2Input
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationUpdateDataSourceLoginCredentialsArgs = {
	input: DataSourceLoginCredentialsInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationUpdateDataSourceLoginCredentialsForSameStoreIdArgs = {
	input: UpdateDataSourceLoginCredentialsForSameStoreIdInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationUpdateDraftMessageArgs = {
	input: UpdateDraftMessageInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationUpdateKnownIssueArgs = {
	input: UpdateKnownIssueInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationUpdateLineGroupAndCompanyMappingsArgs = {
	input: UpdateLineGroupAndCompanyMappingsInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationUpdateSalonAndCompanySmsSendingRuleMappingsArgs = {
	input: UpdateSalonAndCompanySmsSendingRuleMappingsInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationUpdateSalonDataSourcePolicyMemoArgs = {
	input: UpdateSalonDataSourcePolicyMemoInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationUpdateSalonGoalDataSourcePoliciesArgs = {
	input: UpdateSalonGoalDataSourcePoliciesInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationUpdateSalonSmsSendingStartSettingsArgs = {
	input: UpdateSalonSmsSendingStartSettingsInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationUpdateSalonUsageStartDateArgs = {
	input: UpdateSalonUsageStartDateInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationUpdateSlackUserArgs = {
	input: UpdateSlackUserInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationUpdateTaigaMilestoneArgs = {
	input: UpdateTaigaMilestoneInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationUpdateTaigaNodeArgs = {
	input: UpdateTaigaNodeInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationUpdateTaigaSessionMemoArgs = {
	input: UpdateTaigaSessionMemoInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationUpdateTaigaSessionStatusArgs = {
	input: UpdateTaigaSessionStatusInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationUpdateTaigaSheetArgs = {
	input: UpdateTaigaSheetInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationUpdateTaigaSlackMentionCommentArgs = {
	input: UpdateTaigaSlackMentionCommentInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationUpdateTaskArgs = {
	input: UpdateTaskInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationUpdateTaskKindArgs = {
	input: UpdateTaskKindInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationUpdateTaskTagArgs = {
	input: UpdateTaskTagInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationUpdateUenoClinicInputSheetArgs = {
	input: UpdateUenoClinicInputSheetInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationUploadSlackThreadFileArgs = {
	input: UploadSlackThreadFileInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationUpsertSalonUsersArgs = {
	input: UpsertSalonUsersInput
}

/** souhl admin 権限でない場合は 403 を返す */
export type MutationVerifyDataSourceLoginCredentialsArgs = {
	input: DataSourceLoginCredentialsInput
}

/** oldestActiveTaskMessageTime Query のレスポンス */
export type OldestActiveTaskMessageTimeResponse = {
	/** 未完了タスクを持つ line group の最古「最新メッセージ時刻」(RFC3339)。ipass再連携 種別のタスクは除外。該当なしなら null */
	oldestMessageCreateTime: Maybe<Scalars["DateTime"]["output"]>
}

/**
 * policy が持つ template を 1 通分レンダリングした結果。
 * sending_count は 1-indexed の送信回 (1 = 1 通目)。
 */
export type PolicyMessagePreview = {
	message: Scalars["String"]["output"]
	sendingCount: Scalars["Int"]["output"]
}

/**
 * タスクに紐づく Slack スレッドへ返信を投稿する。
 * primary bot (Nexus) の chat.postMessage (thread_ts 指定) を proxy する。
 * 操作者（Cognito sub → slack_users の表示名）を本文の先頭に "[表示名] " として付与する。
 * - [error]
 *     - PERMISSION_DENIED: souhl_admin でないユーザーがアクセスした場合
 *     - NOT_FOUND: (channelId, threadTs) が task_slack_threads に存在しない場合
 *     - BAD_REQUEST: text が空白のみ、または 4000 文字を超える場合
 *     - PRECONDITION_FAILED: primary bot (Nexus) 自身がチャンネル未参加の場合
 */
export type PostSlackThreadMessageInput = {
	/** Slack チャンネル ID */
	channelId: Scalars["String"]["input"]
	/** 投稿本文（plain text。mrkdwn エスケープは BE で行う） */
	text: Scalars["String"]["input"]
	/** スレッド親メッセージの ts */
	threadTs: Scalars["String"]["input"]
}

/** postSlackThreadMessage のレスポンス */
export type PostSlackThreadMessageResponse = {
	/** 投稿されたメッセージの ts（optimistic UI の置き換えキー） */
	ts: Scalars["String"]["output"]
}

export type PriorityDownTaigaNodeInput = {
	/** 対象ノード ID。自身 + 配下の全子孫ノードの parallelPriority を +1 する（= 優先度を下げる）。 */
	nodeId: Scalars["String"]["input"]
}

export type PriorityDownTaigaNodeResponse = {
	/** parallelPriority が更新されたノード一覧 */
	updatedNodes: Array<TaigaNode>
}

export type PriorityDownTaigaSlackMentionInput = {
	/** 対象メンション ID */
	id: Scalars["String"]["input"]
}

export type PriorityDownTaigaSlackMentionResponse = {
	mention: TaigaSlackMention
}

export type PriorityUpTaigaNodeInput = {
	/** 対象ノード ID。自身 + 配下の全子孫ノードの parallelPriority を -1 する（= 優先度を上げる）。 */
	nodeId: Scalars["String"]["input"]
}

export type PriorityUpTaigaNodeResponse = {
	/** parallelPriority が更新されたノード一覧 */
	updatedNodes: Array<TaigaNode>
}

export type PriorityUpTaigaSlackMentionInput = {
	/** 対象メンション ID */
	id: Scalars["String"]["input"]
}

export type PriorityUpTaigaSlackMentionResponse = {
	mention: TaigaSlackMention
}

export type Query = {
	bizdevHealth: BizdevHealthResponse
	/**
	 * CancelType の一覧と表示用テキストを返す。
	 * rule の更新日降順で返す
	 */
	cancelTypeTexts: Array<CancelTypeText>
	/**
	 * DO NOT call this query.
	 * this field is not for executing query, but only for showing possible UserErrorCode enum value to frontend client.
	 */
	cancyCompanyAdminSubgraphUserErrorCode: CancyCompanyAdminSubgraphUserErrorCode
	channelGroupMemos: ChannelGroupMemosResponse
	/**
	 * cancel_id ごとの請求 reminder の現在状態を返す (存在しない cancel_id は結果に含めない)。
	 * 架電バッチが発信直前に「支払い済み・中止済みでないか」を確認する用途。
	 */
	claimingCancelFeeReminderStatuses: Array<ClaimingCancelFeeReminderStatus>
	companies: CompaniesResponse
	company: CompanyResponse
	companyBySalonId: CompanyBySalonIdResponse
	companyFeatureFlags: CompanyFeatureFlagsResponse
	companySmsSendingRulesV2: CompanySmsSendingRulesV2Response
	completedTasks: CompletedTasksResponse
	dataSourceColumns: DataSourceColumnsResponse
	dataSourcePolicyOptions: Array<DataSourcePolicyWithText>
	featureFlags: FeatureFlagsResponse
	getCompanyCommissionRateChangeHistories: GetCompanyCommissionRateChangeHistoriesResponse
	getCompanyCommissionRates: GetCompanyCommissionRatesResponse
	hello: Scalars["String"]["output"]
	knownIssue: KnownIssueResponse
	knownIssueDaySummaries: KnownIssueDaySummariesResponse
	knownIssueDaySummary: KnownIssueDaySummaryResponse
	knownIssues: KnownIssuesResponse
	lineWorksGroups: LineWorksGroupsResponse
	/**
	 * タスク / 下書きの最終更新時刻を返す軽量 query。
	 * Chrome 拡張が 5 秒ポーリングし、前回と異なれば全データ refetch する。
	 */
	lineWorksGroupsSyncTime: LineWorksGroupsSyncTimeResponse
	/**
	 * 指定 lineGroupId の LINE Works メッセージと channel_messages.id の対応を直近 100 件返す
	 * (固定 limit、 順序は line_works_messages.line_message_create_time ASC)。右クリックメニューで
	 * line message id から channel_message_id を解決するために使う。
	 * - [error]
	 *     - PERMISSION_DENIED: souhl_admin でないユーザーがアクセスした場合
	 */
	lineWorksMessages: LineWorksMessagesResponse
	/**
	 * 未完了タスクを持つ line group の中で、最も古い「最新メッセージ時刻」を返す。
	 * ipass再連携 種別の未完了タスクは「未完了タスクを持つ」判定から除外する (長く open になりがちなため)。
	 * autoScroll の停止判定に使う軽量 query。
	 */
	oldestActiveTaskMessageTime: OldestActiveTaskMessageTimeResponse
	salonUsers: GetSalonUsersResponse
	scheduledReminderPolicyPreviewsSinceYesterday: ScheduledReminderPolicyPreviewsSinceYesterdayResponse
	/**
	 * Slack チャンネル ID + スレッド ts を直接指定して、
	 * スレッド内で最も新しいメッセージの ts を返す。
	 * taiga ノードに紐づかないスレッド（bizdev 等）でも利用可能。
	 * - [error]
	 *     - UNAUTHORIZED: ServiceToken validation failed
	 *     - PERMISSION_DENIED: ServiceToken does not have SouhlAdmin permission
	 */
	slackLatestReplyTs: SlackLatestReplyTsResponse
	slackMentionTargets: SlackMentionTargetsResponse
	slackThreadFileContent: SlackThreadFileContentResponse
	slackThreadMembers: SlackThreadMembersResponse
	slackThreadMessages: SlackThreadMessagesResponse
	/**
	 * Slack スレッド (channelId, threadTs) 指定で cc-server セッションの最新ステータスを取得する。
	 * LINE WORKS 拡張が LINE グループカード内タスク行の「AI作業中」表示のために 3 秒ポーリングで使用する。
	 * taiga_sessions を (channel_id, thread_ts) ペアで引き、node (taiga_nodes) が is_done = true のものは除外する。
	 * - [error]
	 *     - UNAUTHORIZED: ServiceToken validation failed
	 *     - PERMISSION_DENIED: souhl_admin でないユーザーがアクセスした場合
	 *     - BAD_REQUEST: threads が空、または 100 件を超える場合
	 */
	slackThreadSessionStatuses: SlackThreadSessionStatusesResponse
	slackUsers: SlackUsersResponse
	/**
	 * Adhoc milestone 配下のアクティブなノード ID 一覧を取得する。
	 * フロントエンドの 10秒ポーリング用。前回取得時と比較してノード ID に変化があれば
	 * taigaSheet を refetch して UI を更新する。
	 * adhoc milestone が存在しない場合は空配列を返す。
	 * - [error]
	 *     - UNAUTHORIZED: ServiceToken validation failed
	 *     - PERMISSION_DENIED: ServiceToken does not have SouhlAdmin permission
	 */
	taigaAdhocMilestoneNodeIds: TaigaAdhocMilestoneNodeIdsResponse
	/**
	 * 指定したノードの Slack スレッド内で最も新しいメッセージの ts を返す。
	 * フロントエンドは、この ts を使って Slack リンクを構築し、
	 * スレッドの最新メッセージにフォーカスさせる。
	 * - [error]
	 *     - UNAUTHORIZED: ServiceToken validation failed
	 *     - PERMISSION_DENIED: ServiceToken does not have SouhlAdmin permission
	 *     - NOT_FOUND: セッションが存在しないノード
	 */
	taigaLatestThreadTs: TaigaLatestThreadTsResponse
	/**
	 * 指定したノードの Slack スレッドから "PR: <URL>\nBranch:\n`<branch>`" 形式の
	 * メッセージを最新側から探し、抽出した branch 名を返す。
	 * "Branch:" の直後の改行はあってもなくてもよい。
	 * 該当メッセージが見つからなければ branchName は null を返す。
	 * - [error]
	 *     - UNAUTHORIZED: ServiceToken validation failed
	 *     - PERMISSION_DENIED: ServiceToken does not have SouhlAdmin permission
	 *     - NOT_FOUND: セッションが存在しないノード
	 */
	taigaSessionBranchName: TaigaSessionBranchNameResponse
	/**
	 * 指定したノードのセッションステータスを一括取得する。
	 * フロントエンドの 3秒ポーリング用。変更があったもののみ返すのではなく、
	 * 指定された全ノードのセッション最新ステータスを返す。
	 * セッションが存在しないノード ID は結果に含まれない。
	 * - [error]
	 *     - UNAUTHORIZED: ServiceToken validation failed
	 *     - PERMISSION_DENIED: ServiceToken does not have SouhlAdmin permission
	 */
	taigaSessionStatuses: TaigaSessionStatusesResponse
	/**
	 * シート詳細を取得する。
	 * マイルストーン (priority 昇順) と全ノードツリーを含む。
	 * フロントエンドの Sheet Detail 画面の初期ロードに使用する。
	 * - [error]
	 *     - UNAUTHORIZED: ServiceToken validation failed
	 *     - PERMISSION_DENIED: ServiceToken does not have SouhlAdmin permission
	 *     - NOT_FOUND: Sheet with specified id does not exist
	 */
	taigaSheet: TaigaSheetResponse
	/**
	 * シート一覧を取得する。
	 * ログインユーザーが作成したシートのみ返す。updateTime 降順でソート。
	 * - param.includeArchived で archive 済みシートの表示を切り替え可能
	 * - [error]
	 *     - UNAUTHORIZED: ServiceToken validation failed
	 *     - PERMISSION_DENIED: ServiceToken does not have SouhlAdmin permission
	 */
	taigaSheets: TaigaSheetsResponse
	/**
	 * Slack メンション最終同期時刻を取得する。
	 * - param.userId 省略時は認証ユーザー自身の sync_state を返す
	 * - param.userId 指定時はそのユーザーの sync_state を返す
	 * 「最終同期: N 分前」表示で使用する。
	 * - [error]
	 *     - UNAUTHORIZED: ServiceToken validation failed
	 *     - PERMISSION_DENIED: ServiceToken does not have SouhlAdmin permission
	 *     - NOT_FOUND: 対象ユーザーの sync_state が DB に存在しない（マッピング登録されていない場合など）
	 */
	taigaSlackMentionSyncState: TaigaSlackMentionSyncStateResponse
	/**
	 * Slack メンション一覧を取得する。
	 * - param.userId 省略時は認証ユーザー自身のメンションを返す
	 * - param.userId 指定時はそのユーザー宛のメンションを返す（read-only ビュー用）
	 * - is_done = true のレコードは返さない
	 * - slack_message_time 降順（新しいメンションが先頭）でソート
	 * - SlackUserToTaigaUserID にマッピングが無いユーザーには空配列を返す
	 * - [error]
	 *     - UNAUTHORIZED: ServiceToken validation failed
	 *     - PERMISSION_DENIED: ServiceToken does not have SouhlAdmin permission
	 */
	taigaSlackMentions: TaigaSlackMentionsResponse
	taskKinds: TaskKindsResponse
	taskTags: TaskTagsResponse
	unknownIssueLogs: UnknownIssueLogsResponse
}

export type QueryBizdevHealthArgs = {
	param: BizdevHealthParam
}

export type QueryChannelGroupMemosArgs = {
	param: ChannelGroupMemosParam
}

export type QueryClaimingCancelFeeReminderStatusesArgs = {
	cancelIds: Array<Scalars["String"]["input"]>
}

export type QueryCompanyArgs = {
	param: CompanyParam
}

export type QueryCompanyBySalonIdArgs = {
	param: CompanyBySalonIdParam
}

export type QueryCompanyFeatureFlagsArgs = {
	param: CompanyFeatureFlagsParam
}

export type QueryCompanySmsSendingRulesV2Args = {
	companyId: Scalars["String"]["input"]
}

export type QueryCompletedTasksArgs = {
	param: CompletedTasksParam
}

export type QueryDataSourceColumnsArgs = {
	param: DataSourceColumnsParam
}

export type QueryDataSourcePolicyOptionsArgs = {
	param: DataSourcePolicyOptionsParam
}

export type QueryFeatureFlagsArgs = {
	param: FeatureFlagsParam
}

export type QueryGetCompanyCommissionRateChangeHistoriesArgs = {
	param: GetCompanyCommissionRateChangeHistoriesParam
}

export type QueryGetCompanyCommissionRatesArgs = {
	param: GetCompanyCommissionRatesParam
}

export type QueryKnownIssueArgs = {
	id: Scalars["String"]["input"]
}

export type QueryKnownIssueDaySummariesArgs = {
	ids: Array<Scalars["String"]["input"]>
}

export type QueryKnownIssueDaySummaryArgs = {
	id: Scalars["String"]["input"]
}

export type QueryKnownIssuesArgs = {
	param: InputMaybe<KnownIssuesParam>
}

export type QueryLineWorksGroupsArgs = {
	param: LineWorksGroupsParam
}

export type QueryLineWorksMessagesArgs = {
	param: LineWorksMessagesParam
}

export type QuerySalonUsersArgs = {
	param: GetSalonUsersParam
}

export type QueryScheduledReminderPolicyPreviewsSinceYesterdayArgs = {
	param: ScheduledReminderPolicyPreviewsSinceYesterdayParam
}

export type QuerySlackLatestReplyTsArgs = {
	param: SlackLatestReplyTsParam
}

export type QuerySlackThreadFileContentArgs = {
	param: SlackThreadFileContentParam
}

export type QuerySlackThreadMembersArgs = {
	param: SlackThreadMembersParam
}

export type QuerySlackThreadMessagesArgs = {
	param: SlackThreadMessagesParam
}

export type QuerySlackThreadSessionStatusesArgs = {
	param: SlackThreadSessionStatusesParam
}

export type QuerySlackUsersArgs = {
	param: SlackUsersParam
}

export type QueryTaigaAdhocMilestoneNodeIdsArgs = {
	param: TaigaAdhocMilestoneNodeIdsParam
}

export type QueryTaigaLatestThreadTsArgs = {
	param: TaigaLatestThreadTsParam
}

export type QueryTaigaSessionBranchNameArgs = {
	param: TaigaSessionBranchNameParam
}

export type QueryTaigaSessionStatusesArgs = {
	param: TaigaSessionStatusesParam
}

export type QueryTaigaSheetArgs = {
	param: TaigaSheetParam
}

export type QueryTaigaSheetsArgs = {
	param: TaigaSheetsParam
}

export type QueryTaigaSlackMentionSyncStateArgs = {
	param: TaigaSlackMentionSyncStateParam
}

export type QueryTaigaSlackMentionsArgs = {
	param: TaigaSlackMentionsParam
}

export type QueryTaskKindsArgs = {
	param: TaskKindsParam
}

export type QueryTaskTagsArgs = {
	param: TaskTagsParam
}

export type QueryUnknownIssueLogsArgs = {
	param: InputMaybe<UnknownIssueLogsParam>
}

/** RGB カラー値。各チャネルは 0〜255 の整数。 */
export type Rgb = {
	/** 青（0〜255） */
	b: Scalars["Int"]["output"]
	/** 緑（0〜255） */
	g: Scalars["Int"]["output"]
	/** 赤（0〜255） */
	r: Scalars["Int"]["output"]
}

/** RGB カラー値の入力型。各チャネルは 0〜255 の整数。 */
export type RgbInput = {
	/** 青（0〜255） */
	b: Scalars["Int"]["input"]
	/** 緑（0〜255） */
	g: Scalars["Int"]["input"]
	/** 赤（0〜255） */
	r: Scalars["Int"]["input"]
}

/**
 * 指定した金額(price)のクーポンURLを、未割当在庫として登録する。発行元(publisher)はURLごとに指定する。
 * 登録したURLは enqueueSendingGiftEmails でcancel_idに割り当てられ、顧客に送付される。
 *
 * giftUrls が空配列の場合はエラーにせず、空の結果を返す。
 * 既に登録済みのURL・同一リクエスト内で重複しているURLは、エラーにせず黙ってスキップする
 * (同じCSVを2回流しても安全にするため。スキップしたURLは skippedGiftUrls に入る)。
 * - [error]
 *     - BAD_REQUEST: price が0以下、gift_url が https:// で始まらない、expireDate が過去日
 *       のいずれかに該当する行が1件でも含まれる場合
 *       (この場合、1件もDBに登録されない)
 */
export type RegisterGiftUrlsInput = {
	/** 登録するURL一覧 */
	giftUrls: Array<GiftUrlInput>
	/** 登録するURLの金額（円）。このリクエストで登録する全URLに同じ値が入る */
	price: Scalars["Int"]["input"]
}

/** URL在庫登録の結果 */
export type RegisterGiftUrlsResponse = {
	/** 実際に登録されたURL一覧 */
	registeredGiftUrls: Array<Scalars["String"]["output"]>
	/** 既に登録済み（または同一リクエスト内で重複）のためスキップしたURL一覧 */
	skippedGiftUrls: Array<Scalars["String"]["output"]>
}

export type RenewTaigaSlackMentionInput = {
	/** 再投稿先の Slack チャンネル ID。未指定なら default チャンネル（cron の定期 renew は連投がメインチャンネルへ流れないよう専用チャンネルを指定する） */
	channelId?: InputMaybe<Scalars["String"]["input"]>
	/** 新しいメンションの期限。今日から何日後にするか (0 = 今日, 1 = 明日, ...) */
	daysFromToday: Scalars["Int"]["input"]
	/** 作り直す対象メンション ID */
	id: Scalars["String"]["input"]
	/** 新しいメンションの優先度（0 = 最優先） */
	priority: Scalars["Int"]["input"]
}

export type RenewTaigaSlackMentionResponse = {
	/** 作り直して新しく作成されたメンション */
	mention: TaigaSlackMention
	/** 新しいメンションへ付け替えた node 数（root node + embed session の node） */
	movedNodeCount: Scalars["Int"]["output"]
}

/**
 * Reopen known issues (set status from resolved to open).
 * - MANUALLY_RESOLVED または AUTOMATICALLY_RESOLVED の issue を OPEN に戻す
 * - OPEN の issue は変更なし（成功扱い）
 * - CLOSED の issue はエラー
 * - [error]
 *     - UNAUTHORIZED: ServiceToken validation failed
 *     - PERMISSION_DENIED: ServiceToken does not have SouhlAdmin permission
 *     - NOT_FOUND: KnownIssue with specified id does not exist
 *     - BAD_REQUEST: CLOSED の issue は reopen できない
 */
export type ReopenKnownIssuesInput = {
	ids: Array<Scalars["String"]["input"]>
}

export type ReopenKnownIssuesResponse = {
	ids: Array<Scalars["String"]["output"]>
}

/**
 * マイルストーンの並び替え。
 * milestoneIds の順序がそのまま priority (1, 2, 3...) になる。
 * シート内の全マイルストーン ID を含める必要がある。
 */
export type ReorderTaigaMilestonesInput = {
	/** 並び替え後の順序で全マイルストーン ID を指定 */
	milestoneIds: Array<Scalars["String"]["input"]>
	sheetId: Scalars["String"]["input"]
}

export type ReorderTaigaMilestonesResponse = {
	milestones: Array<TaigaMilestone>
}

/**
 * 同一親内でのノード並び替え。
 * nodeIds の順序がそのまま order (1, 2, 3...) になる。
 */
export type ReorderTaigaNodesInput = {
	/** parentNodeId が null の場合に必要。どのマイルストーン直下を並び替えるか。 */
	milestoneId?: InputMaybe<Scalars["String"]["input"]>
	/** 並び替え後の順序で全兄弟ノード ID を指定 */
	nodeIds: Array<Scalars["String"]["input"]>
	/** 並び替え対象ノードの親 ID（null = マイルストーン直下のルートノード群） */
	parentNodeId?: InputMaybe<Scalars["String"]["input"]>
}

export type ReorderTaigaNodesResponse = {
	nodes: Array<TaigaNode>
}

/**
 * タスクのレビューを依頼する（souhl_admin のみ）。
 * 指定された draft_messages の reviewer_slack_user_id を更新する。
 * reviewerSlackUserId が null の場合は reviewer_slack_user_id を解除する。
 * tasks.status は変更しない。
 * - [error]
 *     - UNAUTHORIZED: ServiceToken の検証に失敗する場合
 *     - PERMISSION_DENIED: ServiceToken が SouhlAdmin 権限を持たない場合
 *     - NOT_FOUND: taskId のタスクが存在しない場合
 *     - NOT_FOUND: draftMessageId のドラフトメッセージが存在しない場合
 *     - INVALID_ARGUMENT: draftMessageId が taskId に属さない場合
 *     - NOT_FOUND: reviewerSlackUserId の slack_user が存在しない場合
 */
export type RequestTaskReviewInput = {
	/** レビュー対象のドラフトメッセージ ID（FK → draft_messages.id） */
	draftMessageId: Scalars["ID"]["input"]
	/** レビュワーの Slack User ID（FK → slack_users.id。null = 未設定） */
	reviewerSlackUserId?: InputMaybe<Scalars["String"]["input"]>
	/** 対象タスクの ID */
	taskId: Scalars["ID"]["input"]
}

/** requestTaskReview のレスポンス */
export type RequestTaskReviewResponse = {
	/** 成功した場合は true */
	ok: Scalars["Boolean"]["output"]
}

/**
 * Resolve known issues (set status to manually_resolved).
 * - [error]
 *     - UNAUTHORIZED: ServiceToken validation failed
 *     - PERMISSION_DENIED: ServiceToken does not have SouhlAdmin permission
 *     - NOT_FOUND: KnownIssue with specified id does not exist
 */
export type ResolveKnownIssuesInput = {
	ids: Array<Scalars["String"]["input"]>
}

export type ResolveKnownIssuesResponse = {
	ids: Array<Scalars["String"]["output"]>
}

/**
 * タスクのレビュー状態（draft_messages 由来の computed field）。
 * seq2 (05_fe_foundation_and_left_pane / 2_filter_and_badge) のレビュー状態フィルタ用。
 * 本実装は 04_bizdev_frontend_facing_api / 8_review_status_field で行う予定。
 * 本フィールドは暫定実装（常に NONE を返す）でスキーマ整合性のために定義する。
 */
export type ReviewStatus =
	/** それ以外（draft 無し / reviewer 未アサイン 等） */
	| "NONE"
	/** レビュー後送信済み（レビュー局面が終了し、 outgoing 送信が完了した状態） */
	| "OUTGOING_MESSAGE_SENT_AFTER_REVIEWED"
	/** レビュー待ち（reviewer 設定済み、 まだレビュー結果メッセージが作られてない） */
	| "PENDING_REVIEW"
	/** レビュー済み（送信前。レビュー結果メッセージが作られたが、 顧客には未送信） */
	| "REVIEWED"

/**
 * Role はユーザーの役割を表します
 * - MEMBER: 一般メンバー
 * - ADMIN: 管理者
 * - OWNER: オーナー
 */
export type Role = "ADMIN" | "MEMBER" | "OWNER"

export type Salon = {
	/**
	 * NOTE: Salon は data loader を使用するのに対し、
	 * Salon.applied_company_sms_sending_rule.cancel_type_settings は data loader を使用しないので、
	 * 大量の N+1 が発生してしまうが、現状 FE はこの時 cancel_type_settings を要求しないため、
	 * 実際には N+1 のクエリは発生せず、問題ない
	 */
	appliedCompanySmsSendingRule: Maybe<CompanySmsSendingRuleV2>
	autoClaimBase: CompanySmsSendingRuleAutoClaimBase
	autoClaimStartDate: Maybe<Scalars["Date"]["output"]>
	/**
	 * 設定完了可否。nabeko 内部で以下を判定:
	 * 1. goalDataSourcePolicy 未設定 → false
	 * 2. dataSourcePolicy != goalDataSourcePolicy（差分あり）→ false
	 * 3. 必要な DataSource の接続ステータスが不足 → false
	 * 4. hasIdPassError が1つでもある → false
	 * 5. 上記いずれにも該当しない → true
	 * nabeko に salon が未登録の場合は true を返す。
	 */
	canCompleteSetup: Scalars["Boolean"]["output"]
	/** 設定完了可能か（cancy 側の判定）。デフォルトルール不可 + 自動請求を含むルール適用中は autoClaimStartDate 必須 + 再予約案内を含むルール適用中は encourageStartCancelDate 必須。FE は canCompleteSetup (nabeko 側、媒体設定完了) と AND で使う。 */
	canCompleteSetupBasedOnCancy: Scalars["Boolean"]["output"]
	companyId: Scalars["String"]["output"]
	/** 各媒体の連携状況。DataSource enum の定義順で返却する。connection status が存在する媒体のみ含まれる。スクレイピング実行時に更新される */
	dataSourceConnectionStatuses: Array<DataSourceConnectionStatus>
	/** 現在の媒体設定ポリシー */
	dataSourcePolicy: DataSourcePolicy
	/** 媒体設定メモ（NULL = 未設定） */
	dataSourcePolicyMemo: Maybe<Scalars["String"]["output"]>
	displayName: Scalars["String"]["output"]
	encourageStartCancelDate: Maybe<Scalars["Date"]["output"]>
	/** 目標の媒体設定ポリシー（NULL = 未設定） */
	goalDataSourcePolicy: Maybe<DataSourcePolicy>
	id: Scalars["Int"]["output"]
	name: Scalars["String"]["output"]
	/** 利用開始日。CSM が任意の日付（過去・当日・未来）を設定可能。NULL は未設定。 */
	usageStartDate: Maybe<Scalars["Date"]["output"]>
}

/** 再予約案内設定 */
export type SalonRereservationSettingInput = {
	/** Cloud Beauty かんざし結の再予約促進 URL */
	cloudBeautyKanzashiYuiRereservationUrl?: InputMaybe<
		Scalars["String"]["input"]
	>
	/** ホットペッパービューティー経由の予約のみ再予約促進するかどうか */
	encourageRereservationOnlyForHotPepperRoute: Scalars["Boolean"]["input"]
	/** Salonboard 経由の予約のみ再予約促進するかどうか */
	encourageRereservationOnlyForSalonboard: Scalars["Boolean"]["input"]
	/** 再予約ヘッダー画像 URL */
	headerImageUrl?: InputMaybe<Scalars["String"]["input"]>
	/** アイコン URL */
	iconUrl: Scalars["String"]["input"]
	/** 再予約促進する最大来店回数 */
	maxVisitCountToEncourageRereservation?: InputMaybe<Scalars["Int"]["input"]>
}

/**
 * register_time が前日 00:00 JST 以降に register された scheduled reminder を
 * message_sending_policy_id 単位に集計した結果。
 *
 * - scheduledReminderCount: 同じ policy_id を持つ scheduled reminder の総数
 * - messages: 該当 policy が持つ全 template を、代表 1 件の cancel 実データで整形したメッセージ群
 *   (1 通目 ~ N 通目を sending_count 昇順で並べる)。
 *   URL 部分は <rereservation_url> / <unsubscribe_url> / <payment_url> の placeholder に置換される。
 */
export type ScheduledReminderPolicyPreview = {
	messages: Array<PolicyMessagePreview>
	policyId: Scalars["String"]["output"]
	reminderType: ScheduledReminderType
	scheduledReminderCount: Scalars["Int"]["output"]
}

/**
 * register_time が前日 00:00 JST 以降の scheduled な reminder
 * (encourage_rereservation_reminders / claiming_cancel_fee_reminders) を
 * message_sending_policy_id 単位で集計し、各 policy の代表 1 件のメッセージを
 * 実データから整形して返す。policy ごとの実際の文面を手動で確認するための API。
 *
 * - 各 policy について 1 件の代表 reminder を選び、その policy の全 template を整形して返す
 * - URL は <rereservation_url> / <unsubscribe_url> / <payment_url> の placeholder に置換される
 * - [error]
 *     - PERMISSION_DENIED: souhl_admin でないユーザーがアクセスした場合
 */
export type ScheduledReminderPolicyPreviewsSinceYesterdayParam = {
	Dummy?: InputMaybe<Scalars["Boolean"]["input"]>
}

export type ScheduledReminderPolicyPreviewsSinceYesterdayResponse = {
	previews: Array<ScheduledReminderPolicyPreview>
}

/**
 * ScheduledReminderType は、scheduled な reminder の種類を表す。
 * - ENCOURAGE_RERESERVATION: 再予約案内 reminder
 * - CLAIMING_CANCEL_FEE: キャンセル料請求 reminder
 */
export type ScheduledReminderType =
	| "CLAIMING_CANCEL_FEE"
	| "ENCOURAGE_RERESERVATION"

/**
 * 指定した cancel_id の請求 reminder (claiming_cancel_fee_reminders) の next_scheduled_time を
 * 「API を叩いた時刻」に書き換え、すぐ配信されるようにする。
 * あわせて use_zero_three_phone_number を 1 にし、以後この reminder の送付はすべて
 * 03 番号 (0345824393) から送られる。
 * 何通目の送付を早めたか・自動請求か・書き換え前後の値を claiming_cancel_fee_reminder_send_soon_logs に残す。
 *
 * - [error]
 *     - PERMISSION_DENIED: souhl_admin でないユーザーがアクセスした場合
 *     - INTERNAL: 以下のいずれかに該当する場合 (reminder は書き換えない)
 *         - 指定した cancel_id の claiming_cancel_fee_reminder が存在しない
 *         - reminder の status が scheduled でない (completed / paid / aborted 等)
 *         - reminder の next_scheduled_time が API を叩いた日 (JST) でない
 *         - reminder の next_scheduled_time を既に過ぎている (送信ツールが取得済みの可能性があるため)
 */
export type SendClaimingCancelFeeReminderSoonInput = {
	/** すぐ配信する請求 reminder の cancel_id */
	cancelId: Scalars["String"]["input"]
}

/** sendClaimingCancelFeeReminderSoon のレスポンス */
export type SendClaimingCancelFeeReminderSoonResponse = {
	/** 送付を早めた請求 reminder の cancel_id (input の cancelId と同じ) */
	cancelId: Scalars["String"]["output"]
	/** 送付を早めた後 (書き換え後) の next_scheduled_time (JST)。API を叩いた時刻 */
	nextScheduledTimeAfterUpdate: Scalars["DateTime"]["output"]
	/** 送付を早める前 (書き換え前) の next_scheduled_time (JST) */
	nextScheduledTimeBeforeUpdate: Scalars["DateTime"]["output"]
}

export type SetTaigaSlackMentionDueDateInput = {
	/** 今日から何日後に期限を設定するか (0 = 今日, 1 = 明日, ...) */
	daysFromToday: Scalars["Int"]["input"]
	/** 対象メンション ID */
	id: Scalars["String"]["input"]
}

export type SetTaigaSlackMentionDueDateResponse = {
	mention: TaigaSlackMention
}

/** settlement のステータス */
export type SettlementStatus =
	/** 来月繰越 */
	| "CARRYOVER"
	/** 完了 */
	| "COMPLETED"
	/** 御社支払い確認中 */
	| "INVOICE_IN_PROGRESS"
	/** SOUHL 振込確認中 */
	| "PAYOUT_IN_PROGRESS"
	/** 保留中 */
	| "PENDING"

/** Slack チャンネル ID とスレッド ts を直接指定して最新リプライ ts を取得するパラメータ。 */
export type SlackLatestReplyTsParam = {
	/** Slack チャンネル ID */
	channelId: Scalars["String"]["input"]
	/** Slack スレッドの親メッセージ ts */
	threadTs: Scalars["String"]["input"]
}

export type SlackLatestReplyTsResponse = {
	/** スレッド内で最も新しいメッセージの ts */
	ts: Scalars["String"]["output"]
}

export type SlackMentionTarget = {
	/** Slack user/group ID (e.g. U12345678) */
	id: Scalars["String"]["output"]
	/** Display name */
	name: Scalars["String"]["output"]
}

/**
 * Get valid Slack mention targets.
 * - [error]
 *     - UNAUTHORIZED: ServiceToken validation failed
 *     - PERMISSION_DENIED: ServiceToken does not have SouhlAdmin permission
 */
export type SlackMentionTargetsResponse = {
	targets: Array<SlackMentionTarget>
}

/**
 * メッセージに添付されたファイル。
 * 原本は permalink（ユーザー自身のブラウザ Slack セッションで開く）。url_private は返さない。
 */
export type SlackThreadFile = {
	/** Slack file id（FE のサムネイルキャッシュキー） */
	id: Scalars["String"]["output"]
	/** MIME タイプ */
	mimetype: Scalars["String"]["output"]
	/** ファイル名 */
	name: Scalars["String"]["output"]
	/** Slack の permalink。クリックで別タブで開く用 */
	permalink: Scalars["String"]["output"]
	/** ファイルサイズ（バイト） */
	size: Scalars["Int"]["output"]
	/** サムネイル画像の data URI（data:image/png;base64,... 形式）。常に同梱する（ページネーションにより 1 レスポンスが小さいため）。サムネイル非対応形式（zip 等）・取得失敗時は null */
	thumbnailDataUri: Maybe<Scalars["String"]["output"]>
}

/**
 * タスクに紐づく Slack スレッドの添付ファイル本体を取得する（Slack API 素通し proxy・DB 保存なし）。
 * LINE WORKS 拡張のファイルビューア（モーダル内プレビュー / ダウンロード）が使用する。
 * primary (Nexus) token の files.info で url_private を解決し、Bearer 付きで本体を取得して base64 で返す。
 * GraphQL の base64 ペイロードのため、取得対象のファイルサイズ上限は 10MB（uploadSlackThreadFile と同じ境界）。
 * - [error]
 *     - PERMISSION_DENIED: souhl_admin でないユーザーがアクセスした場合
 *     - NOT_FOUND: (channelId, threadTs) が task_slack_threads に存在しない場合、またはファイルが Slack 側に存在しない / 削除済みの場合
 *     - BAD_REQUEST: ファイルサイズが 10MB を超える場合（FE はプレビュー不可として permalink へ誘導する）
 *     - RESOURCE_EXHAUSTED: Slack API が rate limit (429) の場合
 *     - INTERNAL_ERROR: その他の Slack API エラー
 */
export type SlackThreadFileContentParam = {
	/** Slack チャンネル ID。task_slack_threads.slack_channel_id に存在するもののみ許可 */
	channelId: Scalars["String"]["input"]
	/** Slack file id（slackThreadMessages の files[].id） */
	fileId: Scalars["String"]["input"]
	/** スレッド親メッセージの ts。task_slack_threads.slack_thread_ts に存在するもののみ許可 */
	threadTs: Scalars["String"]["input"]
}

/** slackThreadFileContent のレスポンス */
export type SlackThreadFileContentResponse = {
	/** ファイル内容の base64（standard encoding） */
	dataBase64: Scalars["String"]["output"]
	/** MIME タイプ */
	mimetype: Scalars["String"]["output"]
	/** ファイル名（files.info の最新値。表示・ダウンロードファイル名に使う） */
	name: Scalars["String"]["output"]
	/** ファイルサイズ（バイト。デコード後サイズ） */
	size: Scalars["Int"]["output"]
}

/**
 * Slack スレッドの指定。
 * URL から呼び出し側で channelId / threadTs を抽出して渡す（バックエンドでは URL パースしない）。
 */
export type SlackThreadInput = {
	/** Slack チャンネル ID（例: C0ADS67T8UV） */
	slackChannelId: Scalars["String"]["input"]
	/** Slack スレッドのタイムスタンプ（例: 1771786120.321049） */
	slackThreadTs: Scalars["String"]["input"]
}

/** Slack スレッドの特定キー */
export type SlackThreadKeyInput = {
	/** Slack チャンネル ID */
	channelId: Scalars["String"]["input"]
	/** スレッド親メッセージの ts */
	threadTs: Scalars["String"]["input"]
}

/** メンション入力の候補 1 件（スレッドが属するチャンネルのメンバー）。 */
export type SlackThreadMember = {
	/** アバター画像 URL（Slack CDN の公開 URL）。解決できない場合は null */
	imageUrl: Maybe<Scalars["String"]["output"]>
	/** bot ユーザーかどうか（FE で候補表示を変える用） */
	isBot: Scalars["Boolean"]["output"]
	/** 表示名（users.info の display_name → real_name → name の順で解決） */
	name: Scalars["String"]["output"]
	/** Slack user ID (U...) */
	userId: Scalars["String"]["output"]
}

/**
 * タスクに紐づく Slack スレッドが属するチャンネルのメンバー一覧を返す（メンション入力の候補出し用）。
 * primary (Nexus) token の conversations.members（cursor ページング・上限 500 人で打ち切り + warn）で
 * member を列挙し、users.info で表示名・アバターを解決して name ASC で返す。
 * users.info で解決できなかった member は除外する（warn ログのみ）。
 * member 列挙は頻度が低いため token pool は使わず primary 固定。
 * primary bot に channels:read / groups:read scope が必要。
 * - [error]
 *     - PERMISSION_DENIED: souhl_admin でないユーザーがアクセスした場合
 *     - NOT_FOUND: (channelId, threadTs) が task_slack_threads に存在しない場合、またはチャンネルが Slack 側に存在しない場合
 *     - PRECONDITION_FAILED: primary bot (Nexus) 自身がチャンネル未参加の場合（join でも回復不能。FE は「@nexus を招待して」を表示する）
 *     - RESOURCE_EXHAUSTED: Slack API が rate limit (429) の場合
 *     - INTERNAL_ERROR: その他の Slack API エラー
 */
export type SlackThreadMembersParam = {
	/** Slack チャンネル ID。task_slack_threads.slack_channel_id に存在するもののみ許可 */
	channelId: Scalars["String"]["input"]
	/** スレッド親メッセージの ts。task_slack_threads.slack_thread_ts に存在するもののみ許可 */
	threadTs: Scalars["String"]["input"]
}

/** slackThreadMembers のレスポンス */
export type SlackThreadMembersResponse = {
	/** チャンネルメンバー一覧（name ASC） */
	members: Array<SlackThreadMember>
}

/** Slack スレッド内の 1 メッセージ（親メッセージ含む）。 */
export type SlackThreadMessage = {
	/** 添付ファイル一覧（ないときは空配列） */
	files: Array<SlackThreadFile>
	/** bot 投稿かどうか（FE でアイコン表示を変える用） */
	isBot: Scalars["Boolean"]["output"]
	/** 投稿日時 */
	postTime: Scalars["DateTime"]["output"]
	/** 送信者のアバター画像 URL（Slack CDN の公開 URL）。解決できない場合は null */
	senderImageUrl: Maybe<Scalars["String"]["output"]>
	/** 送信者の表示名。人間は users.info、bot は bots.info / message.username で解決。解決不能時は user id / bot id をそのまま返す */
	senderName: Scalars["String"]["output"]
	/** 本文（Slack mrkdwn の生テキスト。FE 側で最低限の整形のみ行う） */
	text: Scalars["String"]["output"]
	/** メッセージの ts（スレッド内で一意。クライアント側の差分判定キー） */
	ts: Scalars["String"]["output"]
}

/**
 * タスクに紐づく Slack スレッドのメッセージ一覧をウィンドウ指定で取得する（Slack API 素通し proxy・DB 保存なし）。
 * LINE WORKS 拡張の Slack スレッドモードが、初回表示（最新 limit 件）・上スクロールの過去ページ取得（beforeTs）・
 * 3 秒ポーリングの新着取得（afterTs）の 3 用途で使用する。
 * bot token は primary (Nexus) + 読み取り専用 sub の pool で運用する。
 * 読み取りは pool からランダムに token を選び、429 は未試行 token で再試行、not_in_channel は join / invite で自動回復する。
 * - [error]
 *     - PERMISSION_DENIED: souhl_admin でないユーザーがアクセスした場合
 *     - NOT_FOUND: (channelId, threadTs) が task_slack_threads に存在しない場合、またはスレッドが Slack 側で削除済みの場合
 *     - BAD_REQUEST: limit が 1〜200 の範囲外、または beforeTs と afterTs を同時指定した場合
 *     - PRECONDITION_FAILED: primary bot (Nexus) 自身がチャンネル未参加の場合（FE は「@nexus を招待して」を表示する）
 *     - RESOURCE_EXHAUSTED: pool の全 token が rate limit (429) の場合（FE は polling 間隔を退避する）
 */
export type SlackThreadMessagesParam = {
	/** この ts より新しいメッセージを取得（exclusive）。polling 用。beforeTs と同時指定は BAD_REQUEST */
	afterTs?: InputMaybe<Scalars["String"]["input"]>
	/** この ts より古いメッセージを取得（exclusive）。上スクロールのページネーション用。afterTs と同時指定は BAD_REQUEST */
	beforeTs?: InputMaybe<Scalars["String"]["input"]>
	/** Slack チャンネル ID。task_slack_threads.slack_channel_id に存在するもののみ許可 */
	channelId: Scalars["String"]["input"]
	/** 1 回に返す最大件数（1〜200。FE は 50 を渡す）。afterTs 指定時は無視（新着は全件返す） */
	limit: Scalars["Int"]["input"]
	/** スレッド親メッセージの ts。task_slack_threads.slack_thread_ts に存在するもののみ許可 */
	threadTs: Scalars["String"]["input"]
}

/** slackThreadMessages のレスポンス */
export type SlackThreadMessagesResponse = {
	/** これより古いメッセージがまだあるか（afterTs 指定時は常に false を返す）。FE の上スクロール続行判定に使う */
	hasMoreOlder: Scalars["Boolean"]["output"]
	/**
	 * messages の本文中に現れる <@U...> メンションを users.info で解決した一覧（userId ASC・重複なし）。
	 * FE はこれで本文中の生 user ID を表示名に置き換える。
	 * users.info で解決できなかった ID は含まれない（BE が warn ログを出し、FE は生 ID のまま表示する）。
	 */
	mentionUsers: Array<SlackThreadUser>
	/**
	 * 要求ウィンドウ内のメッセージ（ts ASC）。
	 * 初回（beforeTs / afterTs なし）は親メッセージ + 最新 limit 件。
	 * beforeTs 指定時は、それより古い返信 limit 件（上スクロールのページネーション用）。
	 * afterTs 指定時は、それより新しい返信すべて（polling 用。通常 0〜数件）。
	 */
	messages: Array<SlackThreadMessage>
}

/** Slack スレッドに紐づくセッションステータス（slackThreadSessionStatuses の 1 要素）。 */
export type SlackThreadSessionStatus = {
	/** Slack チャンネル ID（リクエストの echo） */
	channelId: Scalars["String"]["output"]
	/** セッションステータス（既存 enum を再利用） */
	sessionStatus: TaigaSessionStatus
	/** Slack スレッドの thread_ts（リクエストの echo） */
	threadTs: Scalars["String"]["output"]
}

export type SlackThreadSessionStatusesParam = {
	/** 取得対象の Slack スレッド一覧（1〜100 件） */
	threads: Array<SlackThreadKeyInput>
}

/** slackThreadSessionStatuses のレスポンス */
export type SlackThreadSessionStatusesResponse = {
	/**
	 * セッションが存在するスレッドのみ返す（セッション未起動・node が done のものは含まれない）。
	 * (channelId, threadTs) ASC で返す。
	 */
	statuses: Array<SlackThreadSessionStatus>
}

/** メッセージ本文中のメンション (<@U...>) を解決したユーザー。 */
export type SlackThreadUser = {
	/** アバター画像 URL（Slack CDN の公開 URL）。解決できない場合は null */
	imageUrl: Maybe<Scalars["String"]["output"]>
	/** 表示名（users.info の display_name → real_name → name の順で解決） */
	name: Scalars["String"]["output"]
	/** Slack user ID (U...) */
	userId: Scalars["String"]["output"]
}

/**
 * Slack スレッドの一括操作入力。
 * create / update 共通で使う。
 * - create: newThreads に全スレッドを指定。
 * - update: newThreads に新規追加分のみ指定（null = 変更なし）。
 * activeThread で active にするスレッドを channel + ts で指定する（既存・新規どちらでも可）。
 * null = active スレッドなし（全て inactive にする）。
 */
export type SlackThreadsInput = {
	/** active にするスレッドの channel + ts。null = active なし */
	activeThread?: InputMaybe<SlackThreadInput>
	/** 追加するスレッド（create では全スレッド、update では新規追加分のみ） */
	newThreads: Array<SlackThreadInput>
}

/** Slack ユーザー / Subteam。弊社内メンバーのみを保持する。 */
export type SlackUser = {
	/** 表示名 */
	displayName: Scalars["String"]["output"]
	/** PK（Slack User ID or Subteam ID） */
	id: Scalars["String"]["output"]
	/** FK → channel_users.id（LINE Works ユーザーとの紐づけ。null 許容） */
	lineWorksUserID: Maybe<Scalars["String"]["output"]>
	/** メンバー種別 */
	memberType: SlackUserMemberType
	/** ビジネス上の登録日時 */
	registerTime: Scalars["DateTime"]["output"]
	/** Cognito User Sub（souhl user との紐づけ。null 許容） */
	souhlUserID: Maybe<Scalars["String"]["output"]>
}

/** Slack メンバー種別 */
export type SlackUserMemberType =
	/** Slack Subteam（ユーザーグループ） */
	| "SLACK_SUBTEAM"
	/** Slack 個人ユーザー */
	| "SLACK_USER"

/**
 * Slack ユーザー / Subteam の一覧を取得する（souhl_admin のみ）。
 * FE の first_assignee / modified_assignee / reviewer ドロップダウン用。
 * 全件を返す（ページネーションなし。ユーザー数は数十人規模のため）。
 * 結果は display_name の昇順でソートされる。
 */
export type SlackUsersParam = {
	_dummy?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** slackUsers のレスポンス */
export type SlackUsersResponse = {
	/** Slack ユーザー / Subteam の一覧 */
	slackUsers: Array<SlackUser>
}

/** マイルストーン内の全ノードを名前順にソートする。 */
export type SortTaigaMilestoneNodesInput = {
	/** ソート対象のマイルストーン ID */
	milestoneId: Scalars["String"]["input"]
}

export type SortTaigaMilestoneNodesResponse = {
	/** ソート後の全ノード一覧 */
	nodes: Array<TaigaNode>
}

/** スクレイピングで取得した媒体側の店舗情報 */
export type StoreInfo = {
	/** 媒体側の店舗名 */
	name: Scalars["String"]["output"]
	/** 媒体側の店舗ID */
	storeId: Scalars["String"]["output"]
}

export type SyncTaigaSlackMentionsInput = {
	_dummy?: InputMaybe<Scalars["Boolean"]["input"]>
}

export type SyncTaigaSlackMentionsResponse = {
	/** 同期で upsert したメンション件数 */
	upsertedCount: Scalars["Int"]["output"]
}

/**
 * Adhoc milestone のノード ID 取得パラメータ。
 * 10秒ポーリングでノードの追加をニアリアルタイムに検知するために使用する。
 */
export type TaigaAdhocMilestoneNodeIdsParam = {
	/** 対象シート ID */
	sheetId: Scalars["String"]["input"]
}

export type TaigaAdhocMilestoneNodeIdsResponse = {
	/** adhoc milestone 配下のアクティブなノード ID 一覧 */
	nodeIds: Array<Scalars["String"]["output"]>
}

/** Slack スレッドの最新メッセージ ts を取得するパラメータ。 */
export type TaigaLatestThreadTsParam = {
	/** 対象ノード ID */
	nodeId: Scalars["String"]["input"]
}

export type TaigaLatestThreadTsResponse = {
	/** スレッド内で最も新しいメッセージの ts */
	ts: Scalars["String"]["output"]
}

/**
 * マイルストーン: シート内のタスクグループ。
 * ツリー構造のルートを保持する。ドラッグ&ドロップで並び替え可能。
 * 上にあるほど処理の優先度が高い。
 */
export type TaigaMilestone = {
	id: Scalars["String"]["output"]
	/** adhoc マイルストーンかどうか（adhoc=true はアーカイブ不可） */
	isAdhoc: Scalars["Boolean"]["output"]
	/** アーカイブ済みかどうか */
	isArchived: Scalars["Boolean"]["output"]
	/** 折りたたみ状態（true = ツリー非表示） */
	isCollapsed: Scalars["Boolean"]["output"]
	name: Scalars["String"]["output"]
	/** 配下の全ノード（フラットリスト。parentNodeId で親子関係を表現） */
	nodes: Array<TaigaNode>
	/** 表示位置 = 処理優先度（1が最高。数字が小さいほど優先） */
	priority: Scalars["Int"]["output"]
	sheetId: Scalars["String"]["output"]
}

/**
 * ツリーノード: マイルストーン内のタスク要素。
 * 子ノードの有無に関わらず同一の型で表現する。
 * AI Session は末端ノード（子を持たないノード）にのみ紐づけ可能。
 */
export type TaigaNode = {
	id: Scalars["String"]["output"]
	/** アーカイブ済みかどうか */
	isArchived: Scalars["Boolean"]["output"]
	/** 折りたたみ状態（true = 子ノード非表示） */
	isCollapsed: Scalars["Boolean"]["output"]
	/** ノードの作業完了フラグ */
	isDone: Scalars["Boolean"]["output"]
	/** 所属マイルストーン ID。null = Slack mention origin ツリーの node (どの milestone にも属さない) */
	milestoneId: Maybe<Scalars["String"]["output"]>
	name: Scalars["String"]["output"]
	/** 同一親内での表示順序（1始まり） */
	order: Scalars["Int"]["output"]
	/**
	 * ツリー内での並列実行順位。
	 * 同値 = 同一 AI セッションまたは並列セッションで処理可能。
	 * 数値が小さいほど先に実行可能。
	 * ※ これは並列可能性の指標であり、実際の処理優先順位（= Milestone priority）とは別概念。
	 * ※ 末端ノードに限らず、どのノードにも設定可能。
	 */
	parallelPriority: Maybe<Scalars["Int"]["output"]>
	/** 親ノード ID（null = マイルストーン直下のルートノード） */
	parentNodeId: Maybe<Scalars["String"]["output"]>
	/**
	 * ノードに紐づく AI セッション。
	 * 末端ノードにのみ作成可能。セッション未作成なら null。
	 * セッションが存在するノードには子ノードを追加できない。
	 */
	session: Maybe<TaigaSession>
}

/** ノードに紐づくセッション情報。ポーリングレスポンスの1要素。 */
export type TaigaNodeSession = {
	/** ノードが完了状態かどうか。ポーリング時にフロント側で done のノードを画面から消すために返す。 */
	isDone: Scalars["Boolean"]["output"]
	nodeId: Scalars["String"]["output"]
	session: TaigaSession
}

/**
 * AI セッション: ノードに紐づく Slack AI Session の情報。
 * 末端ノード（子を持たないノード）にのみ作成される。
 * セッションが存在するノードには子ノードを追加できない。
 */
export type TaigaSession = {
	/** cc-server のセッション ID（= Claude Code の session id。`claude -r <id>` で resume できる）。未登録の場合は null */
	ccSessionId: Maybe<Scalars["String"]["output"]>
	/** Slack チャンネル ID（セッションが属するチャンネル） */
	channelId: Scalars["String"]["output"]
	/**
	 * claude.ai 側のセッション ID（`session_01...` 形式）。
	 * https://claude.ai/code/{claudeRemoteControlSessionId} でこのセッションの会話ページを開ける。
	 * cc-server の UpdateSessionStatuses 同期で更新される。未解決の場合は null
	 */
	claudeRemoteControlSessionId: Maybe<Scalars["String"]["output"]>
	/**
	 * Remote Control (Claude アプリからの操作) が現在有効なセッションかどうか。
	 * cc-server の UpdateSessionStatuses 同期で更新される。
	 */
	isRemoteControlEnabled: Scalars["Boolean"]["output"]
	/** セッションに付与されたメモ（自由テキスト）。未設定の場合は null */
	memo: Maybe<Scalars["String"]["output"]>
	/** セッションステータス */
	sessionStatus: TaigaSessionStatus
	/** Slack thread_ts（セッション識別子） */
	threadTs: Scalars["String"]["output"]
	/** cc-server 上の worktree パス。resume 時にこのディレクトリで claude を起動する。未登録の場合は null */
	worktreePath: Maybe<Scalars["String"]["output"]>
}

/** Slack スレッドから branch 名を抽出するパラメータ。 */
export type TaigaSessionBranchNameParam = {
	/** 対象ノード ID */
	nodeId: Scalars["String"]["input"]
}

export type TaigaSessionBranchNameResponse = {
	/** スレッド内の最新の PR 通知メッセージから抽出した branch 名。見つからなければ null。 */
	branchName: Maybe<Scalars["String"]["output"]>
}

/**
 * セッションステータス。
 * cc-server が 1秒ごとに SQLite をループし、ステータス変更時にバックエンドを更新する。
 */
export type TaigaSessionStatus =
	/** セッションが処理中 */
	| "BUSY"
	/** セッションがアイドル状態（入力待ち） */
	| "IDLE"
	/** セッションが一時的に保留中（ユーザーが手動設定。focus 対象外） */
	| "PENDING"

/**
 * フロントエンドの 3秒ポーリング用パラメータ。
 * 指定したノード ID 群のセッション最新ステータスを取得する。
 */
export type TaigaSessionStatusesParam = {
	/** 取得対象のノード ID 一覧 */
	nodeIds: Array<Scalars["String"]["input"]>
}

export type TaigaSessionStatusesResponse = {
	/** ノード ID をキーとしたセッション情報。セッションが存在するノードのみ返される。 */
	sessions: Array<TaigaNodeSession>
}

/**
 * シート: タスク管理の最上位概念。
 * 1人のユーザーが0個以上のシートを作成できる。
 */
export type TaigaSheet = {
	id: Scalars["String"]["output"]
	/** アーカイブ済みかどうか */
	isArchived: Scalars["Boolean"]["output"]
	/** デフォルトシートかどうか（ユーザーあたり最大1つ。adhoc セッションの自動追加先） */
	isDefault: Scalars["Boolean"]["output"]
	/** シート内のマイルストーン数（一覧表示用） */
	milestoneCount: Scalars["Int"]["output"]
	name: Scalars["String"]["output"]
}

/**
 * シート詳細: マイルストーンと全ノードツリーを含む。
 * Sheet Detail 画面の初期ロードで使用する。
 */
export type TaigaSheetDetail = {
	id: Scalars["String"]["output"]
	isArchived: Scalars["Boolean"]["output"]
	/** デフォルトシートかどうか（ユーザーあたり最大1つ。adhoc セッションの自動追加先） */
	isDefault: Scalars["Boolean"]["output"]
	/** マイルストーン一覧（priority 昇順 = 上にあるものが先） */
	milestones: Array<TaigaMilestone>
	name: Scalars["String"]["output"]
}

/** シート詳細取得パラメータ。 */
export type TaigaSheetParam = {
	id: Scalars["String"]["input"]
}

export type TaigaSheetResponse = {
	sheet: TaigaSheetDetail
}

/** シート一覧取得パラメータ。 */
export type TaigaSheetsParam = {
	/** true にするとアーカイブ済みシートも含めて返す */
	includeArchived: Scalars["Boolean"]["input"]
}

export type TaigaSheetsResponse = {
	sheets: Array<TaigaSheet>
}

/**
 * Slack メンション: ユーザーへの Slack メンションメッセージ1件。
 * レコードは hourly job で Slack から同期される。
 */
export type TaigaSlackMention = {
	/** Slack channel ID */
	channelId: Scalars["String"]["output"]
	/** チャンネル名 */
	channelName: Maybe<Scalars["String"]["output"]>
	/**
	 * この Slack mention を origin とするツリーの全 node 群 (root + 全子孫)。
	 * is_archived=false の node を order 昇順 (ORDER BY order ASC) でフラットに返す。
	 * FE は各 node の parentNodeId を辿ってツリーを再構築し、何階層でも描画する。
	 * root node のレコードは createTaigaNodeUnderSlackMention で作成される。
	 */
	childNodes: Array<TaigaNode>
	/**
	 * この Slack mention 配下の全 node 数 (root + 全子孫)。`▸ N nodes` 表示用。
	 * is_archived=false の node 数。
	 */
	childNodesCount: Scalars["Int"]["output"]
	/** ユーザーコメント */
	comment: Scalars["String"]["output"]
	/** 要アクション期限 (YYYY-MM-DD 形式の日付文字列, JST 基準) */
	dueDate: Scalars["String"]["output"]
	/**
	 * 同一 (channel_id, thread_ts) に session を持つ Taiga node の埋め込み情報。
	 * 該当 node が存在しない場合は null。thread_ts が null の mention（親メッセージ）は
	 * messageTs を thread_ts にフォールバックして突き合わせる。
	 * node 名は name、ステータス/メモ/Slack URL 構築用の情報は session から取得する。
	 * 完了済み（is_done=true）の node は「なきもの」として扱い null を返す。
	 *
	 * 【誰が起動した session でも反映される】
	 * embedded session は (channel_id, thread_ts) のみで session を引いて表示する。
	 * 突き合わせは「その mention と同じスレッドに session があるか」だけで判定し、
	 * session を起動した Slack ユーザーが誰かには一切依存しない。具体的には:
	 *   - mention を持つユーザー本人が起動した session だけでなく、
	 *     他ユーザーが起動した session も同一スレッドであれば反映される
	 *   - SlackUserToTaigaUserID に未マッピングのユーザーが起動した session も反映される
	 *     （その session の node は milestone に属さない orphan node として作成される）
	 *   - cc-server が起動ユーザー（slack_user_id）を解決できなかった session も、
	 *     cc-server が空 slack_user_id で RegisterCcServerSession を呼ぶため反映される
	 * すなわち、この embedded session は「mention の所有者」ではなく「mention のスレッド」に
	 * 紐づく。誰の起動かを問わず、同一スレッドの最新 session 状態が常に embed される。
	 *
	 * 対応する backend / cc-server:
	 *   - 登録: go.taiga.private.v1.TaigaPrivateService.RegisterCcServerSession
	 *     （cc-server のセッション作成時・fork 時・バックフィル時。slack_user_id は任意）
	 *   - ステータス同期: go.taiga.private.v1.TaigaPrivateService.UpdateSessionStatuses
	 *     （cc-server が全 active session を起動ユーザー問わず同期）
	 */
	embeddedNode: Maybe<TaigaNode>
	/** id は `{channelId}_{messageTs}` 形式 */
	id: Scalars["String"]["output"]
	/**
	 * node ツリー全体 (MentionRow の ▸ N nodes アコーディオン) の開閉状態。
	 * true = 折りたたみ (初期状態)。FE はこの値を初期表示に使い、
	 * toggleTaigaSlackMentionChildNodesCollapsed mutation でトグルする。
	 */
	isChildNodesCollapsed: Scalars["Boolean"]["output"]
	/** Slack message timestamp */
	messageTs: Scalars["String"]["output"]
	/** Slack permalink URL */
	permalink: Maybe<Scalars["String"]["output"]>
	/** 優先度。小さいほど高優先 */
	priority: Scalars["Int"]["output"]
	/** メンションした人の Slack 表示名 */
	senderDisplayName: Scalars["String"]["output"]
	/** Slack メッセージの投稿時刻 */
	slackMessageTime: Scalars["DateTime"]["output"]
	/** メッセージ本文 */
	text: Scalars["String"]["output"]
	/** Slack thread timestamp。スレッド内メンションの場合のみ入る */
	threadTs: Maybe<Scalars["String"]["output"]>
}

/** Slack メンション同期状態。 */
export type TaigaSlackMentionSyncState = {
	/** 最後の同期完了時刻 */
	lastSyncTime: Scalars["DateTime"]["output"]
}

export type TaigaSlackMentionSyncStateParam = {
	/** 対象ユーザー ID。null/未指定なら認証ユーザー自身。 */
	userId?: InputMaybe<Scalars["String"]["input"]>
}

export type TaigaSlackMentionSyncStateResponse = {
	syncState: TaigaSlackMentionSyncState
}

export type TaigaSlackMentionsParam = {
	/** 対象ユーザー ID。null/未指定なら認証ユーザー自身。 */
	userId?: InputMaybe<Scalars["String"]["input"]>
}

export type TaigaSlackMentionsResponse = {
	/** 未完了メンション一覧 */
	mentions: Array<TaigaSlackMention>
}

/**
 * タスクの読み取り情報（lineWorksGroups Query 用）。
 * 未完了タスクのみが返される。
 */
export type Task = {
	/** ドラフトメッセージ一覧（register_time DESC。件数上限なし） */
	draftMessages: Array<DraftMessage>
	/** 最初の担当者（FK → slack_users。null = 未指定） */
	firstAssignee: Maybe<SlackUser>
	/** タスク ID（ULID） */
	id: Scalars["String"]["output"]
	/** タスク種別 */
	kind: TaskKind
	/** メモ */
	memo: Maybe<Scalars["String"]["output"]>
	/** 引き継ぎ後の担当者（FK → slack_users。null = 未指定） */
	modifiedAssignee: Maybe<SlackUser>
	/**
	 * 次回催促予定時刻。status = 'active' の task_reminder の next_reminder_time を返す。
	 * 催促スケジュールが存在しない場合 / status が active でない場合は null。
	 * lineWorksGroups Query の一覧表示でサマリーとして使用。
	 */
	nextReminderTime: Maybe<Scalars["DateTime"]["output"]>
	/** 登録日時 */
	registerTime: Scalars["DateTime"]["output"]
	/** Slack スレッド一覧（register_time DESC。先頭 = 直近に登録した thread） */
	slackThreads: Array<TaskSlackThread>
	/** タスクステータス */
	status: TaskStatus
	/** タグ一覧 */
	tags: Array<TaskTag>
	/** 催促スケジュール詳細（active or ended。存在しない場合は null） */
	taskReminder: Maybe<TaskReminder>
	/** タスク作成のトリガーとなった channel_message の ID（null = メッセージ紐付けなし） */
	triggerChannelMessageId: Maybe<Scalars["String"]["output"]>
}

/**
 * タスク種別マスタ。
 * task_kind ごとにデフォルトの催促スケジュール（intervals）を保持する。
 */
export type TaskKind = {
	/** 表示色（RGB） */
	color: Rgb
	/** デフォルトの催促スケジュール間隔（時間単位の配列）。空配列 = 催促なし */
	defaultReminderIntervalDays: Array<Scalars["Int"]["output"]>
	/** タスク種別 ID（ULID） */
	id: Scalars["String"]["output"]
	/** 表示名 */
	name: Scalars["String"]["output"]
	/** 業務的な登録日時 */
	registerTime: Scalars["DateTime"]["output"]
}

/** タスク種別マスタ一覧を取得する */
export type TaskKindsParam = {
	_dummy?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** taskKinds Query のレスポンス */
export type TaskKindsResponse = {
	/** タスク種別一覧（name ASC でソート済み） */
	taskKinds: Array<TaskKind>
}

/**
 * 催促スケジュール詳細（読み取り用）。
 * active or ended の task_reminders 情報を返す。
 */
export type TaskReminder = {
	/** 催促スケジュール ID（ULID） */
	id: Scalars["String"]["output"]
	/** 催促間隔の設定一覧（sequence_number ASC) */
	intervals: Array<TaskReminderInterval>
	/** 直近の催促以降に通常の outgoing メッセージが送信されていない場合 true */
	needsAction: Scalars["Boolean"]["output"]
	/** 次回催促予定時刻（status = ACTIVE のときのみ有効。null の場合あり） */
	nextReminderTime: Maybe<Scalars["DateTime"]["output"]>
	/** ステータス（active = 動作中 / ended = task complete で終了 / deleted = 差し替え or 停止で履歴扱い） */
	status: TaskReminderStatus
}

/** 催促スケジュールの設定。intervals で催促の間隔を日単位で指定する。通知は毎朝 9:00 JST に送信される。 */
export type TaskReminderInput = {
	/** 催促間隔の配列（日単位、最大 5 個）。1 番目の値が最初の催促までの待ち日数。空配列 = 催促停止 */
	intervals: Array<Scalars["Int"]["input"]>
}

/** 催促間隔の個別設定。 */
export type TaskReminderInterval = {
	/** 間隔（日単位） */
	intervalDays: Scalars["Int"]["output"]
	/** シーケンス番号（1始まり） */
	sequenceNumber: Scalars["Int"]["output"]
}

/** 催促スケジュールのステータス */
export type TaskReminderStatus =
	/** 催促進行中（バッチ処理対象） */
	| "ACTIVE"
	/** 過去バージョン（updateTask で差し替えられた履歴） */
	| "DELETED"
	/** 催促終了済み */
	| "ENDED"

/**
 * タスクに紐づく Slack スレッド情報（読み取り用）。
 * register_time 降順で返される。isActive はフラグのみ。
 */
export type TaskSlackThread = {
	/** Slack スレッド ID */
	id: Scalars["String"]["output"]
	/** アクティブフラグ（true = 現在アクティブなスレッド） */
	isActive: Scalars["Boolean"]["output"]
	/** 登録日時 */
	registerTime: Scalars["DateTime"]["output"]
	/** Slack チャンネル ID */
	slackChannelId: Scalars["String"]["output"]
	/** Slack スレッドのタイムスタンプ */
	slackThreadTs: Scalars["String"]["output"]
}

/** タスクのステータス */
export type TaskStatus =
	/** 完了 */
	| "COMPLETED"
	/** 返信が必要 */
	| "NEEDS_REPLY"
	/** 返信待ち */
	| "WAITING_REPLY"

/** タスクタグ。タスクに紐付けて分類に使用する。 */
export type TaskTag = {
	/** 表示色（RGB） */
	color: Rgb
	/** タスクタグ ID（ULID） */
	id: Scalars["String"]["output"]
	/** タグ名 */
	name: Scalars["String"]["output"]
	/** 業務的な登録日時 */
	registerTime: Scalars["DateTime"]["output"]
}

/** タスクタグ一覧を取得する */
export type TaskTagsParam = {
	_dummy?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** taskTags Query のレスポンス */
export type TaskTagsResponse = {
	/** タスクタグ一覧（name ASC でソート済み） */
	taskTags: Array<TaskTag>
}

/**
 * Feature Flag の設定を切り替えます。
 * - isCompanyWideEnabled: true → 会社全体で ON（enabledSalonIds は無視）
 * - isCompanyWideEnabled: false → 個別店舗設定（enabledSalonIds で指定した店舗のみ ON）
 * - [error]
 *     - UNAUTHORIZED: ServiceToken の検証に失敗する場合
 *     - PERMISSION_DENIED: ServiceToken が SouhlAdmin 権限を持たない場合
 *     - INVALID_ARGUMENT: 不正な featureFlagId が指定された場合
 */
export type ToggleFeatureFlagsInput = {
	/** 対象の会社 ID */
	companyId: Scalars["String"]["input"]
	/** toggle するフラグの設定 */
	featureFlags: Array<FeatureFlagToggleInput>
}

export type ToggleFeatureFlagsResponse = {
	/** 更新後の会社設定 */
	companyFeatureFlags: Array<CompanyFeatureFlag>
}

export type ToggleTaigaSlackMentionChildNodesCollapsedInput = {
	/** 対象メンション ID */
	id: Scalars["String"]["input"]
}

export type ToggleTaigaSlackMentionChildNodesCollapsedResponse = {
	mention: TaigaSlackMention
}

export type UnarchiveTaigaMilestoneInput = {
	id: Scalars["String"]["input"]
}

export type UnarchiveTaigaMilestoneResponse = {
	milestone: TaigaMilestone
}

export type UnarchiveTaigaSheetInput = {
	id: Scalars["String"]["input"]
}

export type UnarchiveTaigaSheetResponse = {
	sheet: TaigaSheet
}

/**
 * 完了済みタスクを未完了に戻す（souhl_admin のみ）。
 * tasks.status を NEEDS_REPLY に、completed_time を null にリセットし、task_complete_line_works_message_ids を削除する。
 * - [error]
 *     - UNAUTHORIZED: ServiceToken の検証に失敗する場合
 *     - PERMISSION_DENIED: ServiceToken が SouhlAdmin 権限を持たない場合
 *     - NOT_FOUND: taskId のタスクが存在しない場合
 *     - FAILED_PRECONDITION: taskId のタスクが COMPLETED でない場合
 */
export type UncompleteTaskInput = {
	/** 対象のタスク ID */
	taskId: Scalars["ID"]["input"]
}

/** uncompleteTask のレスポンス */
export type UncompleteTaskResponse = {
	/** 成功した場合は true */
	ok: Scalars["Boolean"]["output"]
}

export type UnknownIssueLog = {
	/** Kind (if available) */
	kind: Maybe<Scalars["String"]["output"]>
	/** Log level (WARNING, ERROR, CRITICAL) */
	level: LogLevel
	/** Log message (truncated to 500 chars) */
	message: Scalars["String"]["output"]
	/** Module name */
	moduleName: Scalars["String"]["output"]
	/** OpenSearch URL for this log */
	opensearchUrl: Scalars["String"]["output"]
	/** Request ID */
	reqId: Scalars["String"]["output"]
	/** Salon ID (if available) */
	salonId: Maybe<Scalars["Int"]["output"]>
	/** Log timestamp */
	time: Scalars["DateTime"]["output"]
}

/**
 * Get unknown issue logs from the last 48 hours.
 * Returns logs that don't match any open known issue, sorted by time descending (newest first).
 * - HideUnknownIssueLogsInput で hide されているものはかえされない
 * - [error]
 *     - UNAUTHORIZED: ServiceToken validation failed
 *     - PERMISSION_DENIED: ServiceToken does not have SouhlAdmin permission
 */
export type UnknownIssueLogsParam = {
	/** Filter by kind (partial match, optional) */
	kind?: InputMaybe<Scalars["String"]["input"]>
	/** Limit number of results (default: 200, max: 500) */
	limit?: InputMaybe<Scalars["Int"]["input"]>
	/** Filter by log level (optional) */
	logLevel?: InputMaybe<LogLevel>
	/** Filter by module name (partial match, optional) */
	moduleName?: InputMaybe<Scalars["String"]["input"]>
	/** Filter by salon ID (optional) */
	salonId?: InputMaybe<Scalars["Int"]["input"]>
}

export type UnknownIssueLogsResponse = {
	logs: Array<UnknownIssueLog>
	/** Total count of unknown logs in the last 48 hours (before limit applied) */
	totalCount: Scalars["Int"]["output"]
}

/**
 * チャネルグループのメモ本文・ピン留めを更新する（souhl_admin のみ）。
 * 作成者（author_slack_user_id）は変更しない。
 * - [error]
 *     - NOT_FOUND: 指定 memoId に対応する active な channel_group_memos レコードが存在しない場合
 *     - INVALID_ARGUMENT: text が空文字の場合
 */
export type UpdateChannelGroupMemoInput = {
	/** 更新後のピン留めフラグ */
	isPinned: Scalars["Boolean"]["input"]
	/** 更新対象のメモ ID */
	memoId: Scalars["String"]["input"]
	/** 更新後のメモ本文 */
	text: Scalars["String"]["input"]
}

/** updateChannelGroupMemo のレスポンス */
export type UpdateChannelGroupMemoResponse = {
	/** 更新されたメモ */
	memo: ChannelGroupMemo
}

/**
 * 会社の手数料率を更新し、変更履歴を自動記録する。
 * レコードが存在しない場合は新規作成し、存在する場合は更新する。
 * - 先月の settlement 再作成を best effort スコープで行う
 * - [error]
 *     - BAD_REQUEST: cancelFeeCommissionRate / existingCustomerRereservationCommissionRate / newCustomerRereservationCommissionRate が 0〜100 の範囲外の場合
 */
export type UpdateCompanyCommissionRatesInput = {
	/** キャンセル料回収手数料率（税抜 %、0〜100 の整数） */
	cancelFeeCommissionRate: Scalars["Int"]["input"]
	/** IDP companies.id */
	companyId: Scalars["String"]["input"]
	/** 既存客の再予約手数料率（税抜 %、0〜100 の整数）。 */
	existingCustomerRereservationCommissionRate: Scalars["Int"]["input"]
	/** 新規客の再予約手数料率（税抜 %、0〜100 の整数）。 */
	newCustomerRereservationCommissionRate: Scalars["Int"]["input"]
}

/** updateCompanyCommissionRates のレスポンス */
export type UpdateCompanyCommissionRatesResponse = {
	companyCommissionRates: CompanyCommissionRates
}

/**
 * company と HubSpot 取引の紐付けを更新する（souhl_admin のみ）。
 * 置換（replace）操作: mutation 実行後、指定 company に紐づくアクティブな contract は
 * hubspotContractIds と完全に一致する状態になる。
 * hubspotContractIds に含まれない旧マッピングは is_active = 0 に更新（ソフトデリート）。
 * hubspotContractIds が空配列の場合、全紐付けを解除する。
 * 冪等: 同じ引数で再実行しても結果は変わらない。
 * - [error]
 *     - UNAUTHORIZED: ServiceToken の検証に失敗する場合
 *     - PERMISSION_DENIED: ServiceToken が SouhlAdmin 権限を持たない場合
 *     - NOT_FOUND: companyId の company が存在しない場合（idp private gRPC で検証）
 *     - NOT_FOUND: hubspotContractIds に hubspot_contracts テーブルに存在しない ID が含まれる場合
 */
export type UpdateCompanyHubspotContractIDsInput = {
	/** 対象の会社 ID */
	companyId: Scalars["String"]["input"]
	/** 紐付ける HubSpot 取引 ID 一覧（空配列で全紐付け解除） */
	hubspotContractIds: Array<Scalars["String"]["input"]>
}

/** updateCompanyHubspotContractIDs のレスポンス */
export type UpdateCompanyHubspotContractIDsResponse = {
	/** 更新後の company に紐づくアクティブな HubSpot 取引一覧 */
	hubspotContracts: Array<HubspotContract>
}

/**
 * `updateCompany` は、会社情報を更新します。
 * - [error]
 *     - 401: caller が SOUHL admin ではない場合
 */
export type UpdateCompanyInput = {
	id: Scalars["String"]["input"]
	name: Scalars["String"]["input"]
}

export type UpdateCompanyResponse = {
	company: Company
}

export type UpdateCompanySmsSendingRuleV2CancelTypeSettingInput = {
	/** 詳細は CompanySmsSendingRuleV2CancelTypeSetting.cancel_fee_amount_for_non_zero_yen_reservation を参照 */
	cancelFeeAmountForNonZeroYenReservation?: InputMaybe<Scalars["Int"]["input"]>
	/** 詳細は CompanySmsSendingRuleV2CancelTypeSetting.cancel_fee_amount_for_zero_yen_reservation を参照 */
	cancelFeeAmountForZeroYenReservation: Scalars["Int"]["input"]
	/** 詳細は CompanySmsSendingRuleV2CancelTypeSetting.cancel_fee_percent_for_non_zero_yen_reservation を参照 */
	cancelFeePercentForNonZeroYenReservation?: InputMaybe<Scalars["Int"]["input"]>
	/**
	 * 詳細は CompanySmsSendingRuleV2CancelTypeSetting.claiming_conversion_policy_name を参照
	 * - 現在選択不可能なものを指定すると validation error になる。
	 */
	claimingConversionPolicyName?: InputMaybe<Scalars["String"]["input"]>
	/** 詳細は CompanySmsSendingRuleV2CancelTypeSetting.encouraging_rereservation_policy_name を参照 */
	encouragingRereservationPolicyName?: InputMaybe<Scalars["String"]["input"]>
	/**
	 * 再予約案内の来店回数区間ごとの送付種別設定
	 * - 省略時 (null) は unit を変更しない
	 * - 空リストは unit を全削除する (従来通り encouraging_rereservation_policy_name を参照する状態に戻す)
	 */
	encouragingRereservationUnits?: InputMaybe<
		Array<EncouragingRereservationUnitInput>
	>
	id: Scalars["String"]["input"]
	/**
	 * 手動請求の来店回数区間ごとの転換設定
	 * - 省略時 (null) は unit を変更しない
	 * - 空リストは unit を全削除する (転換しない普通の手動請求に戻す)
	 */
	manuallyClaimingUnits?: InputMaybe<Array<ManuallyClaimingUnitInput>>
	/** 詳細は CompanySmsSendingRuleV2CancelTypeSetting.min_visit_count_for_claiming_conversion を参照 */
	minVisitCountForClaimingConversion: Scalars["Int"]["input"]
	/** 詳細は CompanySmsSendingRuleV2CancelTypeSetting.min_visit_count_for_encourageing_rereservation を参照 */
	minVisitCountForEncouragingRereservation: Scalars["Int"]["input"]
	/** 詳細は CompanySmsSendingRuleV2CancelTypeSetting.min_visit_count_for_manually_claiming_cancel_feeを参照 */
	minVisitCountForManuallyClaimingCancelFee: Scalars["Int"]["input"]
	/** 詳細は CompanySmsSendingRuleV2CancelTypeSetting.min_visit_count_for_nothingを参照 */
	minVisitCountForNothing: Scalars["Int"]["input"]
}

/**
 * updateCompanySmsSendingRuleV2 mutation は、ログインしている店舗 (Rh-Salon-Id header で指定した店舗) が所属している Company の
 * SMS 送信ルールを更新します。
 * なお、UpdateCompanySmsSendingRuleV2CancelTypeSettingInput で指定されていない cancel type setting は、更新されません。
 *
 * - [validation]
 *     - CompanySmsSendingRuleV2 と CompanySmsSendingRuleV2CancelTypeSetting の各フィールドが満たすべき条件を満たしている必要がある
 *     - 再予約案内を有効にする場合、紐づく店舗が再予約機能を利用可能である必要がある.
 *         - 再予約機能を利用不可能な店舗:
 *             - ScrapingTarget が CLOUD_BEAUTY で kanzashi_yui_link がない店舗
 *             - ScrapingTarget が SELECT_TYPE, KIREIPASS_CONNECT, MANUAL の店舗
 *             - 再予約v2が有効な連携媒体（CLOUD_BEAUTYを除く）で NabekoPrivateService.GetSalons の結果 can_use_rereservation_function=false の店舗
 * - [error] (extension の masseges にエラーメッセージ list を返します)
 *     - PERMISSION_DENIED: caller が会社の会社 admin ではない場合.
 *     - BAD_REQUEST: validation error の場合
 */
export type UpdateCompanySmsSendingRuleV2Input = {
	cancelTypeSettingInputs: Array<UpdateCompanySmsSendingRuleV2CancelTypeSettingInput>
	companyId: Scalars["String"]["input"]
	id: Scalars["String"]["input"]
	name: Scalars["String"]["input"]
}

export type UpdateCompanySmsSendingRuleV2Response = {
	rule: CompanySmsSendingRuleV2
}

/**
 * 指定 salon・媒体の認証情報（loginId/password）を、前回つながった店舗と同じ店舗 ID のときだけ更新する。
 * 同じ店舗で ID/PASS が変わっただけの ipass 再連携で使い、別の店舗の ID/PASS を保存する前に止める。
 * 掲載変更などで店舗 ID が変わった場合・前回の店舗 ID が記録されていない場合は、updateDataSourceLoginCredentials を使う。
 *
 * 処理:
 * 1. 新しい認証情報で媒体にログインし、媒体の画面から店舗 ID を取る
 * 2. salon_data_source_connection_statuses.store_id（前回つながったときの店舗 ID）と照合する
 * 3. 一致すれば updateDataSourceLoginCredentials と同じく、Parameter Store(password) → DB(login_id・接続状態) の順で更新する
 *    DB を更新する TX の中で接続状態を FOR UPDATE で取り直し、同じ照合をもう一度行う
 * 照合に失敗した場合、Parameter Store・DB は更新しない。
 * ただし、TX 内の再照合で失敗した場合（照合と TX の間に同じ salon・媒体の別の更新が走った場合）は、
 * DB はロールバックするが、Parameter Store は新しいパスワードに更新済みのまま残る。その場合はもう一度更新する。
 *
 * 対象媒体: SALONBOARD / BEAUTY_MERIT / MINIMO / RAKUTEN（媒体の画面から店舗 ID を取れている媒体）。
 * souhl_admin のみアクセス可能。機密を扱うため mutation として公開し no-cache で呼ぶ。
 * パスワード値はレスポンス・ログに平文出力しない。
 *
 * - [error]
 *     - PERMISSION_DENIED: souhl_admin でないユーザー、または Parameter Store 書き込み権限が不足している場合
 *     - NOT_FOUND: 指定 salon_id の当該媒体 scraping_setting が存在しない場合
 *     - INVALID_ARGUMENT: dataSource が対象媒体でない場合、または loginId/password が空の場合
 *     - FAILED_PRECONDITION: 次のいずれか。メッセージの先頭で見分ける
 *         - 「ログイン検証に失敗しました: 」: ログイン検証に失敗した場合（updateDataSourceLoginCredentials と同じ）
 *         - 「店舗IDの照合に失敗しました: 前回の店舗IDが保存されていないため」: 接続状態の行が無い、store_id が NULL・空文字、または今回取った店舗 ID が空文字の場合。updateDataSourceLoginCredentials で更新する
 *         - 「店舗IDの照合に失敗しました: 前回接続した店舗IDと違います」: 前回の店舗 ID と今回取った店舗 ID が違う場合。メッセージに両方の店舗 ID を含む
 */
export type UpdateDataSourceLoginCredentialsForSameStoreIdInput = {
	/** 対象媒体。SALONBOARD / BEAUTY_MERIT / MINIMO / RAKUTEN のみ */
	dataSource: DataSource
	/** 新しいログインID（DB の {media}_scraping_setting.login_id を更新） */
	loginId: Scalars["String"]["input"]
	/** 新しいログインパスワード（AWS Parameter Store を更新）。レスポンス・ログには出力しない */
	password: Scalars["String"]["input"]
	/** 対象の salon ID */
	salonId: Scalars["Int"]["input"]
}

/** updateDataSourceLoginCredentialsForSameStoreId のレスポンス */
export type UpdateDataSourceLoginCredentialsForSameStoreIdResponse = {
	/** 更新時の検証で取得した媒体側の店舗情報。対象媒体はすべて検証するので常に返る */
	storeInfo: StoreInfo
}

/** updateDataSourceLoginCredentials のレスポンス */
export type UpdateDataSourceLoginCredentialsResponse = {
	/**
	 * 更新時の検証で取得した媒体側の店舗情報。
	 * 検証なし媒体（POSTAS/EXCEED_SYSTEM）では null。
	 */
	storeInfo: Maybe<StoreInfo>
}

/**
 * ドラフトメッセージの本文を更新する（souhl_admin のみ）。
 * active な draft であれば種別 (AI / USER / レビュー結果) を問わず更新可能。
 * 新しい USER ドラフト行を作成し、元 draft は `is_active = false` に切り替える。
 * 作成者は ServiceToken の souhlUserID から自動解決する（slack_users.souhl_user_id で引く）。
 *
 * 新規 active 行のフィールド設定:
 *   - `author_slack_user_id`: ServiceToken の souhlUserID → slack_users.souhl_user_id で解決。
 *   - `reviewer_slack_user_id`: 元 draft の reviewer をそのまま継承（AI / レビュー
 *     結果のように元が nil の場合は nil）。
 *   - `original_draft_message_id`: **常に元 draft の id を保存**して系譜 (chain)
 *     を伸ばす。AI / USER / レビュー結果いずれが元でも 1 つ前を辿れる。
 *   - `reviewee_draft_message_id`: 常に nil（元がレビュー結果でも継承しない。
 *     レビュー関係は元 reviewee を起点に保持される）。
 * - [error]
 *     - NOT_FOUND: 指定 draftMessageId に対応する active な draft_messages レコードが存在しない場合
 *     - NOT_FOUND: ServiceToken の souhlUserID に対応する slack_users レコードが存在しない場合
 */
export type UpdateDraftMessageInput = {
	/** 更新対象のドラフトメッセージ ID */
	draftMessageId: Scalars["String"]["input"]
	/** 更新後のメッセージ本文 */
	text: Scalars["String"]["input"]
}

/** updateDraftMessage のレスポンス */
export type UpdateDraftMessageResponse = {
	/** 更新されたドラフトメッセージ */
	draftMessage: DraftMessage
}

/**
 * Update a known issue. Sets issue_modified_time to current time.
 * - [error]
 *     - UNAUTHORIZED: ServiceToken validation failed
 *     - PERMISSION_DENIED: ServiceToken does not have SouhlAdmin permission
 *     - NOT_FOUND: KnownIssue with specified id does not exist
 *     - BAD_REQUEST: Required field is invalid, or mentionTargetIds contains invalid ID
 */
export type UpdateKnownIssueInput = {
	autoResolveDaysAfterLastActivity: Scalars["Int"]["input"]
	/** Cooldown hours between notifications. Null means no cooldown. */
	cooldownHoursToNotify?: InputMaybe<Scalars["Int"]["input"]>
	description: Scalars["String"]["input"]
	id: Scalars["String"]["input"]
	issueType: IssueType
	logKeyword: Scalars["String"]["input"]
	logKind?: InputMaybe<Scalars["String"]["input"]>
	logLevel: LogLevel
	logMatchMethod: LogMatchMethod
	logModuleName: Scalars["String"]["input"]
	/** Salon IDs to match (OR condition). NOTE: Existing mappings are deleted and replaced with new values. Pass empty array [] to clear. */
	logSalonIds: Array<Scalars["Int"]["input"]>
	mentionTargetIds?: InputMaybe<Array<Scalars["String"]["input"]>>
	shouldSendIosCriticalNotification: Scalars["Boolean"]["input"]
	/** @deprecated 期限機能は廃止済み。指定しても無視される */
	shouldSkipThresholdCountCheckAfter?: InputMaybe<Scalars["DateTime"]["input"]>
	slackChannelNameToNotify: Scalars["String"]["input"]
	thresholdCountToNotify: Scalars["Int"]["input"]
}

export type UpdateKnownIssueResponse = {
	knownIssue: KnownIssue
}

/**
 * 指定した company に紐づく line_group mapping を、指定した lineGroupDisplayNames のリストで差分同期する。
 * bizdev 側で channel_groups.display_name から line_group_id を解決し、idp private API
 * （ReplaceLineGroupAndCompanyMappings）経由で同期する。
 * - [error]
 *     - UNAUTHORIZED: ServiceToken の検証に失敗する場合
 *     - PERMISSION_DENIED: ServiceToken が SouhlAdmin 権限を持たない場合
 *     - NOT_FOUND: companyId に該当する company が存在しない場合（idp 側で検証）
 *     - NOT_FOUND: lineGroupDisplayNames に bizdev.channel_groups に存在しない display_name が含まれる場合
 *     - INVALID_ARGUMENT: lineGroupDisplayNames に bizdev.channel_groups で重複する display_name が含まれる場合
 *     - INTERNAL: idp private API 呼び出しに失敗した場合
 */
export type UpdateLineGroupAndCompanyMappingsInput = {
	/** 対象会社の ID（IDP companies.id に対応） */
	companyId: Scalars["String"]["input"]
	/** この company に紐づける channel_groups の display_name の一覧。bizdev 側で line_group_id に解決した後、idp に差分同期される。空配列の場合は全 active mapping を soft delete する */
	lineGroupDisplayNames: Array<Scalars["String"]["input"]>
}

/** updateLineGroupAndCompanyMappings のレスポンス */
export type UpdateLineGroupAndCompanyMappingsResponse = {
	/** 同期後の active mapping 件数 */
	updatedCount: Scalars["Int"]["output"]
}

export type UpdateSalonAndCompanySmsSendingRuleMappingInput = {
	companySmsSendingRuleId: Scalars["String"]["input"]
	salonId: Scalars["Int"]["input"]
}

/**
 * updateSalonAndCompanySmsSendingRuleMappings mutation は、company_id param で指定した Company の店舗情報を更新します。
 * 指定されていない店舗は無視します。
 *
 * - [validation]
 *     - ルールに再予約案内設定がある場合、対象店舗が再予約機能を利用可能である必要がある.
 *         - 詳細は UpdateCompanySmsSendingRuleV2Input を参照
 * - [error]
 *     - BAD_REQUEST: validation error の場合
 */
export type UpdateSalonAndCompanySmsSendingRuleMappingsInput = {
	companyId: Scalars["String"]["input"]
	inputs: Array<UpdateSalonAndCompanySmsSendingRuleMappingInput>
}

export type UpdateSalonAndCompanySmsSendingRuleMappingsResponse = {
	/**
	 * 更新された店舗の ID 一覧
	 * - なんか返さないといけないので、 salon_ids でも返しておく
	 */
	salonIds: Array<Scalars["Int"]["output"]>
}

/**
 * 指定された salon_id の data_source_policy_memo を更新する。
 * memo が null の場合はメモをクリアする。
 * souhl_admin のみアクセス可能。
 * - [error]
 *     - PERMISSION_DENIED: souhl_admin でないユーザーがアクセスした場合
 *     - NOT_FOUND: 指定された salon_id が存在しない場合
 *     - BAD_REQUEST: memo が 1000 文字を超える場合
 */
export type UpdateSalonDataSourcePolicyMemoInput = {
	/** 設定するメモ（null でクリア）。最大 1000 文字 */
	memo?: InputMaybe<Scalars["String"]["input"]>
	/** 対象の salon ID */
	salonId: Scalars["Int"]["input"]
}

export type UpdateSalonDataSourcePolicyMemoResponse = {
	/** 更新後の salon */
	salon: Salon
}

/**
 * 指定された salon_ids の goal_data_source_policy を一括更新する。
 * goalDataSourcePolicy が null の場合は、既存の goal_data_source_policy をクリア（NULL に更新）する。
 * souhl_admin のみアクセス可能。
 * - [error]
 *     - PERMISSION_DENIED: souhl_admin でないユーザーがアクセスした場合
 *     - NOT_FOUND: 指定された salon_id が存在しない場合
 */
export type UpdateSalonGoalDataSourcePoliciesInput = {
	/** 設定する目標の媒体設定ポリシー（null で既存値をクリア） */
	goalDataSourcePolicy?: InputMaybe<DataSourcePolicy>
	/** 対象の salon ID リスト（1件以上必須） */
	salonIds: Array<Scalars["Int"]["input"]>
}

export type UpdateSalonGoalDataSourcePoliciesResponse = {
	/** 更新成功 */
	success: Scalars["Boolean"]["output"]
}

/**
 * updateSalonSmsSendingStartSettings mutation は、input.salon_idsで指定された店舗での SMS 送信ルールの適用開始設定を更新します。
 *
 * - [validation]
 *     - 設定完了済みかつ自動請求を含むルール適用中の場合、auto_claim_start_date を null にできない
 *     - 設定完了済みかつ再予約案内を含むルール適用中の場合、encourage_start_cancel_date を null にできない
 * - [error]
 *     - BAD_REQUEST: validation error の場合
 */
export type UpdateSalonSmsSendingStartSettingsInput = {
	/** 自動請求を何を基準にスタートするか。(何と `auto_claim_start_date` を比較するか) */
	autoClaimBase: CompanySmsSendingRuleAutoClaimBase
	/** 自動請求の対象となる、最小の時間。`auto_claim_base` が指すフィールドの値が、これ以上であれば自動請求する。 */
	autoClaimStartDate?: InputMaybe<Scalars["Date"]["input"]>
	/** 対象会社の ID。 */
	companyId: Scalars["String"]["input"]
	/** 再予約案内の対象となる、最小のキャンセル日 */
	encourageStartCancelDate?: InputMaybe<Scalars["Date"]["input"]>
	/** 適用開始設定を更新する対象サロンの ID リスト。 */
	salonIds: Array<Scalars["Int"]["input"]>
}

export type UpdateSalonSmsSendingStartSettingsResponse = {
	/** 更新された店舗の ID 一覧 */
	salonIds: Array<Scalars["Int"]["output"]>
}

/**
 * updateSalonUsageStartDate mutation は、指定されたサロンの利用開始日を一括更新します。
 * usageStartDate に日付を指定すると、対象サロンの usage_start_date にその日付を記録します。
 * usageStartDate に null を指定すると、usage_start_date を NULL にクリアします。
 * 過去・当日・未来いずれの日付も指定可能です（CSM の判断を信頼し、日付バリデーションは行いません）。
 *
 * - [validation]
 *     - salonIds に指定されたサロンが companyId に属していない場合はエラー
 *     - usageStartDate を SET する場合（null でない場合）、対象サロンが以下を全て満たす必要がある
 *         - デフォルトルール適用中ではない
 *         - 自動請求を含むルール適用中の場合、auto_claim_start_date が設定済み
 *         - 再予約案内を含むルール適用中の場合、encourage_start_cancel_date が設定済み
 *     - usageStartDate を null にクリアする場合は上記 validation はスキップ
 * - [error]
 *     - BAD_REQUEST: salonIds に指定された companyId に属さないサロンが含まれる場合
 *     - BAD_REQUEST: 上記 SMS 送信ルール設定 validation を満たさない場合
 *     - NOT_FOUND: salonIds に存在しないサロン ID が含まれる場合
 */
export type UpdateSalonUsageStartDateInput = {
	/** 対象会社の ID。salonIds が当該会社に属するかの認可チェックに使用する。 */
	companyId: Scalars["String"]["input"]
	/** 利用開始日を更新する対象サロンの ID リスト。 */
	salonIds: Array<Scalars["Int"]["input"]>
	/** 設定する利用開始日。null の場合は NULL にクリアする。過去・当日・未来いずれも指定可能。 */
	usageStartDate?: InputMaybe<Scalars["Date"]["input"]>
}

export type UpdateSalonUsageStartDateResponse = {
	/** 更新されたサロン ID のリスト */
	salonIds: Array<Scalars["Int"]["output"]>
}

/**
 * 既存の Slack ユーザー / Subteam を更新する（souhl_admin のみ）。
 * - 対象の memberType が SLACK_USER の場合、souhlUserID は null 不可。
 * - 対象の memberType が SLACK_SUBTEAM の場合、souhlUserID / lineWorksUserID は指定不可（INVALID_ARGUMENT）。
 * - [error]
 *     - NOT_FOUND: 対象の slack_user が存在しない場合
 *     - NOT_FOUND: lineWorksUserID が指定されているが channel_users に存在しない場合
 *     - NOT_FOUND: souhlUserID が指定されているが idp に該当ユーザーが存在しない場合
 *     - INVALID_ARGUMENT: 対象の memberType が SLACK_USER の場合に souhlUserID が null の場合
 *     - INVALID_ARGUMENT: 対象の memberType が SLACK_SUBTEAM の場合に souhlUserID または lineWorksUserID が指定されている場合
 */
export type UpdateSlackUserInput = {
	/** 表示名 */
	displayName: Scalars["String"]["input"]
	/** 対象の Slack User ID or Subteam ID */
	id: Scalars["String"]["input"]
	/** channel_users.id（LINE Works ユーザーとの紐づけ。null で紐づけ解除。SLACK_SUBTEAM の場合は指定不可） */
	lineWorksUserID?: InputMaybe<Scalars["String"]["input"]>
	/** Cognito User Sub（SLACK_USER の場合は null 不可。SLACK_SUBTEAM の場合は指定不可） */
	souhlUserID?: InputMaybe<Scalars["String"]["input"]>
}

/** updateSlackUser のレスポンス */
export type UpdateSlackUserResponse = {
	/** 更新された Slack ユーザー */
	slackUser: SlackUser
}

export type UpdateTaigaMilestoneInput = {
	id: Scalars["String"]["input"]
	/** 変更しない場合は現在の値をそのまま渡す */
	isCollapsed: Scalars["Boolean"]["input"]
	/** 変更しない場合は現在の値をそのまま渡す */
	name: Scalars["String"]["input"]
}

export type UpdateTaigaMilestoneResponse = {
	milestone: TaigaMilestone
}

export type UpdateTaigaNodeInput = {
	id: Scalars["String"]["input"]
	/** 折りたたみ状態を設定する（省略時は変更しない） */
	isCollapsed?: InputMaybe<Scalars["Boolean"]["input"]>
	/** ノードの完了状態を設定する（省略時は変更しない） */
	isDone?: InputMaybe<Scalars["Boolean"]["input"]>
	/** 変更しない場合は現在の値をそのまま渡す */
	name: Scalars["String"]["input"]
}

export type UpdateTaigaNodeResponse = {
	node: TaigaNode
}

/**
 * セッションのメモを更新する。
 * memo が null または空文字の場合はメモをクリア（NULL に更新）する。
 * memo は 2000 文字以内であること。
 */
export type UpdateTaigaSessionMemoInput = {
	/** メモの内容。null または空文字の場合はメモをクリア */
	memo?: InputMaybe<Scalars["String"]["input"]>
	/** 対象ノード ID */
	nodeId: Scalars["String"]["input"]
}

export type UpdateTaigaSessionMemoResponse = {
	/** メモが更新されたノード */
	node: TaigaNode
}

/**
 * セッションステータスのユーザー操作による更新。
 * 主に PENDING 設定に使用するが、任意の status に変更可能。
 */
export type UpdateTaigaSessionStatusInput = {
	/** 対象ノード ID */
	nodeId: Scalars["String"]["input"]
	/** 更新後のステータス */
	status: TaigaSessionStatus
}

export type UpdateTaigaSessionStatusResponse = {
	node: TaigaNode
}

export type UpdateTaigaSheetInput = {
	id: Scalars["String"]["input"]
	name: Scalars["String"]["input"]
}

export type UpdateTaigaSheetResponse = {
	sheet: TaigaSheet
}

export type UpdateTaigaSlackMentionCommentInput = {
	/** コメント内容 */
	comment: Scalars["String"]["input"]
	/** 対象メンション ID */
	id: Scalars["String"]["input"]
}

export type UpdateTaigaSlackMentionCommentResponse = {
	mention: TaigaSlackMention
}

/**
 * タスクを更新する（souhl_admin のみ）。
 * COMPLETED 状態のタスクに対して呼び出すと FAILED_PRECONDITION エラーを返す。
 * memo / taskKindId / firstAssigneeSlackUserId / modifiedAssigneeSlackUserId / tagIds は
 * 全量指定（full replacement）。FE は現在値を初期値として送信する。
 * slackThreads は null = 変更なし（操作をスキップ）。SlackThreadsInput を渡すと newThreads を追加し、activeThread で指定したスレッドを active にする（他は deactivate）。
 * taskReminder は null = 変更なし。intervals 空配列 = 催促停止。intervals 非空 = 常に既存 reminder を soft delete し新規作成（next_reminder_time をリセット）。FE 側「リマインドを最初からやり直す」チェックがついた場合のみ送ること。
 * - [error]
 *     - UNAUTHORIZED: ServiceToken の検証に失敗する場合
 *     - PERMISSION_DENIED: ServiceToken が SouhlAdmin 権限を持たない場合
 *     - NOT_FOUND: taskId のタスクが存在しない場合
 *     - FAILED_PRECONDITION: taskId のタスクが既に COMPLETED の場合
 *     - NOT_FOUND: taskKindId / firstAssigneeSlackUserId / modifiedAssigneeSlackUserId / tagIds の FK 先が存在しない場合
 *     - INVALID_ARGUMENT: taskReminder.intervals が 5 個超、または 0 以下の値を含む場合
 */
export type UpdateTaskInput = {
	/** 最初の担当者の Slack User ID（null = 担当者を解除） */
	firstAssigneeSlackUserId?: InputMaybe<Scalars["String"]["input"]>
	/** メモ（null = メモをクリア） */
	memo?: InputMaybe<Scalars["String"]["input"]>
	/** 引き継ぎ後の担当者の Slack User ID（null = 担当者を解除） */
	modifiedAssigneeSlackUserId?: InputMaybe<Scalars["String"]["input"]>
	/** Slack スレッド（null = 変更なし。SlackThreadsInput を渡すと newThreads を追加し activeThread を active にする） */
	slackThreads?: InputMaybe<SlackThreadsInput>
	/** タグ ID 配列（全量指定。DELETE → INSERT で全量置換。空配列 = 全タグ解除） */
	tagIds: Array<Scalars["ID"]["input"]>
	/** 更新対象のタスク ID */
	taskId: Scalars["ID"]["input"]
	/** タスク種別 ID（FK → task_kinds.id） */
	taskKindId: Scalars["ID"]["input"]
	/** 催促スケジュール（null = 変更なし。intervals 空配列 = 催促停止。intervals 非空 = 常に既存 reminder を soft delete し新規作成（next_reminder_time をリセット）。FE 側「リマインドを最初からやり直す」チェックがついた場合のみ送ること） */
	taskReminder?: InputMaybe<TaskReminderInput>
}

/** タスク種別を更新する */
export type UpdateTaskKindInput = {
	/** 表示色（RGB） */
	color: RgbInput
	/** デフォルトの催促間隔（時間単位の配列、最大 5 個。空配列 = 催促なし） */
	defaultReminderIntervalDays: Array<Scalars["Int"]["input"]>
	/** 更新対象のタスク種別 ID */
	id: Scalars["String"]["input"]
	/** 表示名（ユニーク） */
	name: Scalars["String"]["input"]
}

/** updateTaskKind のレスポンス */
export type UpdateTaskKindResponse = {
	/** 更新されたタスク種別 */
	taskKind: TaskKind
}

/** updateTask のレスポンス */
export type UpdateTaskResponse = {
	/** 成功した場合は true */
	ok: Scalars["Boolean"]["output"]
}

/** タスクタグを更新する */
export type UpdateTaskTagInput = {
	/** 表示色（RGB） */
	color: RgbInput
	/** 更新対象のタスクタグ ID */
	id: Scalars["String"]["input"]
	/** タグ名（ユニーク） */
	name: Scalars["String"]["input"]
}

/** updateTaskTag のレスポンス */
export type UpdateTaskTagResponse = {
	/** 更新されたタスクタグ */
	taskTag: TaskTag
}

/**
 * 上野クリニック「入力シート」「入力シート_確定後キャンセル」の SOUHL 記載列を最新の配信実績で洗い替えする。
 *
 * - 対象列: 初回配信日 / 最新配信日 / 送付通数 / 送付ステータス / CV有無 (入力シートは M〜Q、確定後キャンセルは I〜M)
 * - 初回配信日は、まだ 1 通も送っていない行では初回配信の予定日を出す
 * - シートの行とキャンセルは「携帯電話番号 + 来院日 (確定後キャンセルは開始日付)」で突合する
 * - 突合できなかった行 (未取り込み・記入不備・未記入) は空欄にする
 * - 送付ステータスは再予約案内 (encourage_rereservation_reminders) の状態 (配信中 / 配信終了 / 希望来店日受信済み / 停止)
 * - CV有無は再来カウンセリング予約の受付 (rereservation_requests) があれば「有」
 *
 * - [error]
 *     - PERMISSION_DENIED: souhl_admin でないユーザーがアクセスした場合
 */
export type UpdateUenoClinicInputSheetInput = {
	Dummy?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** 上野クリニック 入力シートの更新結果 (入力シート / 入力シート_確定後キャンセル の合計) */
export type UpdateUenoClinicInputSheetResponse = {
	/** 配信実績を書き込めた行数 (キャンセルと突合できた行) */
	matchedRowCount: Scalars["Int"]["output"]
	/** SOUHL 記載列を書き込んだ行数 (空欄にした行を含む) */
	writtenRowCount: Scalars["Int"]["output"]
}

/**
 * タスクに紐づく Slack スレッドへファイルを添付投稿する。
 * primary (Nexus) token の files.getUploadURLExternal → upload URL への bytes POST →
 * files.completeUploadExternal (channel_id + thread_ts 指定) を proxy する。
 * comment がある場合のみ、postSlackThreadMessage と同じ "[表示名] " prefix を付けて
 * initial_comment として送る（comment なしなら initial_comment も付けない）。
 * GraphQL の base64 ペイロードのため、デコード後サイズの上限は 10MB。
 * primary bot に files:write scope が必要。
 * - [error]
 *     - PERMISSION_DENIED: souhl_admin でないユーザーがアクセスした場合
 *     - NOT_FOUND: (channelId, threadTs) が task_slack_threads に存在しない場合
 *     - BAD_REQUEST: filename が空白のみ / dataBase64 がデコードできない / デコード後サイズが 10MB を超える / comment が 4000 文字を超える場合
 *     - PRECONDITION_FAILED: primary bot (Nexus) 自身がチャンネル未参加の場合（join でも回復不能）
 *     - RESOURCE_EXHAUSTED: Slack API が rate limit (429) の場合
 *     - INTERNAL_ERROR: その他の Slack API エラー
 */
export type UploadSlackThreadFileInput = {
	/** Slack チャンネル ID */
	channelId: Scalars["String"]["input"]
	/** 添付と一緒に送る本文（plain text）。null / 空白のみなら initial_comment なしで添付のみ投稿する */
	comment?: InputMaybe<Scalars["String"]["input"]>
	/** ファイル内容の base64（standard encoding）。デコード後 10MB まで */
	dataBase64: Scalars["String"]["input"]
	/** ファイル名（Slack 上の title にもなる） */
	filename: Scalars["String"]["input"]
	/** MIME タイプ（upload URL への POST の Content-Type に使う） */
	mimetype: Scalars["String"]["input"]
	/** スレッド親メッセージの ts */
	threadTs: Scalars["String"]["input"]
}

/** uploadSlackThreadFile のレスポンス */
export type UploadSlackThreadFileResponse = {
	/** アップロードされた Slack file id。メッセージ ts は completeUploadExternal のレスポンスから確実に取れないため返さない（FE は polling で拾う） */
	fileId: Scalars["String"]["output"]
}

/**
 * `upsertSalonUsers` は指定された店舗に、複数のユーザーを結びつけます。
 * - やること
 *     - ある店舗に、指定された email のユーザーを結びつけます。
 *     - 指定された email のユーザーが存在しない場合、cognitoInitPassword レコード作成と、cognito のユーザーデータを作成します。
 *     - 指定された email のユーザーが既に存在する場合、Role を更新します。
 * - cognitoInitPassword レコード作成、 cognito のユーザー作成、db のレコード作成はそれぞれ atomic ではありませんが、
 *   retry することで整合性をとることが可能です。
 * - [error]
 *     - UNAUTHORIZED: ServiceToken の検証に失敗する場合
 *     - PERMISSION_DENIED: ServiceToken が SouhlAdmin 権限を持たない場合
 *     - NOT_FOUND: 指定された salon_id の Salon が存在しない場合
 *     - INVALID_ARGUMENT: OWNER role を持つユーザーがちょうど1人でない場合
 */
export type UpsertSalonUsersInput = {
	salonId: Scalars["Int"]["input"]
	users: Array<UpsertUserInput>
}

export type UpsertSalonUsersResponse = {
	success: Scalars["Boolean"]["output"]
}

export type UpsertUserInput = {
	email: Scalars["String"]["input"]
	role: Role
}

/** User はシステムの RefundHub ユーザーを表します */
export type User = {
	email: Scalars["String"]["output"]
	id: Scalars["String"]["output"]
	role: Role
}

/** verifyDataSourceLoginCredentials のレスポンス */
export type VerifyDataSourceLoginCredentialsResponse = {
	/** 新認証情報でのログイン検証で取得した媒体側の店舗情報 */
	storeInfo: Maybe<StoreInfo>
}

export type Join__Graph =
	| "ACCOUNTING_SOUHL_ADMIN"
	| "BIZDEV_SOUHL_ADMIN"
	| "CANCY_SOUHL_ADMIN"
	| "FEATURE_FLAG_SOUHL_ADMIN"
	| "IDP_SOUHL_ADMIN"
	| "NABEKO_SOUHL_ADMIN"
	| "NOTIFFY_SOUHL_ADMIN"
	| "TAIGA_SOUHL_ADMIN"

export type Link__Purpose =
	/** `EXECUTION` features provide metadata necessary for operation execution. */
	| "EXECUTION"
	/** `SECURITY` features provide metadata necessary to securely resolve fields. */
	| "SECURITY"

export type CreateSettlementMutationVariables = Exact<{
	input: CreateSettlementInput
}>

export type CreateSettlementMutation = {
	createSettlement: { created: boolean }
}

export type EnqueueSendAccountingEmailsBySettlementIDsMutationVariables =
	Exact<{
		input: EnqueueSendAccountingEmailsBySettlementIDsInput
	}>

export type EnqueueSendAccountingEmailsBySettlementIDsMutation = {
	enqueueSendAccountingEmailsBySettlementIDs: {
		enqueuedSettlementIds: Array<string>
	}
}

export type BulkUpdatePayoutSettlementStatuses_UpdateStatusMutationVariables =
	Exact<{
		input: BulkUpdatePayoutSettlementStatusesInput
	}>

export type BulkUpdatePayoutSettlementStatuses_UpdateStatusMutation = {
	bulkUpdatePayoutSettlementStatuses: { updatedSettlementIds: Array<string> }
}

export type BulkUpdateInvoiceSettlementStatuses_UpdateStatusMutationVariables =
	Exact<{
		input: BulkUpdateInvoiceSettlementStatusesInput
	}>

export type BulkUpdateInvoiceSettlementStatuses_UpdateStatusMutation = {
	bulkUpdateInvoiceSettlementStatuses: { updatedSettlementIds: Array<string> }
}

export type GetCompaniesQueryVariables = Exact<{ [key: string]: never }>

export type GetCompaniesQuery = {
	companies: {
		companies: Array<{
			" $fragmentRefs"?: { CompanyListTableFragment: CompanyListTableFragment }
		}>
	}
}

export type GetFeatureFlagsForListQueryVariables = Exact<{
	param: FeatureFlagsParam
}>

export type GetFeatureFlagsForListQuery = {
	featureFlags: {
		featureFlags: Array<{
			" $fragmentRefs"?: {
				CompanyListTableFeatureFlagFragment: CompanyListTableFeatureFlagFragment
			}
		}>
	}
}

export type CreateCompanyMutationVariables = Exact<{
	input: CreateCompanyInput
}>

export type CreateCompanyMutation = {
	createCompany: { company: { id: string; name: string } }
}

export type CreateDefaultCompanySmsSendingRuleV2MutationVariables = Exact<{
	input: CreateDefaultCompanySmsSendingRuleV2Input
}>

export type CreateDefaultCompanySmsSendingRuleV2Mutation = {
	createDefaultCompanySmsSendingRuleV2: { companyId: string }
}

export type GetCompanyNameQueryVariables = Exact<{
	param: CompanyParam
}>

export type GetCompanyNameQuery = {
	company: { company: { id: string; name: string } }
}

export type GetCompanyForEditQueryVariables = Exact<{
	param: CompanyParam
}>

export type GetCompanyForEditQuery = {
	company: { company: { id: string; name: string } }
}

export type UpdateCompanyMutationVariables = Exact<{
	input: UpdateCompanyInput
}>

export type UpdateCompanyMutation = {
	updateCompany: { company: { id: string; name: string } }
}

export type CompanyListTableFragment = {
	id: string
	name: string
	enabledFeatureFlagIds: Array<string>
} & { " $fragmentName"?: "CompanyListTableFragment" }

export type CompanyListTableFeatureFlagFragment = {
	id: string
	name: string
} & { " $fragmentName"?: "CompanyListTableFeatureFlagFragment" }

export type DatasourceConfigTableFragment = ({ id: number } & {
	" $fragmentRefs"?: {
		DatasourceConfigRowFragment: DatasourceConfigRowFragment
	}
}) & { " $fragmentName"?: "DatasourceConfigTableFragment" }

export type DatasourceConfigRowFragment = ({
	id: number
	displayName: string
	dataSourcePolicy: DataSourcePolicy
	goalDataSourcePolicy: DataSourcePolicy | null
	dataSourceConnectionStatuses: Array<
		{ dataSource: DataSource; hasIdPassError: boolean } & {
			" $fragmentRefs"?: {
				ConnectionStatusCellFragment: ConnectionStatusCellFragment
			}
		}
	>
} & { " $fragmentRefs"?: { MemoCellFragment: MemoCellFragment } }) & {
	" $fragmentName"?: "DatasourceConfigRowFragment"
}

export type ConnectionStatusCellFragment = {
	dataSourceStoreName: string | null
	hasIdPassError: boolean
	loginId: string | null
	storeId: string | null
} & { " $fragmentName"?: "ConnectionStatusCellFragment" }

export type MemoCellFragment = {
	id: number
	dataSourcePolicyMemo: string | null
} & { " $fragmentName"?: "MemoCellFragment" }

export type SalonStatusForDatasourceConfigFragment = {
	id: number
	dataSourcePolicy: DataSourcePolicy
	goalDataSourcePolicy: DataSourcePolicy | null
	dataSourceConnectionStatuses: Array<{ hasIdPassError: boolean }>
} & { " $fragmentName"?: "SalonStatusForDatasourceConfigFragment" }

export type GetCompanyForDatasourceConfigQueryVariables = Exact<{
	param: CompanyParam
}>

export type GetCompanyForDatasourceConfigQuery = {
	company: {
		company: {
			id: string
			salons: Array<{
				" $fragmentRefs"?: {
					SalonStatusForDatasourceConfigFragment: SalonStatusForDatasourceConfigFragment
					DatasourceConfigTableFragment: DatasourceConfigTableFragment
				}
			}>
		}
	}
}

export type GetDataSourceColumnsQueryVariables = Exact<{
	param: DataSourceColumnsParam
}>

export type GetDataSourceColumnsQuery = {
	dataSourceColumns: {
		dataSourceColumns: Array<{ dataSource: DataSource; label: string }>
	}
}

export type GetDataSourcePolicyOptionsQueryVariables = Exact<{
	param: DataSourcePolicyOptionsParam
}>

export type GetDataSourcePolicyOptionsQuery = {
	dataSourcePolicyOptions: Array<{ value: DataSourcePolicy; label: string }>
}

export type UpdateSalonGoalDataSourcePoliciesMutationVariables = Exact<{
	input: UpdateSalonGoalDataSourcePoliciesInput
}>

export type UpdateSalonGoalDataSourcePoliciesMutation = {
	updateSalonGoalDataSourcePolicies: { success: boolean }
}

export type UpdateSalonDataSourcePolicyMemoMutationVariables = Exact<{
	input: UpdateSalonDataSourcePolicyMemoInput
}>

export type UpdateSalonDataSourcePolicyMemoMutation = {
	updateSalonDataSourcePolicyMemo: {
		salon: { id: number; dataSourcePolicyMemo: string | null }
	}
}

export type GetDataSourceLoginPasswordMutationVariables = Exact<{
	input: GetDataSourceLoginPasswordInput
}>

export type GetDataSourceLoginPasswordMutation = {
	getDataSourceLoginPassword: { password: string }
}

export type FeatureFlagTabFragment = ({
	featureFlag: { id: string; name: string; comment: string }
} & {
	" $fragmentRefs"?: {
		CompanyWideRowCompanyFeatureFlagFragment: CompanyWideRowCompanyFeatureFlagFragment
		BulkToggleRowCompanyFeatureFlagFragment: BulkToggleRowCompanyFeatureFlagFragment
		SalonRowCompanyFeatureFlagFragment: SalonRowCompanyFeatureFlagFragment
	}
}) & { " $fragmentName"?: "FeatureFlagTabFragment" }

export type FeatureFlagTabSalonFragment = ({ id: number } & {
	" $fragmentRefs"?: {
		BulkToggleRowSalonFragment: BulkToggleRowSalonFragment
		SalonRowSalonFragment: SalonRowSalonFragment
	}
}) & { " $fragmentName"?: "FeatureFlagTabSalonFragment" }

export type BulkToggleRowCompanyFeatureFlagFragment = {
	featureFlag: { id: string }
} & { " $fragmentName"?: "BulkToggleRowCompanyFeatureFlagFragment" }

export type BulkToggleRowSalonFragment = { id: number } & {
	" $fragmentName"?: "BulkToggleRowSalonFragment"
}

export type CompanyWideRowCompanyFeatureFlagFragment = {
	featureFlag: { id: string }
} & { " $fragmentName"?: "CompanyWideRowCompanyFeatureFlagFragment" }

export type SalonRowCompanyFeatureFlagFragment = {
	featureFlag: { id: string }
} & { " $fragmentName"?: "SalonRowCompanyFeatureFlagFragment" }

export type SalonRowSalonFragment = { id: number; name: string } & {
	" $fragmentName"?: "SalonRowSalonFragment"
}

export type FeatureFlagTabEditStateFragment = {
	isCompanyWideEnabled: boolean
	enabledSalonIds: Array<number>
	featureFlag: { id: string }
} & { " $fragmentName"?: "FeatureFlagTabEditStateFragment" }

export type FeatureFlagTabSalonIdsFragment = { id: number } & {
	" $fragmentName"?: "FeatureFlagTabSalonIdsFragment"
}

export type GetCompanyFeatureFlagsQueryVariables = Exact<{
	param: CompanyFeatureFlagsParam
}>

export type GetCompanyFeatureFlagsQuery = {
	companyFeatureFlags: {
		companyFeatureFlags: Array<{
			" $fragmentRefs"?: {
				FeatureFlagTabEditStateFragment: FeatureFlagTabEditStateFragment
				FeatureFlagTabFragment: FeatureFlagTabFragment
			}
		}>
	}
}

export type GetCompanySalonsForFeatureFlagQueryVariables = Exact<{
	param: CompanyParam
}>

export type GetCompanySalonsForFeatureFlagQuery = {
	company: {
		company: {
			salons: Array<{
				" $fragmentRefs"?: {
					FeatureFlagTabSalonIdsFragment: FeatureFlagTabSalonIdsFragment
					FeatureFlagTabSalonFragment: FeatureFlagTabSalonFragment
				}
			}>
		}
	}
}

export type ToggleFeatureFlagsMutationVariables = Exact<{
	input: ToggleFeatureFlagsInput
}>

export type ToggleFeatureFlagsMutation = {
	toggleFeatureFlags: {
		companyFeatureFlags: Array<{
			" $fragmentRefs"?: {
				FeatureFlagTabEditStateFragment: FeatureFlagTabEditStateFragment
				FeatureFlagTabFragment: FeatureFlagTabFragment
			}
		}>
	}
}

export type ChangeHistoryFieldsFragment = {
	id: string
	cancelFeeCommissionRate: number
	existingCustomerRereservationCommissionRate: number
	newCustomerRereservationCommissionRate: number
	createTime: string
} & { " $fragmentName"?: "ChangeHistoryFieldsFragment" }

export type GetCompanyCommissionRatesQueryVariables = Exact<{
	param: GetCompanyCommissionRatesParam
}>

export type GetCompanyCommissionRatesQuery = {
	getCompanyCommissionRates: {
		companyCommissionRates: {
			companyId: string
			cancelFeeCommissionRate: number
			existingCustomerRereservationCommissionRate: number
			newCustomerRereservationCommissionRate: number
		}
	}
}

export type GetCompanyCommissionRateChangeHistoriesQueryVariables = Exact<{
	param: GetCompanyCommissionRateChangeHistoriesParam
}>

export type GetCompanyCommissionRateChangeHistoriesQuery = {
	getCompanyCommissionRateChangeHistories: {
		histories: Array<{
			" $fragmentRefs"?: {
				ChangeHistoryFieldsFragment: ChangeHistoryFieldsFragment
			}
		}>
	}
}

export type UpdateCompanyCommissionRatesMutationVariables = Exact<{
	input: UpdateCompanyCommissionRatesInput
}>

export type UpdateCompanyCommissionRatesMutation = {
	updateCompanyCommissionRates: {
		companyCommissionRates: {
			companyId: string
			cancelFeeCommissionRate: number
			existingCustomerRereservationCommissionRate: number
			newCustomerRereservationCommissionRate: number
		}
	}
}

export type GetCompanyForGeneralInfoQueryVariables = Exact<{
	param: CompanyParam
}>

export type GetCompanyForGeneralInfoQuery = {
	company: {
		company: {
			id: string
			name: string
			salons: Array<{ id: number; name: string; displayName: string }>
			lineGroups: Array<{ id: string; name: string }>
			hubspotContracts: Array<{
				" $fragmentRefs"?: {
					HubspotContractsSection_HubspotContractFragment: HubspotContractsSection_HubspotContractFragment
				}
			}>
		}
	}
}

export type GenerateFinLoginUrlForGeneralInfoTabMutationVariables = Exact<{
	input: GenerateFinLoginUrlInput
}>

export type GenerateFinLoginUrlForGeneralInfoTabMutation = {
	generateFinLoginUrl: { url: string }
}

export type HubspotContractsSection_HubspotContractFragment = {
	id: string
	name: string
	dealstage: string | null
	mainAssignee: string | null
	registerTime: string
} & { " $fragmentName"?: "HubspotContractsSection_HubspotContractFragment" }

export type UpdateCompanyHubspotContractIDsForGeneralInfoMutationVariables =
	Exact<{
		input: UpdateCompanyHubspotContractIDsInput
	}>

export type UpdateCompanyHubspotContractIDsForGeneralInfoMutation = {
	updateCompanyHubspotContractIDs: {
		hubspotContracts: Array<{
			" $fragmentRefs"?: {
				HubspotContractsSection_HubspotContractFragment: HubspotContractsSection_HubspotContractFragment
			}
		}>
	}
}

export type UpdateLineGroupAndCompanyMappingsForGeneralInfoMutationVariables =
	Exact<{
		input: UpdateLineGroupAndCompanyMappingsInput
	}>

export type UpdateLineGroupAndCompanyMappingsForGeneralInfoMutation = {
	updateLineGroupAndCompanyMappings: { updatedCount: number }
}

export type CompanyBySalonIdForSalonSelectQueryVariables = Exact<{
	param: CompanyBySalonIdParam
}>

export type CompanyBySalonIdForSalonSelectQuery = {
	companyBySalonId: { company: { id: string } }
}

export type UsageStartDateTabFragment = ({ id: number } & {
	" $fragmentRefs"?: {
		UsageStartDateTableRowFragment: UsageStartDateTableRowFragment
	}
}) & { " $fragmentName"?: "UsageStartDateTabFragment" }

export type GetCompanyForUsageStartDateQueryVariables = Exact<{
	param: CompanyParam
}>

export type GetCompanyForUsageStartDateQuery = {
	company: {
		currentCompany: {
			salons: Array<{
				" $fragmentRefs"?: {
					UsageStartDateTabFragment: UsageStartDateTabFragment
				}
			}>
		}
	}
}

export type UsageStartDateTableRowFragment = {
	id: number
	displayName: string
	usageStartDate: string | null
} & { " $fragmentName"?: "UsageStartDateTableRowFragment" }

export type UpdateSalonUsageStartDateMutationVariables = Exact<{
	input: UpdateSalonUsageStartDateInput
}>

export type UpdateSalonUsageStartDateMutation = {
	updateSalonUsageStartDate: { salonIds: Array<number> }
}

export type GetCompanySmsSendingRulesV2QueryVariables = Exact<{
	companyId: Scalars["String"]["input"]
}>

export type GetCompanySmsSendingRulesV2Query = {
	companySmsSendingRulesV2: {
		summaryText: string
		rules: Array<
			{ id: string; name: string } & {
				" $fragmentRefs"?: {
					CompanySmsSendingRuleV2ViewFragmentFragment: CompanySmsSendingRuleV2ViewFragmentFragment
				}
			}
		>
	}
}

export type GetCompanySmsSendingRulesV2ForMappingQueryVariables = Exact<{
	companyId: Scalars["String"]["input"]
}>

export type GetCompanySmsSendingRulesV2ForMappingQuery = {
	companySmsSendingRulesV2: { rules: Array<{ id: string; name: string }> }
}

export type GetCompanyForMappingQueryVariables = Exact<{
	param: CompanyParam
}>

export type GetCompanyForMappingQuery = {
	company: {
		currentCompany: {
			id: string
			salons: Array<{
				id: number
				displayName: string
				appliedCompanySmsSendingRule: { id: string } | null
			}>
		}
	}
}

export type UpdateSalonAndCompanySmsSendingRuleMappingsMutationVariables =
	Exact<{
		input: UpdateSalonAndCompanySmsSendingRuleMappingsInput
	}>

export type UpdateSalonAndCompanySmsSendingRuleMappingsMutation = {
	updateSalonAndCompanySmsSendingRuleMappings: { salonIds: Array<number> }
}

export type SmsSendingStartSettingsTableFragment = {
	id: number
	name: string
	displayName: string
	autoClaimBase: CompanySmsSendingRuleAutoClaimBase
	autoClaimStartDate: string | null
	encourageStartCancelDate: string | null
} & { " $fragmentName"?: "SmsSendingStartSettingsTableFragment" }

export type SmsSendingStartSettingsFragment = ({ id: number } & {
	" $fragmentRefs"?: {
		SmsSendingStartSettingsTableFragment: SmsSendingStartSettingsTableFragment
	}
}) & { " $fragmentName"?: "SmsSendingStartSettingsFragment" }

export type UpdateSalonSmsSendingStartSettingsMutationVariables = Exact<{
	input: UpdateSalonSmsSendingStartSettingsInput
}>

export type UpdateSalonSmsSendingStartSettingsMutation = {
	updateSalonSmsSendingStartSettings: { salonIds: Array<number> }
}

export type GetCompanyForSmsSendingStartSettingsQueryVariables = Exact<{
	param: CompanyParam
}>

export type GetCompanyForSmsSendingStartSettingsQuery = {
	company: {
		currentCompany: {
			salons: Array<{
				" $fragmentRefs"?: {
					SmsSendingStartSettingsFragment: SmsSendingStartSettingsFragment
				}
			}>
		}
	}
}

export type SummaryTextModalFragmentFragment = { summaryText: string } & {
	" $fragmentName"?: "SummaryTextModalFragmentFragment"
}

export type UpdateCompanySmsSendingRuleV2MutationVariables = Exact<{
	input: UpdateCompanySmsSendingRuleV2Input
}>

export type UpdateCompanySmsSendingRuleV2Mutation = {
	updateCompanySmsSendingRuleV2: { rule: { id: string } }
}

export type CreateCompanySmsSendingRuleV2MutationVariables = Exact<{
	input: CreateCompanySmsSendingRuleV2Input
}>

export type CreateCompanySmsSendingRuleV2Mutation = {
	createCompanySmsSendingRuleV2: { rule: { id: string } }
}

export type GetCompanySmsSendingRulesV2ForEditQueryVariables = Exact<{
	companyId: Scalars["String"]["input"]
}>

export type GetCompanySmsSendingRulesV2ForEditQuery = {
	companySmsSendingRulesV2: {
		rules: Array<{
			id: string
			name: string
			cancelPolicyTemplateType: CancelPolicyTemplateType
			selectableClaimingConversionPolicyNames: Array<string>
			selectableEncouragingRereservationPolicyNames: Array<string>
			cancelTypeSettings: Array<{
				id: string
				cancelType: CancelType
				cancelFeeAmountForNonZeroYenReservation: number | null
				cancelFeeAmountForZeroYenReservation: number
				cancelFeePercentForNonZeroYenReservation: number | null
				claimingConversionPolicyName: string | null
				encouragingRereservationPolicyName: string | null
				minVisitCountForClaimingConversion: number
				minVisitCountForEncouragingRereservation: number
				minVisitCountForManuallyClaimingCancelFee: number
				minVisitCountForNothing: number
				encouragingRereservationUnits: Array<{
					minVisitCount: number
					encouragingRereservationPolicyName: string
				}>
				manuallyClaimingUnits: Array<{
					minVisitCount: number
					manuallyClaimingUnitKind: ManuallyClaimingUnitKind | null
					conversionDays: number | null
				}>
			}>
		}>
	}
}

export type CompanySmsSendingRuleRowV2FragmentFragment = {
	cancelFeeAmountForNonZeroYenReservation: number | null
	cancelFeeAmountForZeroYenReservation: number
	cancelFeePercentForNonZeroYenReservation: number | null
	cancelType: CancelType
	claimingConversionPolicyName: string | null
	encouragingRereservationPolicyName: string | null
	isClaimableCancelType: boolean
	minVisitCountForClaimingConversion: number
	minVisitCountForEncouragingRereservation: number
	minVisitCountForManuallyClaimingCancelFee: number
	minVisitCountForNothing: number
	encouragingRereservationUnits: Array<{
		minVisitCount: number
		encouragingRereservationPolicyName: string
	}>
	manuallyClaimingUnits: Array<{
		minVisitCount: number
		manuallyClaimingUnitKind: ManuallyClaimingUnitKind | null
		conversionDays: number | null
	}>
} & { " $fragmentName"?: "CompanySmsSendingRuleRowV2FragmentFragment" }

export type CompanySmsSendingRuleV2ViewFragmentFragment = ({
	cancelPolicyTemplateType: CancelPolicyTemplateType
	companyId: string
	name: string
	selectableClaimingConversionPolicyNames: Array<string>
	selectableEncouragingRereservationPolicyNames: Array<string>
	cancelTypeSettings: Array<{
		" $fragmentRefs"?: {
			CompanySmsSendingRuleRowV2FragmentFragment: CompanySmsSendingRuleRowV2FragmentFragment
		}
	}>
} & {
	" $fragmentRefs"?: {
		SummaryTextModalFragmentFragment: SummaryTextModalFragmentFragment
	}
}) & { " $fragmentName"?: "CompanySmsSendingRuleV2ViewFragmentFragment" }

export type CreateKnownIssueMutationVariables = Exact<{
	input: CreateKnownIssueInput
}>

export type CreateKnownIssueMutation = {
	createKnownIssue: { knownIssue: { id: string } }
}

export type GetKnownIssueQueryVariables = Exact<{
	id: Scalars["String"]["input"]
}>

export type GetKnownIssueQuery = {
	knownIssue: {
		knownIssue: {
			id: string
			status: KnownIssueStatus
			description: string
			issueType: IssueType
			logLevel: LogLevel
			logMatchMethod: LogMatchMethod
			logKeyword: string
			logModuleName: string
			logKind: string | null
			logSalonIds: Array<number>
			slackChannelNameToNotify: string
			thresholdCountToNotify: number
			cooldownHoursToNotify: number | null
			autoResolveDaysAfterLastActivity: number
			shouldSendIosCriticalNotification: boolean
			registerTime: string
			issueModifiedTime: string
			latestAlertedTime: string | null
			opensearchQueryUrl: string
			mentionTargets: Array<{ slackMentionTargetId: string; name: string }>
		}
	}
}

export type GetKnownIssueDaySummaryQueryVariables = Exact<{
	id: Scalars["String"]["input"]
}>

export type GetKnownIssueDaySummaryQuery = {
	knownIssueDaySummary: {
		daySummaries: Array<{
			" $fragmentRefs"?: {
				KnownIssueDaySummaryFragmentFragment: KnownIssueDaySummaryFragmentFragment
			}
		}>
	}
}

export type ResolveKnownIssueDetailMutationVariables = Exact<{
	input: ResolveKnownIssuesInput
}>

export type ResolveKnownIssueDetailMutation = {
	resolveKnownIssues: { ids: Array<string> }
}

export type CloseKnownIssueDetailMutationVariables = Exact<{
	input: CloseKnownIssuesInput
}>

export type CloseKnownIssueDetailMutation = {
	closeKnownIssues: { ids: Array<string> }
}

export type ReopenKnownIssueDetailMutationVariables = Exact<{
	input: ReopenKnownIssuesInput
}>

export type ReopenKnownIssueDetailMutation = {
	reopenKnownIssues: { ids: Array<string> }
}

export type GetKnownIssueForEditQueryVariables = Exact<{
	id: Scalars["String"]["input"]
}>

export type GetKnownIssueForEditQuery = {
	knownIssue: {
		knownIssue: {
			id: string
			description: string
			issueType: IssueType
			logLevel: LogLevel
			logMatchMethod: LogMatchMethod
			logKeyword: string
			logModuleName: string
			logKind: string | null
			logSalonIds: Array<number>
			slackChannelNameToNotify: string
			thresholdCountToNotify: number
			cooldownHoursToNotify: number | null
			autoResolveDaysAfterLastActivity: number
			shouldSendIosCriticalNotification: boolean
			mentionTargets: Array<{ slackMentionTargetId: string }>
		}
	}
}

export type UpdateKnownIssueMutationVariables = Exact<{
	input: UpdateKnownIssueInput
}>

export type UpdateKnownIssueMutation = {
	updateKnownIssue: { knownIssue: { id: string } }
}

export type GetSlackMentionTargetsQueryVariables = Exact<{
	[key: string]: never
}>

export type GetSlackMentionTargetsQuery = {
	slackMentionTargets: { targets: Array<{ id: string; name: string }> }
}

export type KnownIssueListTableFragment = {
	id: string
	description: string
	issueType: IssueType
	logLevel: LogLevel
	logModuleName: string
	logKind: string | null
	logSalonIds: Array<number>
	status: KnownIssueStatus
	logKeyword: string
	logMatchMethod: LogMatchMethod
	opensearchQueryUrl: string
	slackChannelNameToNotify: string
	thresholdCountToNotify: number
	cooldownHoursToNotify: number | null
	autoResolveDaysAfterLastActivity: number
	shouldSendIosCriticalNotification: boolean
	registerTime: string
	issueModifiedTime: string
	mentionTargets: Array<{ slackMentionTargetId: string; name: string }>
} & { " $fragmentName"?: "KnownIssueListTableFragment" }

export type KnownIssueIdFragment = { id: string } & {
	" $fragmentName"?: "KnownIssueIdFragment"
}

export type GetKnownIssuesQueryVariables = Exact<{
	param: InputMaybe<KnownIssuesParam>
}>

export type GetKnownIssuesQuery = {
	knownIssues: {
		knownIssues: Array<{
			" $fragmentRefs"?: {
				KnownIssueIdFragment: KnownIssueIdFragment
				KnownIssueListTableFragment: KnownIssueListTableFragment
			}
		}>
	}
}

export type GetKnownIssueDaySummariesQueryVariables = Exact<{
	ids: Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
}>

export type GetKnownIssueDaySummariesQuery = {
	knownIssueDaySummaries: {
		summaries: Array<{
			knownIssueId: string
			last24HoursMatchCount: number
			daySummaries: Array<{
				" $fragmentRefs"?: {
					KnownIssueDaySummaryFragmentFragment: KnownIssueDaySummaryFragmentFragment
				}
			}>
		}>
	}
}

export type ResolveKnownIssuesMutationVariables = Exact<{
	input: ResolveKnownIssuesInput
}>

export type ResolveKnownIssuesMutation = {
	resolveKnownIssues: { ids: Array<string> }
}

export type CloseKnownIssuesMutationVariables = Exact<{
	input: CloseKnownIssuesInput
}>

export type CloseKnownIssuesMutation = {
	closeKnownIssues: { ids: Array<string> }
}

export type ReopenKnownIssuesMutationVariables = Exact<{
	input: ReopenKnownIssuesInput
}>

export type ReopenKnownIssuesMutation = {
	reopenKnownIssues: { ids: Array<string> }
}

export type KnownIssueDaySummaryFragmentFragment = {
	date: string
	matchLogCount: number
	sampleReqId: string | null
	sampleMessage: string | null
} & { " $fragmentName"?: "KnownIssueDaySummaryFragmentFragment" }

export type TaigaSlackMentionMetaFragment = {
	id: string
	channelId: string
	threadTs: string | null
	messageTs: string
	permalink: string | null
	dueDate: string
	comment: string
	priority: number
	senderDisplayName: string
	embeddedNode: {
		id: string
		isDone: boolean
		isArchived: boolean
		session: {
			sessionStatus: TaigaSessionStatus
			isRemoteControlEnabled: boolean
			memo: string | null
		} | null
	} | null
	childNodes: Array<{
		id: string
		isDone: boolean
		isArchived: boolean
		session: {
			sessionStatus: TaigaSessionStatus
			isRemoteControlEnabled: boolean
			memo: string | null
		} | null
	}>
} & { " $fragmentName"?: "TaigaSlackMentionMetaFragment" }

export type GetSlackMentionsQueryVariables = Exact<{
	param: TaigaSlackMentionsParam
}>

export type GetSlackMentionsQuery = {
	taigaSlackMentions: {
		mentions: Array<{
			" $fragmentRefs"?: {
				TaigaSlackMentionMetaFragment: TaigaSlackMentionMetaFragment
				SlackMentionsSectionMentionFragment: SlackMentionsSectionMentionFragment
			}
		}>
	}
}

export type GetSlackMentionSyncStateQueryVariables = Exact<{
	param: TaigaSlackMentionSyncStateParam
}>

export type GetSlackMentionSyncStateQuery = {
	taigaSlackMentionSyncState: {
		syncState: {
			" $fragmentRefs"?: {
				SlackMentionsSectionSyncStateFragment: SlackMentionsSectionSyncStateFragment
			}
		}
	}
}

export type CompleteSlackMentionMutationVariables = Exact<{
	input: CompleteTaigaSlackMentionInput
}>

export type CompleteSlackMentionMutation = {
	completeTaigaSlackMention: { mention: { id: string } }
}

export type SetSlackMentionDueDateMutationVariables = Exact<{
	input: SetTaigaSlackMentionDueDateInput
}>

export type SetSlackMentionDueDateMutation = {
	setTaigaSlackMentionDueDate: { mention: { id: string; dueDate: string } }
}

export type PriorityUpSlackMentionMutationVariables = Exact<{
	input: PriorityUpTaigaSlackMentionInput
}>

export type PriorityUpSlackMentionMutation = {
	priorityUpTaigaSlackMention: { mention: { id: string; priority: number } }
}

export type PriorityDownSlackMentionMutationVariables = Exact<{
	input: PriorityDownTaigaSlackMentionInput
}>

export type PriorityDownSlackMentionMutation = {
	priorityDownTaigaSlackMention: { mention: { id: string; priority: number } }
}

export type UpdateSlackMentionCommentMutationVariables = Exact<{
	input: UpdateTaigaSlackMentionCommentInput
}>

export type UpdateSlackMentionCommentMutation = {
	updateTaigaSlackMentionComment: { mention: { id: string; comment: string } }
}

export type SyncTaigaSlackMentionsMutationVariables = Exact<{
	input: SyncTaigaSlackMentionsInput
}>

export type SyncTaigaSlackMentionsMutation = {
	syncTaigaSlackMentions: { upsertedCount: number }
}

export type CreateTaigaSlackMentionMutationVariables = Exact<{
	input: CreateTaigaSlackMentionInput
}>

export type CreateTaigaSlackMentionMutation = {
	createTaigaSlackMention: { mention: { id: string } }
}

export type CreateTaigaNodeUnderSlackMentionMutationVariables = Exact<{
	input: CreateTaigaNodeUnderSlackMentionInput
}>

export type CreateTaigaNodeUnderSlackMentionMutation = {
	createTaigaNodeUnderSlackMention: {
		node: {
			id: string
			milestoneId: string | null
			parentNodeId: string | null
			name: string
			isArchived: boolean
			order: number
			isDone: boolean
			isCollapsed: boolean
		}
	}
}

export type HandOverTaigaEmbedSessionMutationVariables = Exact<{
	input: HandOverTaigaEmbedSessionInput
}>

export type HandOverTaigaEmbedSessionMutation = {
	handOverTaigaEmbedSession: {
		node: {
			id: string
			milestoneId: string | null
			parentNodeId: string | null
			name: string
			isArchived: boolean
			order: number
			isDone: boolean
			isCollapsed: boolean
		}
	}
}

export type ToggleTaigaSlackMentionChildNodesCollapsedMutationVariables =
	Exact<{
		input: ToggleTaigaSlackMentionChildNodesCollapsedInput
	}>

export type ToggleTaigaSlackMentionChildNodesCollapsedMutation = {
	toggleTaigaSlackMentionChildNodesCollapsed: {
		mention: { id: string; isChildNodesCollapsed: boolean }
	}
}

export type UpdateTaigaNodeForMentionMutationVariables = Exact<{
	input: UpdateTaigaNodeInput
}>

export type UpdateTaigaNodeForMentionMutation = {
	updateTaigaNode: {
		node: { id: string; name: string; isCollapsed: boolean; isDone: boolean }
	}
}

export type ArchiveTaigaNodeForMentionMutationVariables = Exact<{
	input: ArchiveTaigaNodeInput
}>

export type ArchiveTaigaNodeForMentionMutation = {
	archiveTaigaNode: { node: { id: string; isArchived: boolean } }
}

export type CreateTaigaNodeForMentionMutationVariables = Exact<{
	input: CreateTaigaNodeInput
}>

export type CreateTaigaNodeForMentionMutation = {
	createTaigaNode: {
		node: {
			id: string
			milestoneId: string | null
			parentNodeId: string | null
			name: string
			isArchived: boolean
			order: number
			isDone: boolean
			isCollapsed: boolean
		}
	}
}

export type PriorityUpTaigaNodeForMentionMutationVariables = Exact<{
	input: PriorityUpTaigaNodeInput
}>

export type PriorityUpTaigaNodeForMentionMutation = {
	priorityUpTaigaNode: {
		updatedNodes: Array<{ id: string; parallelPriority: number | null }>
	}
}

export type PriorityDownTaigaNodeForMentionMutationVariables = Exact<{
	input: PriorityDownTaigaNodeInput
}>

export type PriorityDownTaigaNodeForMentionMutation = {
	priorityDownTaigaNode: {
		updatedNodes: Array<{ id: string; parallelPriority: number | null }>
	}
}

export type CreateTaigaSessionForMentionMutationVariables = Exact<{
	input: CreateTaigaSessionInput
}>

export type CreateTaigaSessionForMentionMutation = {
	createTaigaSession: {
		node: {
			id: string
			isDone: boolean
			session: {
				threadTs: string
				channelId: string
				sessionStatus: TaigaSessionStatus
				memo: string | null
				ccSessionId: string | null
				claudeRemoteControlSessionId: string | null
			} | null
		}
	}
}

export type CompleteTaigaSessionForMentionMutationVariables = Exact<{
	input: CompleteTaigaSessionInput
}>

export type CompleteTaigaSessionForMentionMutation = {
	completeTaigaSession: {
		node: {
			id: string
			isDone: boolean
			session: {
				threadTs: string
				channelId: string
				sessionStatus: TaigaSessionStatus
				memo: string | null
				ccSessionId: string | null
				claudeRemoteControlSessionId: string | null
			} | null
		}
	}
}

export type ForkTaigaSessionForMentionMutationVariables = Exact<{
	input: ForkTaigaSessionInput
}>

export type ForkTaigaSessionForMentionMutation = {
	forkTaigaSession: {
		node: {
			id: string
			isDone: boolean
			session: {
				threadTs: string
				channelId: string
				sessionStatus: TaigaSessionStatus
				memo: string | null
				ccSessionId: string | null
				claudeRemoteControlSessionId: string | null
			} | null
		}
	}
}

export type UpdateTaigaSessionStatusForMentionMutationVariables = Exact<{
	input: UpdateTaigaSessionStatusInput
}>

export type UpdateTaigaSessionStatusForMentionMutation = {
	updateTaigaSessionStatus: {
		node: {
			id: string
			isDone: boolean
			session: {
				threadTs: string
				channelId: string
				sessionStatus: TaigaSessionStatus
				memo: string | null
				ccSessionId: string | null
				claudeRemoteControlSessionId: string | null
			} | null
		}
	}
}

export type UpdateTaigaSessionMemoForMentionMutationVariables = Exact<{
	input: UpdateTaigaSessionMemoInput
}>

export type UpdateTaigaSessionMemoForMentionMutation = {
	updateTaigaSessionMemo: {
		node: {
			id: string
			isDone: boolean
			session: {
				threadTs: string
				channelId: string
				sessionStatus: TaigaSessionStatus
				memo: string | null
				ccSessionId: string | null
				claudeRemoteControlSessionId: string | null
			} | null
		}
	}
}

export type MoveTaigaNodeForMentionMutationVariables = Exact<{
	input: MoveTaigaNodeInput
}>

export type MoveTaigaNodeForMentionMutation = {
	moveTaigaNode: {
		node: {
			id: string
			milestoneId: string | null
			parentNodeId: string | null
			order: number
		}
	}
}

export type ReorderTaigaNodesForMentionMutationVariables = Exact<{
	input: ReorderTaigaNodesInput
}>

export type ReorderTaigaNodesForMentionMutation = {
	reorderTaigaNodes: { nodes: Array<{ id: string; order: number }> }
}

export type AttachTaigaSlackThreadForMentionMutationVariables = Exact<{
	input: AttachTaigaSlackThreadInput
}>

export type AttachTaigaSlackThreadForMentionMutation = {
	attachTaigaSlackThread: {
		node: {
			id: string
			isDone: boolean
			session: {
				threadTs: string
				channelId: string
				sessionStatus: TaigaSessionStatus
				memo: string | null
				ccSessionId: string | null
				claudeRemoteControlSessionId: string | null
			} | null
		}
	}
}

export type GetLatestThreadTsForMentionQueryVariables = Exact<{
	param: TaigaLatestThreadTsParam
}>

export type GetLatestThreadTsForMentionQuery = {
	taigaLatestThreadTs: { ts: string }
}

export type GetSlackLatestReplyTsQueryVariables = Exact<{
	param: SlackLatestReplyTsParam
}>

export type GetSlackLatestReplyTsQuery = { slackLatestReplyTs: { ts: string } }

export type GetSessionBranchNameForMentionQueryVariables = Exact<{
	param: TaigaSessionBranchNameParam
}>

export type GetSessionBranchNameForMentionQuery = {
	taigaSessionBranchName: { branchName: string | null }
}

export type GetSessionStatusesQueryVariables = Exact<{
	param: TaigaSessionStatusesParam
}>

export type GetSessionStatusesQuery = {
	taigaSessionStatuses: {
		sessions: Array<{
			nodeId: string
			isDone: boolean
			session: {
				threadTs: string
				channelId: string
				sessionStatus: TaigaSessionStatus
				isRemoteControlEnabled: boolean
				memo: string | null
				ccSessionId: string | null
				claudeRemoteControlSessionId: string | null
			}
		}>
	}
}

export type MentionRowFragment = {
	id: string
	channelId: string
	threadTs: string | null
	messageTs: string
	senderDisplayName: string
	channelName: string | null
	text: string
	permalink: string | null
	dueDate: string
	comment: string
	priority: number
	slackMessageTime: string
	isChildNodesCollapsed: boolean
	childNodesCount: number
	embeddedNode: {
		id: string
		name: string
		isDone: boolean
		session: {
			sessionStatus: TaigaSessionStatus
			isRemoteControlEnabled: boolean
			memo: string | null
			threadTs: string
			channelId: string
			ccSessionId: string | null
			claudeRemoteControlSessionId: string | null
			worktreePath: string | null
		} | null
	} | null
	childNodes: Array<{
		id: string
		milestoneId: string | null
		parentNodeId: string | null
		name: string
		parallelPriority: number | null
		isArchived: boolean
		order: number
		isDone: boolean
		isCollapsed: boolean
		session: {
			threadTs: string
			channelId: string
			sessionStatus: TaigaSessionStatus
			isRemoteControlEnabled: boolean
			memo: string | null
			ccSessionId: string | null
			claudeRemoteControlSessionId: string | null
			worktreePath: string | null
		} | null
	}>
} & { " $fragmentName"?: "MentionRowFragment" }

export type SlackMentionsSectionMentionFragment = ({
	id: string
	isChildNodesCollapsed: boolean
	childNodesCount: number
} & { " $fragmentRefs"?: { MentionRowFragment: MentionRowFragment } }) & {
	" $fragmentName"?: "SlackMentionsSectionMentionFragment"
}

export type SlackMentionsSectionSyncStateFragment = { lastSyncTime: string } & {
	" $fragmentName"?: "SlackMentionsSectionSyncStateFragment"
}

export type UnknownIssueLogsQueryVariables = Exact<{
	param: InputMaybe<UnknownIssueLogsParam>
}>

export type UnknownIssueLogsQuery = {
	unknownIssueLogs: {
		totalCount: number
		logs: Array<{
			time: string
			reqId: string
			level: LogLevel
			message: string
			moduleName: string
			kind: string | null
			salonId: number | null
			opensearchUrl: string
		}>
	}
}

export type HideUnknownIssueLogsMutationVariables = Exact<{
	input: HideUnknownIssueLogsInput
}>

export type HideUnknownIssueLogsMutation = {
	hideUnknownIssueLogs: { hiddenCount: number }
}

export type GetCancelTypeTextsQueryVariables = Exact<{ [key: string]: never }>

export type GetCancelTypeTextsQuery = {
	cancelTypeTexts: Array<{ cancelType: CancelType; text: string }>
}

export type GetCurrentCompanyIdForCompanyAdminQueryVariables = Exact<{
	param: CompanyBySalonIdParam
}>

export type GetCurrentCompanyIdForCompanyAdminQuery = {
	companyBySalonId: { company: { id: string } }
}

export const CompanyListTableFragmentDoc = {
	kind: "Document",
	definitions: [
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "CompanyListTable" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "Company" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "name" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "enabledFeatureFlagIds" },
					},
				],
			},
		},
	],
} as unknown as DocumentNode<CompanyListTableFragment, unknown>
export const CompanyListTableFeatureFlagFragmentDoc = {
	kind: "Document",
	definitions: [
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "CompanyListTableFeatureFlag" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "FeatureFlag" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "name" } },
				],
			},
		},
	],
} as unknown as DocumentNode<CompanyListTableFeatureFlagFragment, unknown>
export const MemoCellFragmentDoc = {
	kind: "Document",
	definitions: [
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "MemoCell" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "Salon" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "dataSourcePolicyMemo" },
					},
				],
			},
		},
	],
} as unknown as DocumentNode<MemoCellFragment, unknown>
export const ConnectionStatusCellFragmentDoc = {
	kind: "Document",
	definitions: [
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "ConnectionStatusCell" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "DataSourceConnectionStatus" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "dataSourceStoreName" },
					},
					{ kind: "Field", name: { kind: "Name", value: "hasIdPassError" } },
					{ kind: "Field", name: { kind: "Name", value: "loginId" } },
					{ kind: "Field", name: { kind: "Name", value: "storeId" } },
				],
			},
		},
	],
} as unknown as DocumentNode<ConnectionStatusCellFragment, unknown>
export const DatasourceConfigRowFragmentDoc = {
	kind: "Document",
	definitions: [
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "DatasourceConfigRow" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "Salon" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "displayName" } },
					{ kind: "Field", name: { kind: "Name", value: "dataSourcePolicy" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "goalDataSourcePolicy" },
					},
					{ kind: "FragmentSpread", name: { kind: "Name", value: "MemoCell" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "dataSourceConnectionStatuses" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "dataSource" } },
								{
									kind: "Field",
									name: { kind: "Name", value: "hasIdPassError" },
								},
								{
									kind: "FragmentSpread",
									name: { kind: "Name", value: "ConnectionStatusCell" },
								},
							],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "MemoCell" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "Salon" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "dataSourcePolicyMemo" },
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "ConnectionStatusCell" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "DataSourceConnectionStatus" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "dataSourceStoreName" },
					},
					{ kind: "Field", name: { kind: "Name", value: "hasIdPassError" } },
					{ kind: "Field", name: { kind: "Name", value: "loginId" } },
					{ kind: "Field", name: { kind: "Name", value: "storeId" } },
				],
			},
		},
	],
} as unknown as DocumentNode<DatasourceConfigRowFragment, unknown>
export const DatasourceConfigTableFragmentDoc = {
	kind: "Document",
	definitions: [
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "DatasourceConfigTable" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "Salon" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{
						kind: "FragmentSpread",
						name: { kind: "Name", value: "DatasourceConfigRow" },
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "MemoCell" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "Salon" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "dataSourcePolicyMemo" },
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "ConnectionStatusCell" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "DataSourceConnectionStatus" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "dataSourceStoreName" },
					},
					{ kind: "Field", name: { kind: "Name", value: "hasIdPassError" } },
					{ kind: "Field", name: { kind: "Name", value: "loginId" } },
					{ kind: "Field", name: { kind: "Name", value: "storeId" } },
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "DatasourceConfigRow" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "Salon" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "displayName" } },
					{ kind: "Field", name: { kind: "Name", value: "dataSourcePolicy" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "goalDataSourcePolicy" },
					},
					{ kind: "FragmentSpread", name: { kind: "Name", value: "MemoCell" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "dataSourceConnectionStatuses" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "dataSource" } },
								{
									kind: "Field",
									name: { kind: "Name", value: "hasIdPassError" },
								},
								{
									kind: "FragmentSpread",
									name: { kind: "Name", value: "ConnectionStatusCell" },
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<DatasourceConfigTableFragment, unknown>
export const SalonStatusForDatasourceConfigFragmentDoc = {
	kind: "Document",
	definitions: [
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "SalonStatusForDatasourceConfig" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "Salon" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "dataSourcePolicy" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "goalDataSourcePolicy" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "dataSourceConnectionStatuses" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "hasIdPassError" },
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<SalonStatusForDatasourceConfigFragment, unknown>
export const CompanyWideRowCompanyFeatureFlagFragmentDoc = {
	kind: "Document",
	definitions: [
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "CompanyWideRowCompanyFeatureFlag" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "CompanyFeatureFlag" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "featureFlag" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "id" } },
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<CompanyWideRowCompanyFeatureFlagFragment, unknown>
export const BulkToggleRowCompanyFeatureFlagFragmentDoc = {
	kind: "Document",
	definitions: [
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "BulkToggleRowCompanyFeatureFlag" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "CompanyFeatureFlag" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "featureFlag" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "id" } },
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<BulkToggleRowCompanyFeatureFlagFragment, unknown>
export const SalonRowCompanyFeatureFlagFragmentDoc = {
	kind: "Document",
	definitions: [
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "SalonRowCompanyFeatureFlag" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "CompanyFeatureFlag" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "featureFlag" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "id" } },
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<SalonRowCompanyFeatureFlagFragment, unknown>
export const FeatureFlagTabFragmentDoc = {
	kind: "Document",
	definitions: [
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "FeatureFlagTab" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "CompanyFeatureFlag" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "featureFlag" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "id" } },
								{ kind: "Field", name: { kind: "Name", value: "name" } },
								{ kind: "Field", name: { kind: "Name", value: "comment" } },
							],
						},
					},
					{
						kind: "FragmentSpread",
						name: { kind: "Name", value: "CompanyWideRowCompanyFeatureFlag" },
					},
					{
						kind: "FragmentSpread",
						name: { kind: "Name", value: "BulkToggleRowCompanyFeatureFlag" },
					},
					{
						kind: "FragmentSpread",
						name: { kind: "Name", value: "SalonRowCompanyFeatureFlag" },
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "CompanyWideRowCompanyFeatureFlag" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "CompanyFeatureFlag" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "featureFlag" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "id" } },
							],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "BulkToggleRowCompanyFeatureFlag" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "CompanyFeatureFlag" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "featureFlag" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "id" } },
							],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "SalonRowCompanyFeatureFlag" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "CompanyFeatureFlag" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "featureFlag" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "id" } },
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<FeatureFlagTabFragment, unknown>
export const BulkToggleRowSalonFragmentDoc = {
	kind: "Document",
	definitions: [
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "BulkToggleRowSalon" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "Salon" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
			},
		},
	],
} as unknown as DocumentNode<BulkToggleRowSalonFragment, unknown>
export const SalonRowSalonFragmentDoc = {
	kind: "Document",
	definitions: [
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "SalonRowSalon" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "Salon" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "name" } },
				],
			},
		},
	],
} as unknown as DocumentNode<SalonRowSalonFragment, unknown>
export const FeatureFlagTabSalonFragmentDoc = {
	kind: "Document",
	definitions: [
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "FeatureFlagTabSalon" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "Salon" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{
						kind: "FragmentSpread",
						name: { kind: "Name", value: "BulkToggleRowSalon" },
					},
					{
						kind: "FragmentSpread",
						name: { kind: "Name", value: "SalonRowSalon" },
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "BulkToggleRowSalon" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "Salon" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "SalonRowSalon" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "Salon" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "name" } },
				],
			},
		},
	],
} as unknown as DocumentNode<FeatureFlagTabSalonFragment, unknown>
export const FeatureFlagTabEditStateFragmentDoc = {
	kind: "Document",
	definitions: [
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "FeatureFlagTabEditState" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "CompanyFeatureFlag" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "featureFlag" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "id" } },
							],
						},
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "isCompanyWideEnabled" },
					},
					{ kind: "Field", name: { kind: "Name", value: "enabledSalonIds" } },
				],
			},
		},
	],
} as unknown as DocumentNode<FeatureFlagTabEditStateFragment, unknown>
export const FeatureFlagTabSalonIdsFragmentDoc = {
	kind: "Document",
	definitions: [
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "FeatureFlagTabSalonIds" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "Salon" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
			},
		},
	],
} as unknown as DocumentNode<FeatureFlagTabSalonIdsFragment, unknown>
export const ChangeHistoryFieldsFragmentDoc = {
	kind: "Document",
	definitions: [
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "ChangeHistoryFields" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "CompanyCommissionRateChangeHistory" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "cancelFeeCommissionRate" },
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "existingCustomerRereservationCommissionRate",
						},
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "newCustomerRereservationCommissionRate",
						},
					},
					{ kind: "Field", name: { kind: "Name", value: "createTime" } },
				],
			},
		},
	],
} as unknown as DocumentNode<ChangeHistoryFieldsFragment, unknown>
export const HubspotContractsSection_HubspotContractFragmentDoc = {
	kind: "Document",
	definitions: [
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "HubspotContractsSection_HubspotContract" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "HubspotContract" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "name" } },
					{ kind: "Field", name: { kind: "Name", value: "dealstage" } },
					{ kind: "Field", name: { kind: "Name", value: "mainAssignee" } },
					{ kind: "Field", name: { kind: "Name", value: "registerTime" } },
				],
			},
		},
	],
} as unknown as DocumentNode<
	HubspotContractsSection_HubspotContractFragment,
	unknown
>
export const UsageStartDateTableRowFragmentDoc = {
	kind: "Document",
	definitions: [
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "UsageStartDateTableRow" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "Salon" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "displayName" } },
					{ kind: "Field", name: { kind: "Name", value: "usageStartDate" } },
				],
			},
		},
	],
} as unknown as DocumentNode<UsageStartDateTableRowFragment, unknown>
export const UsageStartDateTabFragmentDoc = {
	kind: "Document",
	definitions: [
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "UsageStartDateTab" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "Salon" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{
						kind: "FragmentSpread",
						name: { kind: "Name", value: "UsageStartDateTableRow" },
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "UsageStartDateTableRow" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "Salon" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "displayName" } },
					{ kind: "Field", name: { kind: "Name", value: "usageStartDate" } },
				],
			},
		},
	],
} as unknown as DocumentNode<UsageStartDateTabFragment, unknown>
export const SmsSendingStartSettingsTableFragmentDoc = {
	kind: "Document",
	definitions: [
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "smsSendingStartSettingsTable" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "Salon" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "name" } },
					{ kind: "Field", name: { kind: "Name", value: "displayName" } },
					{ kind: "Field", name: { kind: "Name", value: "autoClaimBase" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "autoClaimStartDate" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "encourageStartCancelDate" },
					},
				],
			},
		},
	],
} as unknown as DocumentNode<SmsSendingStartSettingsTableFragment, unknown>
export const SmsSendingStartSettingsFragmentDoc = {
	kind: "Document",
	definitions: [
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "smsSendingStartSettings" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "Salon" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{
						kind: "FragmentSpread",
						name: { kind: "Name", value: "smsSendingStartSettingsTable" },
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "smsSendingStartSettingsTable" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "Salon" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "name" } },
					{ kind: "Field", name: { kind: "Name", value: "displayName" } },
					{ kind: "Field", name: { kind: "Name", value: "autoClaimBase" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "autoClaimStartDate" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "encourageStartCancelDate" },
					},
				],
			},
		},
	],
} as unknown as DocumentNode<SmsSendingStartSettingsFragment, unknown>
export const CompanySmsSendingRuleRowV2FragmentFragmentDoc = {
	kind: "Document",
	definitions: [
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "CompanySmsSendingRuleRowV2Fragment" },
			typeCondition: {
				kind: "NamedType",
				name: {
					kind: "Name",
					value: "CompanySmsSendingRuleV2CancelTypeSetting",
				},
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "cancelFeeAmountForNonZeroYenReservation",
						},
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "cancelFeeAmountForZeroYenReservation",
						},
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "cancelFeePercentForNonZeroYenReservation",
						},
					},
					{ kind: "Field", name: { kind: "Name", value: "cancelType" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "claimingConversionPolicyName" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "encouragingRereservationPolicyName" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "encouragingRereservationUnits" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "minVisitCount" },
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "encouragingRereservationPolicyName",
									},
								},
							],
						},
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "isClaimableCancelType" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "manuallyClaimingUnits" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "minVisitCount" },
								},
								{
									kind: "Field",
									name: { kind: "Name", value: "manuallyClaimingUnitKind" },
								},
								{
									kind: "Field",
									name: { kind: "Name", value: "conversionDays" },
								},
							],
						},
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "minVisitCountForClaimingConversion" },
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "minVisitCountForEncouragingRereservation",
						},
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "minVisitCountForManuallyClaimingCancelFee",
						},
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "minVisitCountForNothing" },
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	CompanySmsSendingRuleRowV2FragmentFragment,
	unknown
>
export const SummaryTextModalFragmentFragmentDoc = {
	kind: "Document",
	definitions: [
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "SummaryTextModalFragment" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "CompanySmsSendingRuleV2" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "summaryText" } },
				],
			},
		},
	],
} as unknown as DocumentNode<SummaryTextModalFragmentFragment, unknown>
export const CompanySmsSendingRuleV2ViewFragmentFragmentDoc = {
	kind: "Document",
	definitions: [
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "companySmsSendingRuleV2ViewFragment" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "CompanySmsSendingRuleV2" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "cancelPolicyTemplateType" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "cancelTypeSettings" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "FragmentSpread",
									name: {
										kind: "Name",
										value: "CompanySmsSendingRuleRowV2Fragment",
									},
								},
							],
						},
					},
					{ kind: "Field", name: { kind: "Name", value: "companyId" } },
					{ kind: "Field", name: { kind: "Name", value: "name" } },
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "selectableClaimingConversionPolicyNames",
						},
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "selectableEncouragingRereservationPolicyNames",
						},
					},
					{
						kind: "FragmentSpread",
						name: { kind: "Name", value: "SummaryTextModalFragment" },
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "CompanySmsSendingRuleRowV2Fragment" },
			typeCondition: {
				kind: "NamedType",
				name: {
					kind: "Name",
					value: "CompanySmsSendingRuleV2CancelTypeSetting",
				},
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "cancelFeeAmountForNonZeroYenReservation",
						},
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "cancelFeeAmountForZeroYenReservation",
						},
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "cancelFeePercentForNonZeroYenReservation",
						},
					},
					{ kind: "Field", name: { kind: "Name", value: "cancelType" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "claimingConversionPolicyName" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "encouragingRereservationPolicyName" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "encouragingRereservationUnits" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "minVisitCount" },
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "encouragingRereservationPolicyName",
									},
								},
							],
						},
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "isClaimableCancelType" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "manuallyClaimingUnits" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "minVisitCount" },
								},
								{
									kind: "Field",
									name: { kind: "Name", value: "manuallyClaimingUnitKind" },
								},
								{
									kind: "Field",
									name: { kind: "Name", value: "conversionDays" },
								},
							],
						},
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "minVisitCountForClaimingConversion" },
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "minVisitCountForEncouragingRereservation",
						},
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "minVisitCountForManuallyClaimingCancelFee",
						},
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "minVisitCountForNothing" },
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "SummaryTextModalFragment" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "CompanySmsSendingRuleV2" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "summaryText" } },
				],
			},
		},
	],
} as unknown as DocumentNode<
	CompanySmsSendingRuleV2ViewFragmentFragment,
	unknown
>
export const KnownIssueListTableFragmentDoc = {
	kind: "Document",
	definitions: [
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "KnownIssueListTable" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "KnownIssue" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "description" } },
					{ kind: "Field", name: { kind: "Name", value: "issueType" } },
					{ kind: "Field", name: { kind: "Name", value: "logLevel" } },
					{ kind: "Field", name: { kind: "Name", value: "logModuleName" } },
					{ kind: "Field", name: { kind: "Name", value: "logKind" } },
					{ kind: "Field", name: { kind: "Name", value: "logSalonIds" } },
					{ kind: "Field", name: { kind: "Name", value: "status" } },
					{ kind: "Field", name: { kind: "Name", value: "logKeyword" } },
					{ kind: "Field", name: { kind: "Name", value: "logMatchMethod" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "opensearchQueryUrl" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "slackChannelNameToNotify" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "mentionTargets" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "slackMentionTargetId" },
								},
								{ kind: "Field", name: { kind: "Name", value: "name" } },
							],
						},
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "thresholdCountToNotify" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "cooldownHoursToNotify" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "autoResolveDaysAfterLastActivity" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "shouldSendIosCriticalNotification" },
					},
					{ kind: "Field", name: { kind: "Name", value: "registerTime" } },
					{ kind: "Field", name: { kind: "Name", value: "issueModifiedTime" } },
				],
			},
		},
	],
} as unknown as DocumentNode<KnownIssueListTableFragment, unknown>
export const KnownIssueIdFragmentDoc = {
	kind: "Document",
	definitions: [
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "KnownIssueId" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "KnownIssue" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
			},
		},
	],
} as unknown as DocumentNode<KnownIssueIdFragment, unknown>
export const KnownIssueDaySummaryFragmentFragmentDoc = {
	kind: "Document",
	definitions: [
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "KnownIssueDaySummaryFragment" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "KnownIssueDaySummary" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "date" } },
					{ kind: "Field", name: { kind: "Name", value: "matchLogCount" } },
					{ kind: "Field", name: { kind: "Name", value: "sampleReqId" } },
					{ kind: "Field", name: { kind: "Name", value: "sampleMessage" } },
				],
			},
		},
	],
} as unknown as DocumentNode<KnownIssueDaySummaryFragmentFragment, unknown>
export const TaigaSlackMentionMetaFragmentDoc = {
	kind: "Document",
	definitions: [
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "TaigaSlackMentionMeta" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "TaigaSlackMention" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "channelId" } },
					{ kind: "Field", name: { kind: "Name", value: "threadTs" } },
					{ kind: "Field", name: { kind: "Name", value: "messageTs" } },
					{ kind: "Field", name: { kind: "Name", value: "permalink" } },
					{ kind: "Field", name: { kind: "Name", value: "dueDate" } },
					{ kind: "Field", name: { kind: "Name", value: "comment" } },
					{ kind: "Field", name: { kind: "Name", value: "priority" } },
					{ kind: "Field", name: { kind: "Name", value: "senderDisplayName" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "embeddedNode" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "id" } },
								{ kind: "Field", name: { kind: "Name", value: "isDone" } },
								{ kind: "Field", name: { kind: "Name", value: "isArchived" } },
								{
									kind: "Field",
									name: { kind: "Name", value: "session" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: { kind: "Name", value: "sessionStatus" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "isRemoteControlEnabled" },
											},
											{ kind: "Field", name: { kind: "Name", value: "memo" } },
										],
									},
								},
							],
						},
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "childNodes" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "id" } },
								{ kind: "Field", name: { kind: "Name", value: "isDone" } },
								{ kind: "Field", name: { kind: "Name", value: "isArchived" } },
								{
									kind: "Field",
									name: { kind: "Name", value: "session" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: { kind: "Name", value: "sessionStatus" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "isRemoteControlEnabled" },
											},
											{ kind: "Field", name: { kind: "Name", value: "memo" } },
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<TaigaSlackMentionMetaFragment, unknown>
export const MentionRowFragmentDoc = {
	kind: "Document",
	definitions: [
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "MentionRow" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "TaigaSlackMention" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "channelId" } },
					{ kind: "Field", name: { kind: "Name", value: "threadTs" } },
					{ kind: "Field", name: { kind: "Name", value: "messageTs" } },
					{ kind: "Field", name: { kind: "Name", value: "senderDisplayName" } },
					{ kind: "Field", name: { kind: "Name", value: "channelName" } },
					{ kind: "Field", name: { kind: "Name", value: "text" } },
					{ kind: "Field", name: { kind: "Name", value: "permalink" } },
					{ kind: "Field", name: { kind: "Name", value: "dueDate" } },
					{ kind: "Field", name: { kind: "Name", value: "comment" } },
					{ kind: "Field", name: { kind: "Name", value: "priority" } },
					{ kind: "Field", name: { kind: "Name", value: "slackMessageTime" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "embeddedNode" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "id" } },
								{ kind: "Field", name: { kind: "Name", value: "name" } },
								{ kind: "Field", name: { kind: "Name", value: "isDone" } },
								{
									kind: "Field",
									name: { kind: "Name", value: "session" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: { kind: "Name", value: "sessionStatus" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "isRemoteControlEnabled" },
											},
											{ kind: "Field", name: { kind: "Name", value: "memo" } },
											{
												kind: "Field",
												name: { kind: "Name", value: "threadTs" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "channelId" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "ccSessionId" },
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "claudeRemoteControlSessionId",
												},
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "worktreePath" },
											},
										],
									},
								},
							],
						},
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "isChildNodesCollapsed" },
					},
					{ kind: "Field", name: { kind: "Name", value: "childNodesCount" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "childNodes" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "id" } },
								{ kind: "Field", name: { kind: "Name", value: "milestoneId" } },
								{
									kind: "Field",
									name: { kind: "Name", value: "parentNodeId" },
								},
								{ kind: "Field", name: { kind: "Name", value: "name" } },
								{
									kind: "Field",
									name: { kind: "Name", value: "parallelPriority" },
								},
								{ kind: "Field", name: { kind: "Name", value: "isArchived" } },
								{ kind: "Field", name: { kind: "Name", value: "order" } },
								{ kind: "Field", name: { kind: "Name", value: "isDone" } },
								{ kind: "Field", name: { kind: "Name", value: "isCollapsed" } },
								{
									kind: "Field",
									name: { kind: "Name", value: "session" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: { kind: "Name", value: "threadTs" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "channelId" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "sessionStatus" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "isRemoteControlEnabled" },
											},
											{ kind: "Field", name: { kind: "Name", value: "memo" } },
											{
												kind: "Field",
												name: { kind: "Name", value: "ccSessionId" },
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "claudeRemoteControlSessionId",
												},
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "worktreePath" },
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<MentionRowFragment, unknown>
export const SlackMentionsSectionMentionFragmentDoc = {
	kind: "Document",
	definitions: [
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "SlackMentionsSectionMention" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "TaigaSlackMention" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "isChildNodesCollapsed" },
					},
					{ kind: "Field", name: { kind: "Name", value: "childNodesCount" } },
					{
						kind: "FragmentSpread",
						name: { kind: "Name", value: "MentionRow" },
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "MentionRow" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "TaigaSlackMention" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "channelId" } },
					{ kind: "Field", name: { kind: "Name", value: "threadTs" } },
					{ kind: "Field", name: { kind: "Name", value: "messageTs" } },
					{ kind: "Field", name: { kind: "Name", value: "senderDisplayName" } },
					{ kind: "Field", name: { kind: "Name", value: "channelName" } },
					{ kind: "Field", name: { kind: "Name", value: "text" } },
					{ kind: "Field", name: { kind: "Name", value: "permalink" } },
					{ kind: "Field", name: { kind: "Name", value: "dueDate" } },
					{ kind: "Field", name: { kind: "Name", value: "comment" } },
					{ kind: "Field", name: { kind: "Name", value: "priority" } },
					{ kind: "Field", name: { kind: "Name", value: "slackMessageTime" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "embeddedNode" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "id" } },
								{ kind: "Field", name: { kind: "Name", value: "name" } },
								{ kind: "Field", name: { kind: "Name", value: "isDone" } },
								{
									kind: "Field",
									name: { kind: "Name", value: "session" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: { kind: "Name", value: "sessionStatus" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "isRemoteControlEnabled" },
											},
											{ kind: "Field", name: { kind: "Name", value: "memo" } },
											{
												kind: "Field",
												name: { kind: "Name", value: "threadTs" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "channelId" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "ccSessionId" },
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "claudeRemoteControlSessionId",
												},
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "worktreePath" },
											},
										],
									},
								},
							],
						},
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "isChildNodesCollapsed" },
					},
					{ kind: "Field", name: { kind: "Name", value: "childNodesCount" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "childNodes" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "id" } },
								{ kind: "Field", name: { kind: "Name", value: "milestoneId" } },
								{
									kind: "Field",
									name: { kind: "Name", value: "parentNodeId" },
								},
								{ kind: "Field", name: { kind: "Name", value: "name" } },
								{
									kind: "Field",
									name: { kind: "Name", value: "parallelPriority" },
								},
								{ kind: "Field", name: { kind: "Name", value: "isArchived" } },
								{ kind: "Field", name: { kind: "Name", value: "order" } },
								{ kind: "Field", name: { kind: "Name", value: "isDone" } },
								{ kind: "Field", name: { kind: "Name", value: "isCollapsed" } },
								{
									kind: "Field",
									name: { kind: "Name", value: "session" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: { kind: "Name", value: "threadTs" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "channelId" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "sessionStatus" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "isRemoteControlEnabled" },
											},
											{ kind: "Field", name: { kind: "Name", value: "memo" } },
											{
												kind: "Field",
												name: { kind: "Name", value: "ccSessionId" },
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "claudeRemoteControlSessionId",
												},
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "worktreePath" },
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<SlackMentionsSectionMentionFragment, unknown>
export const SlackMentionsSectionSyncStateFragmentDoc = {
	kind: "Document",
	definitions: [
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "SlackMentionsSectionSyncState" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "TaigaSlackMentionSyncState" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "lastSyncTime" } },
				],
			},
		},
	],
} as unknown as DocumentNode<SlackMentionsSectionSyncStateFragment, unknown>
export const CreateSettlementDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "CreateSettlement" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "CreateSettlementInput" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "createSettlement" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "created" } },
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	CreateSettlementMutation,
	CreateSettlementMutationVariables
>
export const EnqueueSendAccountingEmailsBySettlementIDsDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: {
				kind: "Name",
				value: "EnqueueSendAccountingEmailsBySettlementIDs",
			},
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "EnqueueSendAccountingEmailsBySettlementIDsInput",
							},
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "enqueueSendAccountingEmailsBySettlementIDs",
						},
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "enqueuedSettlementIds" },
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	EnqueueSendAccountingEmailsBySettlementIDsMutation,
	EnqueueSendAccountingEmailsBySettlementIDsMutationVariables
>
export const BulkUpdatePayoutSettlementStatuses_UpdateStatusDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: {
				kind: "Name",
				value: "BulkUpdatePayoutSettlementStatuses_UpdateStatus",
			},
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "BulkUpdatePayoutSettlementStatusesInput",
							},
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "bulkUpdatePayoutSettlementStatuses" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "updatedSettlementIds" },
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	BulkUpdatePayoutSettlementStatuses_UpdateStatusMutation,
	BulkUpdatePayoutSettlementStatuses_UpdateStatusMutationVariables
>
export const BulkUpdateInvoiceSettlementStatuses_UpdateStatusDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: {
				kind: "Name",
				value: "BulkUpdateInvoiceSettlementStatuses_UpdateStatus",
			},
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "BulkUpdateInvoiceSettlementStatusesInput",
							},
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "bulkUpdateInvoiceSettlementStatuses",
						},
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "updatedSettlementIds" },
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	BulkUpdateInvoiceSettlementStatuses_UpdateStatusMutation,
	BulkUpdateInvoiceSettlementStatuses_UpdateStatusMutationVariables
>
export const GetCompaniesDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "GetCompanies" },
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "companies" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "companies" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "FragmentSpread",
												name: { kind: "Name", value: "CompanyListTable" },
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "CompanyListTable" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "Company" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "name" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "enabledFeatureFlagIds" },
					},
				],
			},
		},
	],
} as unknown as DocumentNode<GetCompaniesQuery, GetCompaniesQueryVariables>
export const GetFeatureFlagsForListDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "GetFeatureFlagsForList" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "param" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "FeatureFlagsParam" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "featureFlags" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "param" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "param" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "featureFlags" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "FragmentSpread",
												name: {
													kind: "Name",
													value: "CompanyListTableFeatureFlag",
												},
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "CompanyListTableFeatureFlag" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "FeatureFlag" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "name" } },
				],
			},
		},
	],
} as unknown as DocumentNode<
	GetFeatureFlagsForListQuery,
	GetFeatureFlagsForListQueryVariables
>
export const CreateCompanyDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "CreateCompany" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "CreateCompanyInput" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "createCompany" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "company" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{ kind: "Field", name: { kind: "Name", value: "id" } },
											{ kind: "Field", name: { kind: "Name", value: "name" } },
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	CreateCompanyMutation,
	CreateCompanyMutationVariables
>
export const CreateDefaultCompanySmsSendingRuleV2Document = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "CreateDefaultCompanySmsSendingRuleV2" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "CreateDefaultCompanySmsSendingRuleV2Input",
							},
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "createDefaultCompanySmsSendingRuleV2",
						},
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "companyId" } },
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	CreateDefaultCompanySmsSendingRuleV2Mutation,
	CreateDefaultCompanySmsSendingRuleV2MutationVariables
>
export const GetCompanyNameDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "GetCompanyName" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "param" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "CompanyParam" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "company" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "param" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "param" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "company" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{ kind: "Field", name: { kind: "Name", value: "id" } },
											{ kind: "Field", name: { kind: "Name", value: "name" } },
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<GetCompanyNameQuery, GetCompanyNameQueryVariables>
export const GetCompanyForEditDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "GetCompanyForEdit" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "param" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "CompanyParam" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "company" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "param" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "param" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "company" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{ kind: "Field", name: { kind: "Name", value: "id" } },
											{ kind: "Field", name: { kind: "Name", value: "name" } },
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	GetCompanyForEditQuery,
	GetCompanyForEditQueryVariables
>
export const UpdateCompanyDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "UpdateCompany" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "UpdateCompanyInput" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "updateCompany" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "company" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{ kind: "Field", name: { kind: "Name", value: "id" } },
											{ kind: "Field", name: { kind: "Name", value: "name" } },
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	UpdateCompanyMutation,
	UpdateCompanyMutationVariables
>
export const GetCompanyForDatasourceConfigDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "GetCompanyForDatasourceConfig" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "param" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "CompanyParam" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "company" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "param" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "param" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "company" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{ kind: "Field", name: { kind: "Name", value: "id" } },
											{
												kind: "Field",
												name: { kind: "Name", value: "salons" },
												selectionSet: {
													kind: "SelectionSet",
													selections: [
														{
															kind: "FragmentSpread",
															name: {
																kind: "Name",
																value: "SalonStatusForDatasourceConfig",
															},
														},
														{
															kind: "FragmentSpread",
															name: {
																kind: "Name",
																value: "DatasourceConfigTable",
															},
														},
													],
												},
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "MemoCell" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "Salon" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "dataSourcePolicyMemo" },
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "ConnectionStatusCell" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "DataSourceConnectionStatus" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "dataSourceStoreName" },
					},
					{ kind: "Field", name: { kind: "Name", value: "hasIdPassError" } },
					{ kind: "Field", name: { kind: "Name", value: "loginId" } },
					{ kind: "Field", name: { kind: "Name", value: "storeId" } },
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "DatasourceConfigRow" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "Salon" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "displayName" } },
					{ kind: "Field", name: { kind: "Name", value: "dataSourcePolicy" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "goalDataSourcePolicy" },
					},
					{ kind: "FragmentSpread", name: { kind: "Name", value: "MemoCell" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "dataSourceConnectionStatuses" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "dataSource" } },
								{
									kind: "Field",
									name: { kind: "Name", value: "hasIdPassError" },
								},
								{
									kind: "FragmentSpread",
									name: { kind: "Name", value: "ConnectionStatusCell" },
								},
							],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "SalonStatusForDatasourceConfig" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "Salon" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "dataSourcePolicy" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "goalDataSourcePolicy" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "dataSourceConnectionStatuses" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "hasIdPassError" },
								},
							],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "DatasourceConfigTable" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "Salon" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{
						kind: "FragmentSpread",
						name: { kind: "Name", value: "DatasourceConfigRow" },
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	GetCompanyForDatasourceConfigQuery,
	GetCompanyForDatasourceConfigQueryVariables
>
export const GetDataSourceColumnsDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "GetDataSourceColumns" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "param" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "DataSourceColumnsParam" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "dataSourceColumns" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "param" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "param" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "dataSourceColumns" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: { kind: "Name", value: "dataSource" },
											},
											{ kind: "Field", name: { kind: "Name", value: "label" } },
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	GetDataSourceColumnsQuery,
	GetDataSourceColumnsQueryVariables
>
export const GetDataSourcePolicyOptionsDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "GetDataSourcePolicyOptions" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "param" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "DataSourcePolicyOptionsParam" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "dataSourcePolicyOptions" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "param" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "param" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "value" } },
								{ kind: "Field", name: { kind: "Name", value: "label" } },
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	GetDataSourcePolicyOptionsQuery,
	GetDataSourcePolicyOptionsQueryVariables
>
export const UpdateSalonGoalDataSourcePoliciesDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "UpdateSalonGoalDataSourcePolicies" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "UpdateSalonGoalDataSourcePoliciesInput",
							},
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "updateSalonGoalDataSourcePolicies" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "success" } },
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	UpdateSalonGoalDataSourcePoliciesMutation,
	UpdateSalonGoalDataSourcePoliciesMutationVariables
>
export const UpdateSalonDataSourcePolicyMemoDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "UpdateSalonDataSourcePolicyMemo" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "UpdateSalonDataSourcePolicyMemoInput",
							},
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "updateSalonDataSourcePolicyMemo" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "salon" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{ kind: "Field", name: { kind: "Name", value: "id" } },
											{
												kind: "Field",
												name: { kind: "Name", value: "dataSourcePolicyMemo" },
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	UpdateSalonDataSourcePolicyMemoMutation,
	UpdateSalonDataSourcePolicyMemoMutationVariables
>
export const GetDataSourceLoginPasswordDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "GetDataSourceLoginPassword" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "GetDataSourceLoginPasswordInput" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "getDataSourceLoginPassword" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "password" } },
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	GetDataSourceLoginPasswordMutation,
	GetDataSourceLoginPasswordMutationVariables
>
export const GetCompanyFeatureFlagsDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "GetCompanyFeatureFlags" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "param" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "CompanyFeatureFlagsParam" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "companyFeatureFlags" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "param" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "param" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "companyFeatureFlags" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "FragmentSpread",
												name: {
													kind: "Name",
													value: "FeatureFlagTabEditState",
												},
											},
											{
												kind: "FragmentSpread",
												name: { kind: "Name", value: "FeatureFlagTab" },
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "CompanyWideRowCompanyFeatureFlag" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "CompanyFeatureFlag" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "featureFlag" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "id" } },
							],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "BulkToggleRowCompanyFeatureFlag" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "CompanyFeatureFlag" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "featureFlag" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "id" } },
							],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "SalonRowCompanyFeatureFlag" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "CompanyFeatureFlag" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "featureFlag" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "id" } },
							],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "FeatureFlagTabEditState" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "CompanyFeatureFlag" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "featureFlag" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "id" } },
							],
						},
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "isCompanyWideEnabled" },
					},
					{ kind: "Field", name: { kind: "Name", value: "enabledSalonIds" } },
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "FeatureFlagTab" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "CompanyFeatureFlag" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "featureFlag" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "id" } },
								{ kind: "Field", name: { kind: "Name", value: "name" } },
								{ kind: "Field", name: { kind: "Name", value: "comment" } },
							],
						},
					},
					{
						kind: "FragmentSpread",
						name: { kind: "Name", value: "CompanyWideRowCompanyFeatureFlag" },
					},
					{
						kind: "FragmentSpread",
						name: { kind: "Name", value: "BulkToggleRowCompanyFeatureFlag" },
					},
					{
						kind: "FragmentSpread",
						name: { kind: "Name", value: "SalonRowCompanyFeatureFlag" },
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	GetCompanyFeatureFlagsQuery,
	GetCompanyFeatureFlagsQueryVariables
>
export const GetCompanySalonsForFeatureFlagDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "GetCompanySalonsForFeatureFlag" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "param" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "CompanyParam" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "company" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "param" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "param" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "company" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: { kind: "Name", value: "salons" },
												selectionSet: {
													kind: "SelectionSet",
													selections: [
														{
															kind: "FragmentSpread",
															name: {
																kind: "Name",
																value: "FeatureFlagTabSalonIds",
															},
														},
														{
															kind: "FragmentSpread",
															name: {
																kind: "Name",
																value: "FeatureFlagTabSalon",
															},
														},
													],
												},
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "BulkToggleRowSalon" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "Salon" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "SalonRowSalon" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "Salon" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "name" } },
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "FeatureFlagTabSalonIds" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "Salon" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "FeatureFlagTabSalon" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "Salon" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{
						kind: "FragmentSpread",
						name: { kind: "Name", value: "BulkToggleRowSalon" },
					},
					{
						kind: "FragmentSpread",
						name: { kind: "Name", value: "SalonRowSalon" },
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	GetCompanySalonsForFeatureFlagQuery,
	GetCompanySalonsForFeatureFlagQueryVariables
>
export const ToggleFeatureFlagsDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "ToggleFeatureFlags" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "ToggleFeatureFlagsInput" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "toggleFeatureFlags" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "companyFeatureFlags" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "FragmentSpread",
												name: {
													kind: "Name",
													value: "FeatureFlagTabEditState",
												},
											},
											{
												kind: "FragmentSpread",
												name: { kind: "Name", value: "FeatureFlagTab" },
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "CompanyWideRowCompanyFeatureFlag" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "CompanyFeatureFlag" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "featureFlag" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "id" } },
							],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "BulkToggleRowCompanyFeatureFlag" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "CompanyFeatureFlag" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "featureFlag" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "id" } },
							],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "SalonRowCompanyFeatureFlag" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "CompanyFeatureFlag" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "featureFlag" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "id" } },
							],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "FeatureFlagTabEditState" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "CompanyFeatureFlag" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "featureFlag" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "id" } },
							],
						},
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "isCompanyWideEnabled" },
					},
					{ kind: "Field", name: { kind: "Name", value: "enabledSalonIds" } },
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "FeatureFlagTab" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "CompanyFeatureFlag" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "featureFlag" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "id" } },
								{ kind: "Field", name: { kind: "Name", value: "name" } },
								{ kind: "Field", name: { kind: "Name", value: "comment" } },
							],
						},
					},
					{
						kind: "FragmentSpread",
						name: { kind: "Name", value: "CompanyWideRowCompanyFeatureFlag" },
					},
					{
						kind: "FragmentSpread",
						name: { kind: "Name", value: "BulkToggleRowCompanyFeatureFlag" },
					},
					{
						kind: "FragmentSpread",
						name: { kind: "Name", value: "SalonRowCompanyFeatureFlag" },
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	ToggleFeatureFlagsMutation,
	ToggleFeatureFlagsMutationVariables
>
export const GetCompanyCommissionRatesDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "GetCompanyCommissionRates" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "param" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "GetCompanyCommissionRatesParam" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "getCompanyCommissionRates" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "param" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "param" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "companyCommissionRates" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: { kind: "Name", value: "companyId" },
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "cancelFeeCommissionRate",
												},
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "existingCustomerRereservationCommissionRate",
												},
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "newCustomerRereservationCommissionRate",
												},
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	GetCompanyCommissionRatesQuery,
	GetCompanyCommissionRatesQueryVariables
>
export const GetCompanyCommissionRateChangeHistoriesDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "GetCompanyCommissionRateChangeHistories" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "param" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "GetCompanyCommissionRateChangeHistoriesParam",
							},
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "getCompanyCommissionRateChangeHistories",
						},
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "param" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "param" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "histories" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "FragmentSpread",
												name: { kind: "Name", value: "ChangeHistoryFields" },
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "ChangeHistoryFields" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "CompanyCommissionRateChangeHistory" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "cancelFeeCommissionRate" },
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "existingCustomerRereservationCommissionRate",
						},
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "newCustomerRereservationCommissionRate",
						},
					},
					{ kind: "Field", name: { kind: "Name", value: "createTime" } },
				],
			},
		},
	],
} as unknown as DocumentNode<
	GetCompanyCommissionRateChangeHistoriesQuery,
	GetCompanyCommissionRateChangeHistoriesQueryVariables
>
export const UpdateCompanyCommissionRatesDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "UpdateCompanyCommissionRates" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "UpdateCompanyCommissionRatesInput",
							},
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "updateCompanyCommissionRates" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "companyCommissionRates" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: { kind: "Name", value: "companyId" },
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "cancelFeeCommissionRate",
												},
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "existingCustomerRereservationCommissionRate",
												},
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "newCustomerRereservationCommissionRate",
												},
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	UpdateCompanyCommissionRatesMutation,
	UpdateCompanyCommissionRatesMutationVariables
>
export const GetCompanyForGeneralInfoDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "GetCompanyForGeneralInfo" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "param" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "CompanyParam" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "company" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "param" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "param" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "company" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{ kind: "Field", name: { kind: "Name", value: "id" } },
											{ kind: "Field", name: { kind: "Name", value: "name" } },
											{
												kind: "Field",
												name: { kind: "Name", value: "salons" },
												selectionSet: {
													kind: "SelectionSet",
													selections: [
														{
															kind: "Field",
															name: { kind: "Name", value: "id" },
														},
														{
															kind: "Field",
															name: { kind: "Name", value: "name" },
														},
														{
															kind: "Field",
															name: { kind: "Name", value: "displayName" },
														},
													],
												},
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "lineGroups" },
												selectionSet: {
													kind: "SelectionSet",
													selections: [
														{
															kind: "Field",
															name: { kind: "Name", value: "id" },
														},
														{
															kind: "Field",
															name: { kind: "Name", value: "name" },
														},
													],
												},
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "hubspotContracts" },
												selectionSet: {
													kind: "SelectionSet",
													selections: [
														{
															kind: "FragmentSpread",
															name: {
																kind: "Name",
																value:
																	"HubspotContractsSection_HubspotContract",
															},
														},
													],
												},
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "HubspotContractsSection_HubspotContract" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "HubspotContract" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "name" } },
					{ kind: "Field", name: { kind: "Name", value: "dealstage" } },
					{ kind: "Field", name: { kind: "Name", value: "mainAssignee" } },
					{ kind: "Field", name: { kind: "Name", value: "registerTime" } },
				],
			},
		},
	],
} as unknown as DocumentNode<
	GetCompanyForGeneralInfoQuery,
	GetCompanyForGeneralInfoQueryVariables
>
export const GenerateFinLoginUrlForGeneralInfoTabDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "GenerateFinLoginUrlForGeneralInfoTab" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "GenerateFinLoginUrlInput" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "generateFinLoginUrl" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "url" } },
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	GenerateFinLoginUrlForGeneralInfoTabMutation,
	GenerateFinLoginUrlForGeneralInfoTabMutationVariables
>
export const UpdateCompanyHubspotContractIDsForGeneralInfoDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: {
				kind: "Name",
				value: "UpdateCompanyHubspotContractIDsForGeneralInfo",
			},
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "UpdateCompanyHubspotContractIDsInput",
							},
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "updateCompanyHubspotContractIDs" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "hubspotContracts" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "FragmentSpread",
												name: {
													kind: "Name",
													value: "HubspotContractsSection_HubspotContract",
												},
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "HubspotContractsSection_HubspotContract" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "HubspotContract" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "name" } },
					{ kind: "Field", name: { kind: "Name", value: "dealstage" } },
					{ kind: "Field", name: { kind: "Name", value: "mainAssignee" } },
					{ kind: "Field", name: { kind: "Name", value: "registerTime" } },
				],
			},
		},
	],
} as unknown as DocumentNode<
	UpdateCompanyHubspotContractIDsForGeneralInfoMutation,
	UpdateCompanyHubspotContractIDsForGeneralInfoMutationVariables
>
export const UpdateLineGroupAndCompanyMappingsForGeneralInfoDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: {
				kind: "Name",
				value: "UpdateLineGroupAndCompanyMappingsForGeneralInfo",
			},
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "UpdateLineGroupAndCompanyMappingsInput",
							},
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "updateLineGroupAndCompanyMappings" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "updatedCount" },
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	UpdateLineGroupAndCompanyMappingsForGeneralInfoMutation,
	UpdateLineGroupAndCompanyMappingsForGeneralInfoMutationVariables
>
export const CompanyBySalonIdForSalonSelectDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "CompanyBySalonIdForSalonSelect" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "param" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "CompanyBySalonIdParam" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "companyBySalonId" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "param" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "param" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "company" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{ kind: "Field", name: { kind: "Name", value: "id" } },
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	CompanyBySalonIdForSalonSelectQuery,
	CompanyBySalonIdForSalonSelectQueryVariables
>
export const GetCompanyForUsageStartDateDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "getCompanyForUsageStartDate" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "param" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "CompanyParam" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "company" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "param" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "param" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									alias: { kind: "Name", value: "currentCompany" },
									name: { kind: "Name", value: "company" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: { kind: "Name", value: "salons" },
												selectionSet: {
													kind: "SelectionSet",
													selections: [
														{
															kind: "FragmentSpread",
															name: {
																kind: "Name",
																value: "UsageStartDateTab",
															},
														},
													],
												},
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "UsageStartDateTableRow" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "Salon" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "displayName" } },
					{ kind: "Field", name: { kind: "Name", value: "usageStartDate" } },
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "UsageStartDateTab" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "Salon" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{
						kind: "FragmentSpread",
						name: { kind: "Name", value: "UsageStartDateTableRow" },
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	GetCompanyForUsageStartDateQuery,
	GetCompanyForUsageStartDateQueryVariables
>
export const UpdateSalonUsageStartDateDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "updateSalonUsageStartDate" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "UpdateSalonUsageStartDateInput" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "updateSalonUsageStartDate" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "salonIds" } },
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	UpdateSalonUsageStartDateMutation,
	UpdateSalonUsageStartDateMutationVariables
>
export const GetCompanySmsSendingRulesV2Document = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "getCompanySmsSendingRulesV2" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "companyId" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "String" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "companySmsSendingRulesV2" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "companyId" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "companyId" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "summaryText" } },
								{
									kind: "Field",
									name: { kind: "Name", value: "rules" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{ kind: "Field", name: { kind: "Name", value: "id" } },
											{ kind: "Field", name: { kind: "Name", value: "name" } },
											{
												kind: "FragmentSpread",
												name: {
													kind: "Name",
													value: "companySmsSendingRuleV2ViewFragment",
												},
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "CompanySmsSendingRuleRowV2Fragment" },
			typeCondition: {
				kind: "NamedType",
				name: {
					kind: "Name",
					value: "CompanySmsSendingRuleV2CancelTypeSetting",
				},
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "cancelFeeAmountForNonZeroYenReservation",
						},
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "cancelFeeAmountForZeroYenReservation",
						},
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "cancelFeePercentForNonZeroYenReservation",
						},
					},
					{ kind: "Field", name: { kind: "Name", value: "cancelType" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "claimingConversionPolicyName" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "encouragingRereservationPolicyName" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "encouragingRereservationUnits" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "minVisitCount" },
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "encouragingRereservationPolicyName",
									},
								},
							],
						},
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "isClaimableCancelType" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "manuallyClaimingUnits" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "minVisitCount" },
								},
								{
									kind: "Field",
									name: { kind: "Name", value: "manuallyClaimingUnitKind" },
								},
								{
									kind: "Field",
									name: { kind: "Name", value: "conversionDays" },
								},
							],
						},
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "minVisitCountForClaimingConversion" },
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "minVisitCountForEncouragingRereservation",
						},
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "minVisitCountForManuallyClaimingCancelFee",
						},
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "minVisitCountForNothing" },
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "SummaryTextModalFragment" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "CompanySmsSendingRuleV2" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "summaryText" } },
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "companySmsSendingRuleV2ViewFragment" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "CompanySmsSendingRuleV2" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "cancelPolicyTemplateType" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "cancelTypeSettings" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "FragmentSpread",
									name: {
										kind: "Name",
										value: "CompanySmsSendingRuleRowV2Fragment",
									},
								},
							],
						},
					},
					{ kind: "Field", name: { kind: "Name", value: "companyId" } },
					{ kind: "Field", name: { kind: "Name", value: "name" } },
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "selectableClaimingConversionPolicyNames",
						},
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "selectableEncouragingRereservationPolicyNames",
						},
					},
					{
						kind: "FragmentSpread",
						name: { kind: "Name", value: "SummaryTextModalFragment" },
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	GetCompanySmsSendingRulesV2Query,
	GetCompanySmsSendingRulesV2QueryVariables
>
export const GetCompanySmsSendingRulesV2ForMappingDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "getCompanySmsSendingRulesV2ForMapping" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "companyId" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "String" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "companySmsSendingRulesV2" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "companyId" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "companyId" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "rules" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{ kind: "Field", name: { kind: "Name", value: "id" } },
											{ kind: "Field", name: { kind: "Name", value: "name" } },
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	GetCompanySmsSendingRulesV2ForMappingQuery,
	GetCompanySmsSendingRulesV2ForMappingQueryVariables
>
export const GetCompanyForMappingDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "getCompanyForMapping" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "param" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "CompanyParam" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "company" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "param" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "param" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									alias: { kind: "Name", value: "currentCompany" },
									name: { kind: "Name", value: "company" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{ kind: "Field", name: { kind: "Name", value: "id" } },
											{
												kind: "Field",
												name: { kind: "Name", value: "salons" },
												selectionSet: {
													kind: "SelectionSet",
													selections: [
														{
															kind: "Field",
															name: { kind: "Name", value: "id" },
														},
														{
															kind: "Field",
															name: { kind: "Name", value: "displayName" },
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "appliedCompanySmsSendingRule",
															},
															selectionSet: {
																kind: "SelectionSet",
																selections: [
																	{
																		kind: "Field",
																		name: { kind: "Name", value: "id" },
																	},
																],
															},
														},
													],
												},
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	GetCompanyForMappingQuery,
	GetCompanyForMappingQueryVariables
>
export const UpdateSalonAndCompanySmsSendingRuleMappingsDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: {
				kind: "Name",
				value: "updateSalonAndCompanySmsSendingRuleMappings",
			},
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "UpdateSalonAndCompanySmsSendingRuleMappingsInput",
							},
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "updateSalonAndCompanySmsSendingRuleMappings",
						},
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "salonIds" } },
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	UpdateSalonAndCompanySmsSendingRuleMappingsMutation,
	UpdateSalonAndCompanySmsSendingRuleMappingsMutationVariables
>
export const UpdateSalonSmsSendingStartSettingsDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "updateSalonSmsSendingStartSettings" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "UpdateSalonSmsSendingStartSettingsInput",
							},
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "updateSalonSmsSendingStartSettings" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "salonIds" } },
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	UpdateSalonSmsSendingStartSettingsMutation,
	UpdateSalonSmsSendingStartSettingsMutationVariables
>
export const GetCompanyForSmsSendingStartSettingsDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "getCompanyForSmsSendingStartSettings" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "param" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "CompanyParam" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "company" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "param" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "param" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									alias: { kind: "Name", value: "currentCompany" },
									name: { kind: "Name", value: "company" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: { kind: "Name", value: "salons" },
												selectionSet: {
													kind: "SelectionSet",
													selections: [
														{
															kind: "FragmentSpread",
															name: {
																kind: "Name",
																value: "smsSendingStartSettings",
															},
														},
													],
												},
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "smsSendingStartSettingsTable" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "Salon" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "name" } },
					{ kind: "Field", name: { kind: "Name", value: "displayName" } },
					{ kind: "Field", name: { kind: "Name", value: "autoClaimBase" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "autoClaimStartDate" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "encourageStartCancelDate" },
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "smsSendingStartSettings" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "Salon" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{
						kind: "FragmentSpread",
						name: { kind: "Name", value: "smsSendingStartSettingsTable" },
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	GetCompanyForSmsSendingStartSettingsQuery,
	GetCompanyForSmsSendingStartSettingsQueryVariables
>
export const UpdateCompanySmsSendingRuleV2Document = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "updateCompanySmsSendingRuleV2" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "UpdateCompanySmsSendingRuleV2Input",
							},
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "updateCompanySmsSendingRuleV2" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "rule" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{ kind: "Field", name: { kind: "Name", value: "id" } },
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	UpdateCompanySmsSendingRuleV2Mutation,
	UpdateCompanySmsSendingRuleV2MutationVariables
>
export const CreateCompanySmsSendingRuleV2Document = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "createCompanySmsSendingRuleV2" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "CreateCompanySmsSendingRuleV2Input",
							},
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "createCompanySmsSendingRuleV2" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "rule" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{ kind: "Field", name: { kind: "Name", value: "id" } },
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	CreateCompanySmsSendingRuleV2Mutation,
	CreateCompanySmsSendingRuleV2MutationVariables
>
export const GetCompanySmsSendingRulesV2ForEditDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "getCompanySmsSendingRulesV2ForEdit" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "companyId" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "String" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "companySmsSendingRulesV2" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "companyId" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "companyId" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "rules" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{ kind: "Field", name: { kind: "Name", value: "id" } },
											{ kind: "Field", name: { kind: "Name", value: "name" } },
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "cancelPolicyTemplateType",
												},
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "selectableClaimingConversionPolicyNames",
												},
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value:
														"selectableEncouragingRereservationPolicyNames",
												},
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "cancelTypeSettings" },
												selectionSet: {
													kind: "SelectionSet",
													selections: [
														{
															kind: "Field",
															name: { kind: "Name", value: "id" },
														},
														{
															kind: "Field",
															name: { kind: "Name", value: "cancelType" },
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value:
																	"cancelFeeAmountForNonZeroYenReservation",
															},
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "cancelFeeAmountForZeroYenReservation",
															},
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value:
																	"cancelFeePercentForNonZeroYenReservation",
															},
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "claimingConversionPolicyName",
															},
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "encouragingRereservationPolicyName",
															},
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "encouragingRereservationUnits",
															},
															selectionSet: {
																kind: "SelectionSet",
																selections: [
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "minVisitCount",
																		},
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value:
																				"encouragingRereservationPolicyName",
																		},
																	},
																],
															},
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "manuallyClaimingUnits",
															},
															selectionSet: {
																kind: "SelectionSet",
																selections: [
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "minVisitCount",
																		},
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "manuallyClaimingUnitKind",
																		},
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "conversionDays",
																		},
																	},
																],
															},
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "minVisitCountForClaimingConversion",
															},
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value:
																	"minVisitCountForEncouragingRereservation",
															},
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value:
																	"minVisitCountForManuallyClaimingCancelFee",
															},
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "minVisitCountForNothing",
															},
														},
													],
												},
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	GetCompanySmsSendingRulesV2ForEditQuery,
	GetCompanySmsSendingRulesV2ForEditQueryVariables
>
export const CreateKnownIssueDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "CreateKnownIssue" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "CreateKnownIssueInput" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "createKnownIssue" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "knownIssue" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{ kind: "Field", name: { kind: "Name", value: "id" } },
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	CreateKnownIssueMutation,
	CreateKnownIssueMutationVariables
>
export const GetKnownIssueDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "GetKnownIssue" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "String" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "knownIssue" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "id" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "id" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "knownIssue" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{ kind: "Field", name: { kind: "Name", value: "id" } },
											{
												kind: "Field",
												name: { kind: "Name", value: "status" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "description" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "issueType" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "logLevel" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "logMatchMethod" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "logKeyword" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "logModuleName" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "logKind" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "logSalonIds" },
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "slackChannelNameToNotify",
												},
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "mentionTargets" },
												selectionSet: {
													kind: "SelectionSet",
													selections: [
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "slackMentionTargetId",
															},
														},
														{
															kind: "Field",
															name: { kind: "Name", value: "name" },
														},
													],
												},
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "thresholdCountToNotify" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "cooldownHoursToNotify" },
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "autoResolveDaysAfterLastActivity",
												},
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "shouldSendIosCriticalNotification",
												},
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "registerTime" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "issueModifiedTime" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "latestAlertedTime" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "opensearchQueryUrl" },
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<GetKnownIssueQuery, GetKnownIssueQueryVariables>
export const GetKnownIssueDaySummaryDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "GetKnownIssueDaySummary" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "String" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "knownIssueDaySummary" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "id" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "id" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "daySummaries" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "FragmentSpread",
												name: {
													kind: "Name",
													value: "KnownIssueDaySummaryFragment",
												},
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "KnownIssueDaySummaryFragment" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "KnownIssueDaySummary" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "date" } },
					{ kind: "Field", name: { kind: "Name", value: "matchLogCount" } },
					{ kind: "Field", name: { kind: "Name", value: "sampleReqId" } },
					{ kind: "Field", name: { kind: "Name", value: "sampleMessage" } },
				],
			},
		},
	],
} as unknown as DocumentNode<
	GetKnownIssueDaySummaryQuery,
	GetKnownIssueDaySummaryQueryVariables
>
export const ResolveKnownIssueDetailDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "ResolveKnownIssueDetail" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "ResolveKnownIssuesInput" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "resolveKnownIssues" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "ids" } },
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	ResolveKnownIssueDetailMutation,
	ResolveKnownIssueDetailMutationVariables
>
export const CloseKnownIssueDetailDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "CloseKnownIssueDetail" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "CloseKnownIssuesInput" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "closeKnownIssues" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "ids" } },
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	CloseKnownIssueDetailMutation,
	CloseKnownIssueDetailMutationVariables
>
export const ReopenKnownIssueDetailDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "ReopenKnownIssueDetail" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "ReopenKnownIssuesInput" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "reopenKnownIssues" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "ids" } },
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	ReopenKnownIssueDetailMutation,
	ReopenKnownIssueDetailMutationVariables
>
export const GetKnownIssueForEditDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "GetKnownIssueForEdit" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "String" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "knownIssue" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "id" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "id" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "knownIssue" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{ kind: "Field", name: { kind: "Name", value: "id" } },
											{
												kind: "Field",
												name: { kind: "Name", value: "description" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "issueType" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "logLevel" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "logMatchMethod" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "logKeyword" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "logModuleName" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "logKind" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "logSalonIds" },
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "slackChannelNameToNotify",
												},
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "mentionTargets" },
												selectionSet: {
													kind: "SelectionSet",
													selections: [
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "slackMentionTargetId",
															},
														},
													],
												},
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "thresholdCountToNotify" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "cooldownHoursToNotify" },
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "autoResolveDaysAfterLastActivity",
												},
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "shouldSendIosCriticalNotification",
												},
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	GetKnownIssueForEditQuery,
	GetKnownIssueForEditQueryVariables
>
export const UpdateKnownIssueDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "UpdateKnownIssue" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "UpdateKnownIssueInput" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "updateKnownIssue" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "knownIssue" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{ kind: "Field", name: { kind: "Name", value: "id" } },
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	UpdateKnownIssueMutation,
	UpdateKnownIssueMutationVariables
>
export const GetSlackMentionTargetsDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "GetSlackMentionTargets" },
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "slackMentionTargets" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "targets" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{ kind: "Field", name: { kind: "Name", value: "id" } },
											{ kind: "Field", name: { kind: "Name", value: "name" } },
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	GetSlackMentionTargetsQuery,
	GetSlackMentionTargetsQueryVariables
>
export const GetKnownIssuesDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "GetKnownIssues" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "param" },
					},
					type: {
						kind: "NamedType",
						name: { kind: "Name", value: "KnownIssuesParam" },
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "knownIssues" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "param" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "param" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "knownIssues" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "FragmentSpread",
												name: { kind: "Name", value: "KnownIssueId" },
											},
											{
												kind: "FragmentSpread",
												name: { kind: "Name", value: "KnownIssueListTable" },
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "KnownIssueId" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "KnownIssue" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "KnownIssueListTable" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "KnownIssue" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "description" } },
					{ kind: "Field", name: { kind: "Name", value: "issueType" } },
					{ kind: "Field", name: { kind: "Name", value: "logLevel" } },
					{ kind: "Field", name: { kind: "Name", value: "logModuleName" } },
					{ kind: "Field", name: { kind: "Name", value: "logKind" } },
					{ kind: "Field", name: { kind: "Name", value: "logSalonIds" } },
					{ kind: "Field", name: { kind: "Name", value: "status" } },
					{ kind: "Field", name: { kind: "Name", value: "logKeyword" } },
					{ kind: "Field", name: { kind: "Name", value: "logMatchMethod" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "opensearchQueryUrl" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "slackChannelNameToNotify" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "mentionTargets" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "slackMentionTargetId" },
								},
								{ kind: "Field", name: { kind: "Name", value: "name" } },
							],
						},
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "thresholdCountToNotify" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "cooldownHoursToNotify" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "autoResolveDaysAfterLastActivity" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "shouldSendIosCriticalNotification" },
					},
					{ kind: "Field", name: { kind: "Name", value: "registerTime" } },
					{ kind: "Field", name: { kind: "Name", value: "issueModifiedTime" } },
				],
			},
		},
	],
} as unknown as DocumentNode<GetKnownIssuesQuery, GetKnownIssuesQueryVariables>
export const GetKnownIssueDaySummariesDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "GetKnownIssueDaySummaries" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: { kind: "Variable", name: { kind: "Name", value: "ids" } },
					type: {
						kind: "NonNullType",
						type: {
							kind: "ListType",
							type: {
								kind: "NonNullType",
								type: {
									kind: "NamedType",
									name: { kind: "Name", value: "String" },
								},
							},
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "knownIssueDaySummaries" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "ids" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "ids" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "summaries" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: { kind: "Name", value: "knownIssueId" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "daySummaries" },
												selectionSet: {
													kind: "SelectionSet",
													selections: [
														{
															kind: "FragmentSpread",
															name: {
																kind: "Name",
																value: "KnownIssueDaySummaryFragment",
															},
														},
													],
												},
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "last24HoursMatchCount" },
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "KnownIssueDaySummaryFragment" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "KnownIssueDaySummary" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "date" } },
					{ kind: "Field", name: { kind: "Name", value: "matchLogCount" } },
					{ kind: "Field", name: { kind: "Name", value: "sampleReqId" } },
					{ kind: "Field", name: { kind: "Name", value: "sampleMessage" } },
				],
			},
		},
	],
} as unknown as DocumentNode<
	GetKnownIssueDaySummariesQuery,
	GetKnownIssueDaySummariesQueryVariables
>
export const ResolveKnownIssuesDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "ResolveKnownIssues" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "ResolveKnownIssuesInput" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "resolveKnownIssues" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "ids" } },
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	ResolveKnownIssuesMutation,
	ResolveKnownIssuesMutationVariables
>
export const CloseKnownIssuesDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "CloseKnownIssues" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "CloseKnownIssuesInput" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "closeKnownIssues" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "ids" } },
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	CloseKnownIssuesMutation,
	CloseKnownIssuesMutationVariables
>
export const ReopenKnownIssuesDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "ReopenKnownIssues" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "ReopenKnownIssuesInput" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "reopenKnownIssues" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "ids" } },
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	ReopenKnownIssuesMutation,
	ReopenKnownIssuesMutationVariables
>
export const GetSlackMentionsDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "GetSlackMentions" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "param" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "TaigaSlackMentionsParam" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "taigaSlackMentions" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "param" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "param" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "mentions" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "FragmentSpread",
												name: { kind: "Name", value: "TaigaSlackMentionMeta" },
											},
											{
												kind: "FragmentSpread",
												name: {
													kind: "Name",
													value: "SlackMentionsSectionMention",
												},
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "MentionRow" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "TaigaSlackMention" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "channelId" } },
					{ kind: "Field", name: { kind: "Name", value: "threadTs" } },
					{ kind: "Field", name: { kind: "Name", value: "messageTs" } },
					{ kind: "Field", name: { kind: "Name", value: "senderDisplayName" } },
					{ kind: "Field", name: { kind: "Name", value: "channelName" } },
					{ kind: "Field", name: { kind: "Name", value: "text" } },
					{ kind: "Field", name: { kind: "Name", value: "permalink" } },
					{ kind: "Field", name: { kind: "Name", value: "dueDate" } },
					{ kind: "Field", name: { kind: "Name", value: "comment" } },
					{ kind: "Field", name: { kind: "Name", value: "priority" } },
					{ kind: "Field", name: { kind: "Name", value: "slackMessageTime" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "embeddedNode" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "id" } },
								{ kind: "Field", name: { kind: "Name", value: "name" } },
								{ kind: "Field", name: { kind: "Name", value: "isDone" } },
								{
									kind: "Field",
									name: { kind: "Name", value: "session" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: { kind: "Name", value: "sessionStatus" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "isRemoteControlEnabled" },
											},
											{ kind: "Field", name: { kind: "Name", value: "memo" } },
											{
												kind: "Field",
												name: { kind: "Name", value: "threadTs" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "channelId" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "ccSessionId" },
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "claudeRemoteControlSessionId",
												},
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "worktreePath" },
											},
										],
									},
								},
							],
						},
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "isChildNodesCollapsed" },
					},
					{ kind: "Field", name: { kind: "Name", value: "childNodesCount" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "childNodes" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "id" } },
								{ kind: "Field", name: { kind: "Name", value: "milestoneId" } },
								{
									kind: "Field",
									name: { kind: "Name", value: "parentNodeId" },
								},
								{ kind: "Field", name: { kind: "Name", value: "name" } },
								{
									kind: "Field",
									name: { kind: "Name", value: "parallelPriority" },
								},
								{ kind: "Field", name: { kind: "Name", value: "isArchived" } },
								{ kind: "Field", name: { kind: "Name", value: "order" } },
								{ kind: "Field", name: { kind: "Name", value: "isDone" } },
								{ kind: "Field", name: { kind: "Name", value: "isCollapsed" } },
								{
									kind: "Field",
									name: { kind: "Name", value: "session" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: { kind: "Name", value: "threadTs" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "channelId" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "sessionStatus" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "isRemoteControlEnabled" },
											},
											{ kind: "Field", name: { kind: "Name", value: "memo" } },
											{
												kind: "Field",
												name: { kind: "Name", value: "ccSessionId" },
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "claudeRemoteControlSessionId",
												},
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "worktreePath" },
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "TaigaSlackMentionMeta" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "TaigaSlackMention" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "channelId" } },
					{ kind: "Field", name: { kind: "Name", value: "threadTs" } },
					{ kind: "Field", name: { kind: "Name", value: "messageTs" } },
					{ kind: "Field", name: { kind: "Name", value: "permalink" } },
					{ kind: "Field", name: { kind: "Name", value: "dueDate" } },
					{ kind: "Field", name: { kind: "Name", value: "comment" } },
					{ kind: "Field", name: { kind: "Name", value: "priority" } },
					{ kind: "Field", name: { kind: "Name", value: "senderDisplayName" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "embeddedNode" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "id" } },
								{ kind: "Field", name: { kind: "Name", value: "isDone" } },
								{ kind: "Field", name: { kind: "Name", value: "isArchived" } },
								{
									kind: "Field",
									name: { kind: "Name", value: "session" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: { kind: "Name", value: "sessionStatus" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "isRemoteControlEnabled" },
											},
											{ kind: "Field", name: { kind: "Name", value: "memo" } },
										],
									},
								},
							],
						},
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "childNodes" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "id" } },
								{ kind: "Field", name: { kind: "Name", value: "isDone" } },
								{ kind: "Field", name: { kind: "Name", value: "isArchived" } },
								{
									kind: "Field",
									name: { kind: "Name", value: "session" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: { kind: "Name", value: "sessionStatus" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "isRemoteControlEnabled" },
											},
											{ kind: "Field", name: { kind: "Name", value: "memo" } },
										],
									},
								},
							],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "SlackMentionsSectionMention" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "TaigaSlackMention" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "isChildNodesCollapsed" },
					},
					{ kind: "Field", name: { kind: "Name", value: "childNodesCount" } },
					{
						kind: "FragmentSpread",
						name: { kind: "Name", value: "MentionRow" },
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	GetSlackMentionsQuery,
	GetSlackMentionsQueryVariables
>
export const GetSlackMentionSyncStateDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "GetSlackMentionSyncState" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "param" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "TaigaSlackMentionSyncStateParam" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "taigaSlackMentionSyncState" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "param" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "param" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "syncState" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "FragmentSpread",
												name: {
													kind: "Name",
													value: "SlackMentionsSectionSyncState",
												},
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "SlackMentionsSectionSyncState" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "TaigaSlackMentionSyncState" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "lastSyncTime" } },
				],
			},
		},
	],
} as unknown as DocumentNode<
	GetSlackMentionSyncStateQuery,
	GetSlackMentionSyncStateQueryVariables
>
export const CompleteSlackMentionDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "CompleteSlackMention" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "CompleteTaigaSlackMentionInput" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "completeTaigaSlackMention" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "mention" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{ kind: "Field", name: { kind: "Name", value: "id" } },
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	CompleteSlackMentionMutation,
	CompleteSlackMentionMutationVariables
>
export const SetSlackMentionDueDateDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "SetSlackMentionDueDate" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "SetTaigaSlackMentionDueDateInput" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "setTaigaSlackMentionDueDate" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "mention" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{ kind: "Field", name: { kind: "Name", value: "id" } },
											{
												kind: "Field",
												name: { kind: "Name", value: "dueDate" },
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	SetSlackMentionDueDateMutation,
	SetSlackMentionDueDateMutationVariables
>
export const PriorityUpSlackMentionDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "PriorityUpSlackMention" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "PriorityUpTaigaSlackMentionInput" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "priorityUpTaigaSlackMention" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "mention" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{ kind: "Field", name: { kind: "Name", value: "id" } },
											{
												kind: "Field",
												name: { kind: "Name", value: "priority" },
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	PriorityUpSlackMentionMutation,
	PriorityUpSlackMentionMutationVariables
>
export const PriorityDownSlackMentionDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "PriorityDownSlackMention" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "PriorityDownTaigaSlackMentionInput",
							},
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "priorityDownTaigaSlackMention" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "mention" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{ kind: "Field", name: { kind: "Name", value: "id" } },
											{
												kind: "Field",
												name: { kind: "Name", value: "priority" },
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	PriorityDownSlackMentionMutation,
	PriorityDownSlackMentionMutationVariables
>
export const UpdateSlackMentionCommentDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "UpdateSlackMentionComment" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "UpdateTaigaSlackMentionCommentInput",
							},
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "updateTaigaSlackMentionComment" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "mention" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{ kind: "Field", name: { kind: "Name", value: "id" } },
											{
												kind: "Field",
												name: { kind: "Name", value: "comment" },
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	UpdateSlackMentionCommentMutation,
	UpdateSlackMentionCommentMutationVariables
>
export const SyncTaigaSlackMentionsDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "SyncTaigaSlackMentions" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "SyncTaigaSlackMentionsInput" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "syncTaigaSlackMentions" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "upsertedCount" },
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	SyncTaigaSlackMentionsMutation,
	SyncTaigaSlackMentionsMutationVariables
>
export const CreateTaigaSlackMentionDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "CreateTaigaSlackMention" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "CreateTaigaSlackMentionInput" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "createTaigaSlackMention" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "mention" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{ kind: "Field", name: { kind: "Name", value: "id" } },
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	CreateTaigaSlackMentionMutation,
	CreateTaigaSlackMentionMutationVariables
>
export const CreateTaigaNodeUnderSlackMentionDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "CreateTaigaNodeUnderSlackMention" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "CreateTaigaNodeUnderSlackMentionInput",
							},
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "createTaigaNodeUnderSlackMention" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "node" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{ kind: "Field", name: { kind: "Name", value: "id" } },
											{
												kind: "Field",
												name: { kind: "Name", value: "milestoneId" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "parentNodeId" },
											},
											{ kind: "Field", name: { kind: "Name", value: "name" } },
											{
												kind: "Field",
												name: { kind: "Name", value: "isArchived" },
											},
											{ kind: "Field", name: { kind: "Name", value: "order" } },
											{
												kind: "Field",
												name: { kind: "Name", value: "isDone" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "isCollapsed" },
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	CreateTaigaNodeUnderSlackMentionMutation,
	CreateTaigaNodeUnderSlackMentionMutationVariables
>
export const HandOverTaigaEmbedSessionDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "HandOverTaigaEmbedSession" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "HandOverTaigaEmbedSessionInput" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "handOverTaigaEmbedSession" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "node" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{ kind: "Field", name: { kind: "Name", value: "id" } },
											{
												kind: "Field",
												name: { kind: "Name", value: "milestoneId" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "parentNodeId" },
											},
											{ kind: "Field", name: { kind: "Name", value: "name" } },
											{
												kind: "Field",
												name: { kind: "Name", value: "isArchived" },
											},
											{ kind: "Field", name: { kind: "Name", value: "order" } },
											{
												kind: "Field",
												name: { kind: "Name", value: "isDone" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "isCollapsed" },
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	HandOverTaigaEmbedSessionMutation,
	HandOverTaigaEmbedSessionMutationVariables
>
export const ToggleTaigaSlackMentionChildNodesCollapsedDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: {
				kind: "Name",
				value: "ToggleTaigaSlackMentionChildNodesCollapsed",
			},
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "ToggleTaigaSlackMentionChildNodesCollapsedInput",
							},
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "toggleTaigaSlackMentionChildNodesCollapsed",
						},
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "mention" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{ kind: "Field", name: { kind: "Name", value: "id" } },
											{
												kind: "Field",
												name: { kind: "Name", value: "isChildNodesCollapsed" },
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	ToggleTaigaSlackMentionChildNodesCollapsedMutation,
	ToggleTaigaSlackMentionChildNodesCollapsedMutationVariables
>
export const UpdateTaigaNodeForMentionDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "UpdateTaigaNodeForMention" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "UpdateTaigaNodeInput" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "updateTaigaNode" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "node" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{ kind: "Field", name: { kind: "Name", value: "id" } },
											{ kind: "Field", name: { kind: "Name", value: "name" } },
											{
												kind: "Field",
												name: { kind: "Name", value: "isCollapsed" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "isDone" },
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	UpdateTaigaNodeForMentionMutation,
	UpdateTaigaNodeForMentionMutationVariables
>
export const ArchiveTaigaNodeForMentionDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "ArchiveTaigaNodeForMention" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "ArchiveTaigaNodeInput" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "archiveTaigaNode" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "node" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{ kind: "Field", name: { kind: "Name", value: "id" } },
											{
												kind: "Field",
												name: { kind: "Name", value: "isArchived" },
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	ArchiveTaigaNodeForMentionMutation,
	ArchiveTaigaNodeForMentionMutationVariables
>
export const CreateTaigaNodeForMentionDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "CreateTaigaNodeForMention" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "CreateTaigaNodeInput" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "createTaigaNode" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "node" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{ kind: "Field", name: { kind: "Name", value: "id" } },
											{
												kind: "Field",
												name: { kind: "Name", value: "milestoneId" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "parentNodeId" },
											},
											{ kind: "Field", name: { kind: "Name", value: "name" } },
											{
												kind: "Field",
												name: { kind: "Name", value: "isArchived" },
											},
											{ kind: "Field", name: { kind: "Name", value: "order" } },
											{
												kind: "Field",
												name: { kind: "Name", value: "isDone" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "isCollapsed" },
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	CreateTaigaNodeForMentionMutation,
	CreateTaigaNodeForMentionMutationVariables
>
export const PriorityUpTaigaNodeForMentionDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "PriorityUpTaigaNodeForMention" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "PriorityUpTaigaNodeInput" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "priorityUpTaigaNode" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "updatedNodes" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{ kind: "Field", name: { kind: "Name", value: "id" } },
											{
												kind: "Field",
												name: { kind: "Name", value: "parallelPriority" },
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	PriorityUpTaigaNodeForMentionMutation,
	PriorityUpTaigaNodeForMentionMutationVariables
>
export const PriorityDownTaigaNodeForMentionDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "PriorityDownTaigaNodeForMention" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "PriorityDownTaigaNodeInput" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "priorityDownTaigaNode" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "updatedNodes" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{ kind: "Field", name: { kind: "Name", value: "id" } },
											{
												kind: "Field",
												name: { kind: "Name", value: "parallelPriority" },
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	PriorityDownTaigaNodeForMentionMutation,
	PriorityDownTaigaNodeForMentionMutationVariables
>
export const CreateTaigaSessionForMentionDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "CreateTaigaSessionForMention" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "CreateTaigaSessionInput" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "createTaigaSession" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "node" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{ kind: "Field", name: { kind: "Name", value: "id" } },
											{
												kind: "Field",
												name: { kind: "Name", value: "isDone" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "session" },
												selectionSet: {
													kind: "SelectionSet",
													selections: [
														{
															kind: "Field",
															name: { kind: "Name", value: "threadTs" },
														},
														{
															kind: "Field",
															name: { kind: "Name", value: "channelId" },
														},
														{
															kind: "Field",
															name: { kind: "Name", value: "sessionStatus" },
														},
														{
															kind: "Field",
															name: { kind: "Name", value: "memo" },
														},
														{
															kind: "Field",
															name: { kind: "Name", value: "ccSessionId" },
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "claudeRemoteControlSessionId",
															},
														},
													],
												},
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	CreateTaigaSessionForMentionMutation,
	CreateTaigaSessionForMentionMutationVariables
>
export const CompleteTaigaSessionForMentionDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "CompleteTaigaSessionForMention" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "CompleteTaigaSessionInput" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "completeTaigaSession" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "node" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{ kind: "Field", name: { kind: "Name", value: "id" } },
											{
												kind: "Field",
												name: { kind: "Name", value: "isDone" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "session" },
												selectionSet: {
													kind: "SelectionSet",
													selections: [
														{
															kind: "Field",
															name: { kind: "Name", value: "threadTs" },
														},
														{
															kind: "Field",
															name: { kind: "Name", value: "channelId" },
														},
														{
															kind: "Field",
															name: { kind: "Name", value: "sessionStatus" },
														},
														{
															kind: "Field",
															name: { kind: "Name", value: "memo" },
														},
														{
															kind: "Field",
															name: { kind: "Name", value: "ccSessionId" },
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "claudeRemoteControlSessionId",
															},
														},
													],
												},
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	CompleteTaigaSessionForMentionMutation,
	CompleteTaigaSessionForMentionMutationVariables
>
export const ForkTaigaSessionForMentionDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "ForkTaigaSessionForMention" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "ForkTaigaSessionInput" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "forkTaigaSession" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "node" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{ kind: "Field", name: { kind: "Name", value: "id" } },
											{
												kind: "Field",
												name: { kind: "Name", value: "isDone" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "session" },
												selectionSet: {
													kind: "SelectionSet",
													selections: [
														{
															kind: "Field",
															name: { kind: "Name", value: "threadTs" },
														},
														{
															kind: "Field",
															name: { kind: "Name", value: "channelId" },
														},
														{
															kind: "Field",
															name: { kind: "Name", value: "sessionStatus" },
														},
														{
															kind: "Field",
															name: { kind: "Name", value: "memo" },
														},
														{
															kind: "Field",
															name: { kind: "Name", value: "ccSessionId" },
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "claudeRemoteControlSessionId",
															},
														},
													],
												},
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	ForkTaigaSessionForMentionMutation,
	ForkTaigaSessionForMentionMutationVariables
>
export const UpdateTaigaSessionStatusForMentionDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "UpdateTaigaSessionStatusForMention" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "UpdateTaigaSessionStatusInput" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "updateTaigaSessionStatus" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "node" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{ kind: "Field", name: { kind: "Name", value: "id" } },
											{
												kind: "Field",
												name: { kind: "Name", value: "isDone" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "session" },
												selectionSet: {
													kind: "SelectionSet",
													selections: [
														{
															kind: "Field",
															name: { kind: "Name", value: "threadTs" },
														},
														{
															kind: "Field",
															name: { kind: "Name", value: "channelId" },
														},
														{
															kind: "Field",
															name: { kind: "Name", value: "sessionStatus" },
														},
														{
															kind: "Field",
															name: { kind: "Name", value: "memo" },
														},
														{
															kind: "Field",
															name: { kind: "Name", value: "ccSessionId" },
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "claudeRemoteControlSessionId",
															},
														},
													],
												},
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	UpdateTaigaSessionStatusForMentionMutation,
	UpdateTaigaSessionStatusForMentionMutationVariables
>
export const UpdateTaigaSessionMemoForMentionDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "UpdateTaigaSessionMemoForMention" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "UpdateTaigaSessionMemoInput" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "updateTaigaSessionMemo" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "node" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{ kind: "Field", name: { kind: "Name", value: "id" } },
											{
												kind: "Field",
												name: { kind: "Name", value: "isDone" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "session" },
												selectionSet: {
													kind: "SelectionSet",
													selections: [
														{
															kind: "Field",
															name: { kind: "Name", value: "threadTs" },
														},
														{
															kind: "Field",
															name: { kind: "Name", value: "channelId" },
														},
														{
															kind: "Field",
															name: { kind: "Name", value: "sessionStatus" },
														},
														{
															kind: "Field",
															name: { kind: "Name", value: "memo" },
														},
														{
															kind: "Field",
															name: { kind: "Name", value: "ccSessionId" },
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "claudeRemoteControlSessionId",
															},
														},
													],
												},
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	UpdateTaigaSessionMemoForMentionMutation,
	UpdateTaigaSessionMemoForMentionMutationVariables
>
export const MoveTaigaNodeForMentionDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "MoveTaigaNodeForMention" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "MoveTaigaNodeInput" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "moveTaigaNode" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "node" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{ kind: "Field", name: { kind: "Name", value: "id" } },
											{
												kind: "Field",
												name: { kind: "Name", value: "milestoneId" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "parentNodeId" },
											},
											{ kind: "Field", name: { kind: "Name", value: "order" } },
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	MoveTaigaNodeForMentionMutation,
	MoveTaigaNodeForMentionMutationVariables
>
export const ReorderTaigaNodesForMentionDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "ReorderTaigaNodesForMention" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "ReorderTaigaNodesInput" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "reorderTaigaNodes" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "nodes" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{ kind: "Field", name: { kind: "Name", value: "id" } },
											{ kind: "Field", name: { kind: "Name", value: "order" } },
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	ReorderTaigaNodesForMentionMutation,
	ReorderTaigaNodesForMentionMutationVariables
>
export const AttachTaigaSlackThreadForMentionDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "AttachTaigaSlackThreadForMention" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "AttachTaigaSlackThreadInput" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "attachTaigaSlackThread" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "node" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{ kind: "Field", name: { kind: "Name", value: "id" } },
											{
												kind: "Field",
												name: { kind: "Name", value: "isDone" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "session" },
												selectionSet: {
													kind: "SelectionSet",
													selections: [
														{
															kind: "Field",
															name: { kind: "Name", value: "threadTs" },
														},
														{
															kind: "Field",
															name: { kind: "Name", value: "channelId" },
														},
														{
															kind: "Field",
															name: { kind: "Name", value: "sessionStatus" },
														},
														{
															kind: "Field",
															name: { kind: "Name", value: "memo" },
														},
														{
															kind: "Field",
															name: { kind: "Name", value: "ccSessionId" },
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "claudeRemoteControlSessionId",
															},
														},
													],
												},
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	AttachTaigaSlackThreadForMentionMutation,
	AttachTaigaSlackThreadForMentionMutationVariables
>
export const GetLatestThreadTsForMentionDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "GetLatestThreadTsForMention" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "param" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "TaigaLatestThreadTsParam" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "taigaLatestThreadTs" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "param" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "param" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "ts" } },
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	GetLatestThreadTsForMentionQuery,
	GetLatestThreadTsForMentionQueryVariables
>
export const GetSlackLatestReplyTsDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "GetSlackLatestReplyTs" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "param" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "SlackLatestReplyTsParam" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "slackLatestReplyTs" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "param" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "param" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "ts" } },
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	GetSlackLatestReplyTsQuery,
	GetSlackLatestReplyTsQueryVariables
>
export const GetSessionBranchNameForMentionDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "GetSessionBranchNameForMention" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "param" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "TaigaSessionBranchNameParam" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "taigaSessionBranchName" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "param" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "param" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "branchName" } },
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	GetSessionBranchNameForMentionQuery,
	GetSessionBranchNameForMentionQueryVariables
>
export const GetSessionStatusesDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "GetSessionStatuses" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "param" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "TaigaSessionStatusesParam" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "taigaSessionStatuses" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "param" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "param" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "sessions" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: { kind: "Name", value: "nodeId" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "isDone" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "session" },
												selectionSet: {
													kind: "SelectionSet",
													selections: [
														{
															kind: "Field",
															name: { kind: "Name", value: "threadTs" },
														},
														{
															kind: "Field",
															name: { kind: "Name", value: "channelId" },
														},
														{
															kind: "Field",
															name: { kind: "Name", value: "sessionStatus" },
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "isRemoteControlEnabled",
															},
														},
														{
															kind: "Field",
															name: { kind: "Name", value: "memo" },
														},
														{
															kind: "Field",
															name: { kind: "Name", value: "ccSessionId" },
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "claudeRemoteControlSessionId",
															},
														},
													],
												},
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	GetSessionStatusesQuery,
	GetSessionStatusesQueryVariables
>
export const UnknownIssueLogsDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "UnknownIssueLogs" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "param" },
					},
					type: {
						kind: "NamedType",
						name: { kind: "Name", value: "UnknownIssueLogsParam" },
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "unknownIssueLogs" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "param" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "param" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "totalCount" } },
								{
									kind: "Field",
									name: { kind: "Name", value: "logs" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{ kind: "Field", name: { kind: "Name", value: "time" } },
											{ kind: "Field", name: { kind: "Name", value: "reqId" } },
											{ kind: "Field", name: { kind: "Name", value: "level" } },
											{
												kind: "Field",
												name: { kind: "Name", value: "message" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "moduleName" },
											},
											{ kind: "Field", name: { kind: "Name", value: "kind" } },
											{
												kind: "Field",
												name: { kind: "Name", value: "salonId" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "opensearchUrl" },
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	UnknownIssueLogsQuery,
	UnknownIssueLogsQueryVariables
>
export const HideUnknownIssueLogsDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "HideUnknownIssueLogs" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "HideUnknownIssueLogsInput" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "hideUnknownIssueLogs" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "hiddenCount" } },
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	HideUnknownIssueLogsMutation,
	HideUnknownIssueLogsMutationVariables
>
export const GetCancelTypeTextsDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "getCancelTypeTexts" },
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "cancelTypeTexts" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "cancelType" } },
								{ kind: "Field", name: { kind: "Name", value: "text" } },
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	GetCancelTypeTextsQuery,
	GetCancelTypeTextsQueryVariables
>
export const GetCurrentCompanyIdForCompanyAdminDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "GetCurrentCompanyIdForCompanyAdmin" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "param" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "CompanyBySalonIdParam" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "companyBySalonId" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "param" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "param" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "company" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{ kind: "Field", name: { kind: "Name", value: "id" } },
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	GetCurrentCompanyIdForCompanyAdminQuery,
	GetCurrentCompanyIdForCompanyAdminQueryVariables
>
